import { FormattedMessage as Ge, useIntl as Pt } from "react-intl";
import * as u from "react";
import ee, { useState as $t, useEffect as yn, startTransition as yr, forwardRef as fs, createElement as an, createContext as Gl, useContext as Zl, useLayoutEffect as Ul, useMemo as Kl } from "react";
import * as Sn from "react-dom";
import ps from "react-dom";
var Un, Sr;
function Yl() {
  if (Sr) return Un;
  Sr = 1;
  const e = Object.freeze({
    EN: "en-US",
    CS: "cs-CZ",
    DE: "de-DE",
    PL: "pl-PL",
    ES: "es-ES",
    RU: "ru-RU"
  }), t = Object.entries(e).reduce((o, [r, a]) => (o[r] = a.split("-")[0], o), {}), n = t.EN;
  return Un = {
    locales: e,
    languages: t,
    defaultLocale: n
  }, Un;
}
var Ct = Yl();
const Xl = {}, ql = {}, Jl = {}, Ql = {}, ec = {}, tc = {};
Ct.languages.EN + "", Ct.languages.CS + "", Ct.languages.DE + "", Ct.languages.PL + "", Ct.languages.ES + "", Ct.languages.RU + "";
const nc = {
  sm: "--breakpoint-sm",
  md: "--breakpoint-md",
  lg: "--breakpoint-lg",
  xl: "--breakpoint-xl",
  "2xl": "--breakpoint-2xl",
  "3xl": "--breakpoint-3xl",
  "4xl": "--breakpoint-4xl"
};
function ms(e) {
  return parseInt(window.getComputedStyle(document.body).getPropertyValue(nc[e]));
}
function Kn(e) {
  return typeof window > "u" ? !1 : window.innerWidth < ms(e);
}
function hs(e, { resolveOnFirstRender: t = !1 } = {}) {
  const [n, o] = $t(() => t ? Kn(e) : !1);
  return yn(() => {
    const r = window.matchMedia(`(max-width: ${ms(e) - 1}px)`), a = () => yr(() => o(Kn(e)));
    return r.addEventListener("change", a), yr(() => o(Kn(e))), () => r.removeEventListener("change", a);
  }, [e]), n;
}
const oc = () => {
  const [e, t] = $t(!1);
  return yn(() => {
    const n = () => {
      t(window.scrollY > 0);
    };
    return window.addEventListener("scroll", n), () => {
      window.removeEventListener("scroll", n);
    };
  }, []), e;
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
var rc = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const he = (e, t, n, o) => {
  const r = fs(
    ({ color: a = "currentColor", size: i = 24, stroke: l = 2, title: c, className: d, children: f, ...m }, g) => an(
      "svg",
      {
        ref: g,
        ...rc[e],
        width: i,
        height: i,
        className: ["tabler-icon", `tabler-icon-${t}`, d].join(" "),
        ...e === "filled" ? {
          fill: a
        } : {
          strokeWidth: l,
          stroke: a
        },
        ...m
      },
      [
        c && an("title", { key: "svg-title" }, c),
        ...o.map(([x, b]) => an(x, b)),
        ...Array.isArray(f) ? f : [f]
      ]
    )
  );
  return r.displayName = `${n}`, r;
};
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sc = [["path", { d: "M12 9v4", key: "svg-0" }], ["path", { d: "M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0", key: "svg-1" }], ["path", { d: "M12 16h.01", key: "svg-2" }]], o4 = he("outline", "alert-triangle", "AlertTriangle", sc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ac = [["path", { d: "M5 12l14 0", key: "svg-0" }], ["path", { d: "M13 18l6 -6", key: "svg-1" }], ["path", { d: "M13 6l6 6", key: "svg-2" }]], gs = he("outline", "arrow-right", "ArrowRight", ac);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ic = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M5.7 5.7l12.6 12.6", key: "svg-1" }]], r4 = he("outline", "ban", "Ban", ic);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lc = [["path", { d: "M5 12l5 5l10 -10", key: "svg-0" }]], cc = he("outline", "check", "Check", lc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uc = [["path", { d: "M6 9l6 6l6 -6", key: "svg-0" }]], tt = he("outline", "chevron-down", "ChevronDown", uc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dc = [["path", { d: "M6 15l6 -6l6 6", key: "svg-0" }]], fc = he("outline", "chevron-up", "ChevronUp", dc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pc = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }], ["path", { d: "M9 12l2 2l4 -4", key: "svg-1" }]], s4 = he("outline", "circle-check", "CircleCheck", pc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const mc = [["path", { d: "M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667l0 -8.666", key: "svg-0" }], ["path", { d: "M4.012 16.737a2.005 2.005 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1", key: "svg-1" }]], a4 = he("outline", "copy", "Copy", mc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hc = [["path", { d: "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2", key: "svg-0" }], ["path", { d: "M12 3v3m0 12v3", key: "svg-1" }]], gc = he("outline", "currency-dollar", "CurrencyDollar", hc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vc = [["path", { d: "M17.2 7a6 7 0 1 0 0 10", key: "svg-0" }], ["path", { d: "M13 10h-8m0 4h8", key: "svg-1" }]], xc = he("outline", "currency-euro", "CurrencyEuro", vc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cc = [["path", { d: "M14 3v4a1 1 0 0 0 1 1h4", key: "svg-0" }], ["path", { d: "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4", key: "svg-1" }], ["path", { d: "M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6", key: "svg-2" }], ["path", { d: "M17 18h2", key: "svg-3" }], ["path", { d: "M20 15h-3v6", key: "svg-4" }], ["path", { d: "M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1", key: "svg-5" }]], i4 = he("outline", "file-type-pdf", "FileTypePdf", Cc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bc = [["path", { d: "M4 6h16", key: "svg-0" }], ["path", { d: "M7 12h13", key: "svg-1" }], ["path", { d: "M10 18h10", key: "svg-2" }]], wc = he("outline", "menu-deep", "MenuDeep", bc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yc = [["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }], ["path", { d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2", key: "svg-1" }]], Sc = he("outline", "user", "User", yc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ec = [["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }], ["path", { d: "M3.6 9h16.8", key: "svg-1" }], ["path", { d: "M3.6 15h16.8", key: "svg-2" }], ["path", { d: "M11.5 3a17 17 0 0 0 0 18", key: "svg-3" }], ["path", { d: "M12.5 3a17 17 0 0 1 0 18", key: "svg-4" }]], vs = he("outline", "world", "World", Ec);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Rc = [["path", { d: "M18 6l-12 12", key: "svg-0" }], ["path", { d: "M6 6l12 12", key: "svg-1" }]], jc = he("outline", "x", "X", Rc);
/**
 * @license @tabler/icons-react v3.46.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mc = [["path", { d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z", key: "svg-0" }]], l4 = he("filled", "info-circle-filled", "InfoCircleFilled", Mc);
var Kt = { exports: {} }, It = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Er;
function Pc() {
  if (Er) return It;
  Er = 1;
  var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(l, c, d) {
    var f, m = {}, g = null, x = null;
    d !== void 0 && (g = "" + d), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (x = c.ref);
    for (f in c) o.call(c, f) && !a.hasOwnProperty(f) && (m[f] = c[f]);
    if (l && l.defaultProps) for (f in c = l.defaultProps, c) m[f] === void 0 && (m[f] = c[f]);
    return { $$typeof: t, type: l, key: g, ref: x, props: m, _owner: r.current };
  }
  return It.Fragment = n, It.jsx = i, It.jsxs = i, It;
}
var Ot = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Rr;
function Nc() {
  return Rr || (Rr = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = ee, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), l = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), f = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), b = Symbol.iterator, p = "@@iterator";
    function v(h) {
      if (h === null || typeof h != "object")
        return null;
      var N = b && h[b] || h[p];
      return typeof N == "function" ? N : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(h) {
      {
        for (var N = arguments.length, A = new Array(N > 1 ? N - 1 : 0), H = 1; H < N; H++)
          A[H - 1] = arguments[H];
        y("error", h, A);
      }
    }
    function y(h, N, A) {
      {
        var H = w.ReactDebugCurrentFrame, oe = H.getStackAddendum();
        oe !== "" && (N += "%s", A = A.concat([oe]));
        var re = A.map(function(J) {
          return String(J);
        });
        re.unshift("Warning: " + N), Function.prototype.apply.call(console[h], console, re);
      }
    }
    var S = !1, E = !1, j = !1, M = !1, R = !1, _;
    _ = Symbol.for("react.module.reference");
    function L(h) {
      return !!(typeof h == "string" || typeof h == "function" || h === o || h === a || R || h === r || h === d || h === f || M || h === x || S || E || j || typeof h == "object" && h !== null && (h.$$typeof === g || h.$$typeof === m || h.$$typeof === i || h.$$typeof === l || h.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      h.$$typeof === _ || h.getModuleId !== void 0));
    }
    function B(h, N, A) {
      var H = h.displayName;
      if (H)
        return H;
      var oe = N.displayName || N.name || "";
      return oe !== "" ? A + "(" + oe + ")" : A;
    }
    function X(h) {
      return h.displayName || "Context";
    }
    function $(h) {
      if (h == null)
        return null;
      if (typeof h.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof h == "function")
        return h.displayName || h.name || null;
      if (typeof h == "string")
        return h;
      switch (h) {
        case o:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case r:
          return "StrictMode";
        case d:
          return "Suspense";
        case f:
          return "SuspenseList";
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case l:
            var N = h;
            return X(N) + ".Consumer";
          case i:
            var A = h;
            return X(A._context) + ".Provider";
          case c:
            return B(h, h.render, "ForwardRef");
          case m:
            var H = h.displayName || null;
            return H !== null ? H : $(h.type) || "Memo";
          case g: {
            var oe = h, re = oe._payload, J = oe._init;
            try {
              return $(J(re));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var z = Object.assign, G = 0, D, Z, P, te, de, ge, Re;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function ce() {
      {
        if (G === 0) {
          D = console.log, Z = console.info, P = console.warn, te = console.error, de = console.group, ge = console.groupCollapsed, Re = console.groupEnd;
          var h = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: h,
            log: h,
            warn: h,
            error: h,
            group: h,
            groupCollapsed: h,
            groupEnd: h
          });
        }
        G++;
      }
    }
    function Se() {
      {
        if (G--, G === 0) {
          var h = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: z({}, h, {
              value: D
            }),
            info: z({}, h, {
              value: Z
            }),
            warn: z({}, h, {
              value: P
            }),
            error: z({}, h, {
              value: te
            }),
            group: z({}, h, {
              value: de
            }),
            groupCollapsed: z({}, h, {
              value: ge
            }),
            groupEnd: z({}, h, {
              value: Re
            })
          });
        }
        G < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var be = w.ReactCurrentDispatcher, k;
    function Q(h, N, A) {
      {
        if (k === void 0)
          try {
            throw Error();
          } catch (oe) {
            var H = oe.stack.trim().match(/\n( *(at )?)/);
            k = H && H[1] || "";
          }
        return `
` + k + h;
      }
    }
    var ae = !1, U;
    {
      var q = typeof WeakMap == "function" ? WeakMap : Map;
      U = new q();
    }
    function K(h, N) {
      if (!h || ae)
        return "";
      {
        var A = U.get(h);
        if (A !== void 0)
          return A;
      }
      var H;
      ae = !0;
      var oe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var re;
      re = be.current, be.current = null, ce();
      try {
        if (N) {
          var J = function() {
            throw Error();
          };
          if (Object.defineProperty(J.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(J, []);
            } catch (we) {
              H = we;
            }
            Reflect.construct(h, [], J);
          } else {
            try {
              J.call();
            } catch (we) {
              H = we;
            }
            h.call(J.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (we) {
            H = we;
          }
          h();
        }
      } catch (we) {
        if (we && H && typeof we.stack == "string") {
          for (var Y = we.stack.split(`
`), xe = H.stack.split(`
`), ue = Y.length - 1, fe = xe.length - 1; ue >= 1 && fe >= 0 && Y[ue] !== xe[fe]; )
            fe--;
          for (; ue >= 1 && fe >= 0; ue--, fe--)
            if (Y[ue] !== xe[fe]) {
              if (ue !== 1 || fe !== 1)
                do
                  if (ue--, fe--, fe < 0 || Y[ue] !== xe[fe]) {
                    var Me = `
` + Y[ue].replace(" at new ", " at ");
                    return h.displayName && Me.includes("<anonymous>") && (Me = Me.replace("<anonymous>", h.displayName)), typeof h == "function" && U.set(h, Me), Me;
                  }
                while (ue >= 1 && fe >= 0);
              break;
            }
        }
      } finally {
        ae = !1, be.current = re, Se(), Error.prepareStackTrace = oe;
      }
      var xt = h ? h.displayName || h.name : "", it = xt ? Q(xt) : "";
      return typeof h == "function" && U.set(h, it), it;
    }
    function ve(h, N, A) {
      return K(h, !1);
    }
    function je(h) {
      var N = h.prototype;
      return !!(N && N.isReactComponent);
    }
    function Ie(h, N, A) {
      if (h == null)
        return "";
      if (typeof h == "function")
        return K(h, je(h));
      if (typeof h == "string")
        return Q(h);
      switch (h) {
        case d:
          return Q("Suspense");
        case f:
          return Q("SuspenseList");
      }
      if (typeof h == "object")
        switch (h.$$typeof) {
          case c:
            return ve(h.render);
          case m:
            return Ie(h.type, N, A);
          case g: {
            var H = h, oe = H._payload, re = H._init;
            try {
              return Ie(re(oe), N, A);
            } catch {
            }
          }
        }
      return "";
    }
    var _e = Object.prototype.hasOwnProperty, Xe = {}, Ut = w.ReactDebugCurrentFrame;
    function ze(h) {
      if (h) {
        var N = h._owner, A = Ie(h.type, h._source, N ? N.type : null);
        Ut.setExtraStackFrame(A);
      } else
        Ut.setExtraStackFrame(null);
    }
    function Sl(h, N, A, H, oe) {
      {
        var re = Function.call.bind(_e);
        for (var J in h)
          if (re(h, J)) {
            var Y = void 0;
            try {
              if (typeof h[J] != "function") {
                var xe = Error((H || "React class") + ": " + A + " type `" + J + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof h[J] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xe.name = "Invariant Violation", xe;
              }
              Y = h[J](N, J, H, A, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ue) {
              Y = ue;
            }
            Y && !(Y instanceof Error) && (ze(oe), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", H || "React class", A, J, typeof Y), ze(null)), Y instanceof Error && !(Y.message in Xe) && (Xe[Y.message] = !0, ze(oe), C("Failed %s type: %s", A, Y.message), ze(null));
          }
      }
    }
    var El = Array.isArray;
    function Bn(h) {
      return El(h);
    }
    function Rl(h) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, A = N && h[Symbol.toStringTag] || h.constructor.name || "Object";
        return A;
      }
    }
    function jl(h) {
      try {
        return ur(h), !1;
      } catch {
        return !0;
      }
    }
    function ur(h) {
      return "" + h;
    }
    function dr(h) {
      if (jl(h))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Rl(h)), ur(h);
    }
    var fr = w.ReactCurrentOwner, Ml = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pr, mr;
    function Pl(h) {
      if (_e.call(h, "ref")) {
        var N = Object.getOwnPropertyDescriptor(h, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return h.ref !== void 0;
    }
    function Nl(h) {
      if (_e.call(h, "key")) {
        var N = Object.getOwnPropertyDescriptor(h, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return h.key !== void 0;
    }
    function _l(h, N) {
      typeof h.ref == "string" && fr.current;
    }
    function Al(h, N) {
      {
        var A = function() {
          pr || (pr = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        A.isReactWarning = !0, Object.defineProperty(h, "key", {
          get: A,
          configurable: !0
        });
      }
    }
    function kl(h, N) {
      {
        var A = function() {
          mr || (mr = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        A.isReactWarning = !0, Object.defineProperty(h, "ref", {
          get: A,
          configurable: !0
        });
      }
    }
    var Tl = function(h, N, A, H, oe, re, J) {
      var Y = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: h,
        key: N,
        ref: A,
        props: J,
        // Record the component responsible for creating this element.
        _owner: re
      };
      return Y._store = {}, Object.defineProperty(Y._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Y, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: H
      }), Object.defineProperty(Y, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.freeze && (Object.freeze(Y.props), Object.freeze(Y)), Y;
    };
    function Il(h, N, A, H, oe) {
      {
        var re, J = {}, Y = null, xe = null;
        A !== void 0 && (dr(A), Y = "" + A), Nl(N) && (dr(N.key), Y = "" + N.key), Pl(N) && (xe = N.ref, _l(N, oe));
        for (re in N)
          _e.call(N, re) && !Ml.hasOwnProperty(re) && (J[re] = N[re]);
        if (h && h.defaultProps) {
          var ue = h.defaultProps;
          for (re in ue)
            J[re] === void 0 && (J[re] = ue[re]);
        }
        if (Y || xe) {
          var fe = typeof h == "function" ? h.displayName || h.name || "Unknown" : h;
          Y && Al(J, fe), xe && kl(J, fe);
        }
        return Tl(h, Y, xe, oe, H, fr.current, J);
      }
    }
    var zn = w.ReactCurrentOwner, hr = w.ReactDebugCurrentFrame;
    function vt(h) {
      if (h) {
        var N = h._owner, A = Ie(h.type, h._source, N ? N.type : null);
        hr.setExtraStackFrame(A);
      } else
        hr.setExtraStackFrame(null);
    }
    var Wn;
    Wn = !1;
    function Gn(h) {
      return typeof h == "object" && h !== null && h.$$typeof === t;
    }
    function gr() {
      {
        if (zn.current) {
          var h = $(zn.current.type);
          if (h)
            return `

Check the render method of \`` + h + "`.";
        }
        return "";
      }
    }
    function Ol(h) {
      return "";
    }
    var vr = {};
    function Ll(h) {
      {
        var N = gr();
        if (!N) {
          var A = typeof h == "string" ? h : h.displayName || h.name;
          A && (N = `

Check the top-level render call using <` + A + ">.");
        }
        return N;
      }
    }
    function xr(h, N) {
      {
        if (!h._store || h._store.validated || h.key != null)
          return;
        h._store.validated = !0;
        var A = Ll(N);
        if (vr[A])
          return;
        vr[A] = !0;
        var H = "";
        h && h._owner && h._owner !== zn.current && (H = " It was passed a child from " + $(h._owner.type) + "."), vt(h), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', A, H), vt(null);
      }
    }
    function Cr(h, N) {
      {
        if (typeof h != "object")
          return;
        if (Bn(h))
          for (var A = 0; A < h.length; A++) {
            var H = h[A];
            Gn(H) && xr(H, N);
          }
        else if (Gn(h))
          h._store && (h._store.validated = !0);
        else if (h) {
          var oe = v(h);
          if (typeof oe == "function" && oe !== h.entries)
            for (var re = oe.call(h), J; !(J = re.next()).done; )
              Gn(J.value) && xr(J.value, N);
        }
      }
    }
    function Dl(h) {
      {
        var N = h.type;
        if (N == null || typeof N == "string")
          return;
        var A;
        if (typeof N == "function")
          A = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === m))
          A = N.propTypes;
        else
          return;
        if (A) {
          var H = $(N);
          Sl(A, h.props, "prop", H, h);
        } else if (N.PropTypes !== void 0 && !Wn) {
          Wn = !0;
          var oe = $(N);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", oe || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Fl(h) {
      {
        for (var N = Object.keys(h.props), A = 0; A < N.length; A++) {
          var H = N[A];
          if (H !== "children" && H !== "key") {
            vt(h), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", H), vt(null);
            break;
          }
        }
        h.ref !== null && (vt(h), C("Invalid attribute `ref` supplied to `React.Fragment`."), vt(null));
      }
    }
    var br = {};
    function wr(h, N, A, H, oe, re) {
      {
        var J = L(h);
        if (!J) {
          var Y = "";
          (h === void 0 || typeof h == "object" && h !== null && Object.keys(h).length === 0) && (Y += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xe = Ol();
          xe ? Y += xe : Y += gr();
          var ue;
          h === null ? ue = "null" : Bn(h) ? ue = "array" : h !== void 0 && h.$$typeof === t ? (ue = "<" + ($(h.type) || "Unknown") + " />", Y = " Did you accidentally export a JSX literal instead of a component?") : ue = typeof h, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ue, Y);
        }
        var fe = Il(h, N, A, oe, re);
        if (fe == null)
          return fe;
        if (J) {
          var Me = N.children;
          if (Me !== void 0)
            if (H)
              if (Bn(Me)) {
                for (var xt = 0; xt < Me.length; xt++)
                  Cr(Me[xt], h);
                Object.freeze && Object.freeze(Me);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cr(Me, h);
        }
        if (_e.call(N, "key")) {
          var it = $(h), we = Object.keys(N).filter(function(Wl) {
            return Wl !== "key";
          }), Zn = we.length > 0 ? "{key: someKey, " + we.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!br[it + Zn]) {
            var zl = we.length > 0 ? "{" + we.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Zn, it, zl, it), br[it + Zn] = !0;
          }
        }
        return h === o ? Fl(fe) : Dl(fe), fe;
      }
    }
    function Vl(h, N, A) {
      return wr(h, N, A, !0);
    }
    function Hl(h, N, A) {
      return wr(h, N, A, !1);
    }
    var $l = Hl, Bl = Vl;
    Ot.Fragment = o, Ot.jsx = $l, Ot.jsxs = Bl;
  })()), Ot;
}
var jr;
function _c() {
  return jr || (jr = 1, process.env.NODE_ENV === "production" ? Kt.exports = Pc() : Kt.exports = Nc()), Kt.exports;
}
var s = _c();
const c4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 36 37", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M27.4621 18.8818C27.512 24.2603 32.1804 26.0501 32.2321 26.0729C32.1926 26.1991 31.4862 28.6235 29.7726 31.1278C28.2912 33.2929 26.7538 35.45 24.3319 35.4946C21.9522 35.5385 21.1869 34.0835 18.4662 34.0835C15.7463 34.0835 14.8961 35.45 12.6434 35.5386C10.3056 35.6271 8.52539 33.1974 7.03182 31.0402C3.97974 26.6277 1.64732 18.5715 4.77917 13.1334C6.335 10.4329 9.1154 8.72278 12.1333 8.67893C14.4289 8.63514 16.5956 10.2233 17.999 10.2233C19.4015 10.2233 22.0345 8.31339 24.8026 8.59389C25.9614 8.64212 29.2143 9.06198 31.303 12.1193C31.1347 12.2237 27.4217 14.3852 27.4621 18.8818ZM22.9896 5.67464C24.2307 4.1723 25.066 2.08092 24.8382 0C23.0492 0.0719024 20.8859 1.19213 19.6027 2.69364C18.4527 4.0233 17.4455 6.15149 17.7173 8.19122C19.7113 8.3455 21.7484 7.17793 22.9896 5.67464Z",
    fill: "black"
  }
) }), u4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 46 46", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28639)", children: [
    /* @__PURE__ */ s.jsx("mask", { id: "mask0_11981_28639", maskUnits: "userSpaceOnUse", x: 0, y: 12, width: 46, height: 21, children: /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M45.3211 12.2374L0.00976562 12.2374L0.00976562 32.9461L45.3211 32.9461V12.2374Z",
        fill: "white"
      }
    ) }),
    /* @__PURE__ */ s.jsxs("g", { mask: "url(#mask0_11981_28639)", children: [
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M36.3782 21.2233C36.2263 21.2233 36.0765 21.2288 35.9267 21.2336C35.9024 21.235 35.8786 21.2405 35.8562 21.2502C35.7757 21.2776 35.7144 21.3438 35.6933 21.4263L35.0512 23.6691C34.7744 24.6335 34.8772 25.5241 35.3426 26.1778C35.7693 26.7826 36.479 27.1374 37.3407 27.1788L40.8239 27.39C40.9274 27.3956 41.0172 27.4453 41.0718 27.5274C41.1296 27.6163 41.1427 27.7272 41.107 27.827C41.0497 27.9907 40.902 28.1057 40.7293 28.1211L37.1101 28.3323C35.1437 28.4235 33.0283 30.0278 32.2861 31.9843L32.0251 32.6746C32.0023 32.7326 32.0089 32.7981 32.0429 32.8504C32.0769 32.9028 32.134 32.9355 32.1963 32.9383L44.6613 32.9383C44.8102 32.9389 44.9413 32.8401 44.9816 32.6966C45.203 31.901 45.3144 31.0788 45.3131 30.2529C45.3131 25.2687 41.3162 21.2288 36.3838 21.2288",
          fill: "#FBAD41"
        }
      ),
      /* @__PURE__ */ s.jsx(
        "path",
        {
          d: "M30.9457 32.6562L31.1763 31.845C31.4538 30.8806 31.351 29.9901 30.8863 29.3363C30.4583 28.7316 29.7492 28.3768 28.8869 28.3354L12.5479 28.1241C12.4448 28.1223 12.3489 28.0712 12.2897 27.9867C12.2316 27.898 12.2183 27.7871 12.2538 27.6871C12.3116 27.5224 12.4609 27.4072 12.6349 27.3931L29.1264 27.1818C31.0845 27.0914 33.2 25.4864 33.9422 23.5299L34.8825 21.0447C34.9204 20.9394 34.9304 20.8257 34.9101 20.7155C33.8386 15.8679 29.5524 12.2374 24.4281 12.2374C19.7042 12.2374 15.6962 15.3177 14.2581 19.5998C13.2898 18.8636 12.0772 18.5244 10.8674 18.6513C8.60283 18.8792 6.7801 20.7237 6.55499 23.0129C6.49672 23.5846 6.53877 24.1621 6.67928 24.7194C2.9786 24.8299 0.00976562 27.8935 0.00976562 31.6586C0.00976562 31.999 0.0339306 32.3345 0.0829507 32.6617C0.103137 32.8205 0.238379 32.9394 0.398476 32.9392L30.5729 32.9392C30.7474 32.9363 30.8992 32.8189 30.9457 32.6506",
          fill: "#F6821F"
        }
      )
    ] })
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28639", children: /* @__PURE__ */ s.jsx("rect", { width: 45.3113, height: 45.3113, fill: "white" }) }) })
] }), d4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 47 47", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("path", { d: "M43.7255 2.57275L2.57227 2.57275L2.57227 43.726H43.7255V2.57275Z", fill: "#0061FE" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.167 15.8254L16.2993 20.209L23.167 24.5926L16.2993 28.9762L9.43164 24.556L16.2993 20.1724L9.43164 15.8254L16.2993 11.4418L23.167 15.8254ZM16.2628 30.3644L23.1304 25.9807L29.9981 30.3644L23.1304 34.748L16.2628 30.3644ZM23.167 24.556L30.0346 20.1724L23.167 15.8254L29.9981 11.4418L36.8657 15.8254L29.9981 20.209L36.8657 24.5926L29.9981 28.9762L23.167 24.556Z",
      fill: "#F6F3F0"
    }
  )
] }), f4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 72 72", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.6074 35.8701C35.6074 30.0004 40.3658 25.2418 46.2357 25.2418C52.1054 25.2418 56.8639 30.0004 56.8639 35.8701C56.8639 41.7401 52.1054 46.4984 46.2357 46.4984C40.3658 46.4984 35.6074 41.7401 35.6074 35.8701Z",
      fill: "#1ABCFE"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 57.127C14.3477 51.2573 19.1061 46.4987 24.9759 46.4987H35.604V57.127C35.604 62.9969 30.8457 67.7553 24.9759 67.7553C19.1061 67.7553 14.3477 62.9969 14.3477 57.127Z",
      fill: "#0ACF83"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.6074 3.9856V25.2421H46.2357C52.1055 25.2421 56.8639 20.4838 56.8639 14.6139C56.8639 8.74404 52.1055 3.9856 46.2357 3.9856H35.6074Z",
      fill: "#FF7262"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 14.6139C14.3477 20.4838 19.1061 25.2421 24.9759 25.2421H35.604V3.9856L24.9759 3.9856C19.1061 3.9856 14.3477 8.74404 14.3477 14.6139Z",
      fill: "#F24E1E"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M14.3477 35.8701C14.3477 41.7401 19.1061 46.4984 24.9759 46.4984H35.604V25.2418H24.9759C19.1061 25.2418 14.3477 30.0004 14.3477 35.8701Z",
      fill: "#A259FF"
    }
  )
] }), p4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 38 38", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5006 2.4137C9.35354 2.4137 1.95898 9.86264 1.95898 19.078C1.95898 26.4444 6.69694 32.6798 13.2697 34.8867C14.0915 35.0527 14.3925 34.5282 14.3925 34.087C14.3925 33.7007 14.3654 32.3764 14.3654 30.9967C9.76388 31.9901 8.80567 29.0102 8.80567 29.0102C8.0662 27.0789 6.97048 26.5825 6.97048 26.5825C5.46443 25.5617 7.08019 25.5617 7.08019 25.5617C8.75083 25.672 9.62746 27.2722 9.62746 27.2722C11.1061 29.8103 13.4888 29.0931 14.4473 28.6516C14.5841 27.5756 15.0226 26.8307 15.4882 26.4169C11.8181 26.0306 7.95682 24.596 7.95682 18.195C7.95682 16.3741 8.61371 14.8843 9.65455 13.7256C9.49034 13.3118 8.91504 11.601 9.81909 9.31111C9.81909 9.31111 11.2158 8.86958 14.365 11.0217C15.7134 10.6569 17.1039 10.4713 18.5006 10.4697C19.8973 10.4697 21.3211 10.6631 22.6359 11.0217C25.7855 8.86958 27.1821 9.31111 27.1821 9.31111C28.0862 11.601 27.5106 13.3118 27.3464 13.7256C28.4147 14.8843 29.0444 16.3741 29.0444 18.195C29.0444 24.596 25.1831 26.0029 21.4857 26.4169C22.0884 26.9411 22.6084 27.9341 22.6084 29.5069C22.6084 31.7416 22.5814 33.5351 22.5814 34.0866C22.5814 34.5282 22.8827 35.0527 23.7041 34.8871C30.2769 32.6795 35.0148 26.4444 35.0148 19.078C35.0419 9.86264 27.6203 2.4137 18.5006 2.4137Z",
    fill: "#24292F"
  }
) }), m4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 66 66", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28666)", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M61.8146 33.536C61.8146 31.0667 61.6142 29.2648 61.1806 27.3962H32.9844V38.5411H49.5349C49.2014 41.3108 47.3995 45.4818 43.3952 48.2846L43.3391 48.6577L52.2542 55.5642L52.8719 55.6258C58.5444 50.3869 61.8146 42.6788 61.8146 33.536Z",
        fill: "#4285F4"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M32.9747 62.9002C41.0831 62.9002 47.8901 60.2307 52.8622 55.626L43.3855 48.2848C40.8496 50.0533 37.4459 51.2879 32.9747 51.2879C25.0331 51.2879 18.2927 46.0493 15.89 38.8083L15.5378 38.8383L6.26771 46.0125L6.14648 46.3495C11.0849 56.1597 21.2289 62.9002 32.9747 62.9002Z",
        fill: "#34A853"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M15.8999 38.8083C15.2659 36.9397 14.899 34.9374 14.899 32.8687C14.899 30.7997 15.2659 28.7977 15.8665 26.9291L15.8498 26.5311L6.46351 19.2417L6.15641 19.3878C4.12103 23.4588 2.95313 28.0303 2.95313 32.8687C2.95313 37.7071 4.12103 42.2784 6.15641 46.3494L15.8999 38.8083Z",
        fill: "#FBBC05"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M32.9747 14.4494C38.6138 14.4494 42.4178 16.8853 44.5868 18.9209L53.0623 10.6455C47.857 5.80707 41.0831 2.83728 32.9747 2.83728C21.2289 2.83728 11.0849 9.57763 6.14648 19.3878L15.8566 26.9292C18.2927 19.6883 25.0331 14.4494 32.9747 14.4494Z",
        fill: "#EB4335"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28666", children: /* @__PURE__ */ s.jsx("rect", { width: 60.27, height: 60.27, fill: "white", transform: "translate(2.26562 2.83704)" }) }) })
] }), h4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 39 39", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M35.2153 18.2859L20.4843 3.55466L19.0679 2.13818L8.01963 13.1866L2.96765 18.2388C2.44828 18.7581 2.44828 19.608 2.96765 20.1746L13.0717 30.2787L19.0679 36.3223L30.1161 25.2738L30.305 25.085L35.2153 20.1746C35.7348 19.6551 35.7348 18.8054 35.2153 18.2859ZM19.0679 24.2823L14.016 19.2302L19.0679 14.1781L24.1199 19.2302L19.0679 24.2823Z",
      fill: "#2684FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M19.0584 14.1781C15.7534 10.873 15.7534 5.49041 19.0112 2.1853L7.96289 13.2338L13.9592 19.2302L19.0584 14.1781Z",
      fill: "url(#paint0_linear_11981_28647)"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M24.1184 19.2288L19.0664 24.2809C22.3714 27.5859 22.3714 32.9685 19.0664 36.3208L30.1618 25.2251L24.1184 19.2288Z",
      fill: "url(#paint1_linear_11981_28647)"
    }
  ),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint0_linear_11981_28647",
        x1: 18.1572,
        y1: 9.05962,
        x2: 11.1016,
        y2: 16.1151,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { offset: 0.176, stopColor: "#0052CC" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#2684FF" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "linearGradient",
      {
        id: "paint1_linear_11981_28647",
        x1: 20.0327,
        y1: 29.3262,
        x2: 27.0742,
        y2: 22.2849,
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ s.jsx("stop", { offset: 0.176, stopColor: "#0052CC" }),
          /* @__PURE__ */ s.jsx("stop", { offset: 1, stopColor: "#2684FF" })
        ]
      }
    )
  ] })
] }), g4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "-1.94 -9.28 64.2 64.2", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M10.6018 45.1V42.1C10.6018 40.95 9.90178 40.2 8.70178 40.2C8.10178 40.2 7.45178 40.4 7.00178 41.05C6.65178 40.5 6.15178 40.2 5.40178 40.2C4.90178 40.2 4.40178 40.35 4.00178 40.9V40.3H2.95179V45.1H4.00178V42.45C4.00178 41.6 4.45178 41.2 5.15178 41.2C5.85178 41.2 6.20178 41.65 6.20178 42.45V45.1H7.25178V42.45C7.25178 41.6 7.75178 41.2 8.40178 41.2C9.10178 41.2 9.45178 41.65 9.45178 42.45V45.1H10.6018ZM26.1518 40.3H24.4518V38.85H23.4018V40.3H22.4518V41.25H23.4018V43.45C23.4018 44.55 23.8518 45.2 25.0518 45.2C25.5018 45.2 26.0018 45.05 26.3518 44.85L26.0518 43.95C25.7518 44.15 25.4018 44.2 25.1518 44.2C24.6518 44.2 24.4518 43.9 24.4518 43.4V41.25H26.1518V40.3ZM35.0518 40.2C34.4518 40.2 34.0518 40.5 33.8018 40.9V40.3H32.7518V45.1H33.8018V42.4C33.8018 41.6 34.1518 41.15 34.8018 41.15C35.0018 41.15 35.2518 41.2 35.4518 41.25L35.7518 40.25C35.5518 40.2 35.2518 40.2 35.0518 40.2ZM21.6018 40.7C21.1018 40.35 20.4018 40.2 19.6518 40.2C18.4518 40.2 17.6518 40.8 17.6518 41.75C17.6518 42.55 18.2518 43 19.3018 43.15L19.8018 43.2C20.3518 43.3 20.6518 43.45 20.6518 43.7C20.6518 44.05 20.2518 44.3 19.5518 44.3C18.8518 44.3 18.3018 44.05 17.9518 43.8L17.4518 44.6C18.0018 45 18.7518 45.2 19.5018 45.2C20.9018 45.2 21.7018 44.55 21.7018 43.65C21.7018 42.8 21.0518 42.35 20.0518 42.2L19.5518 42.15C19.1018 42.1 18.7518 42 18.7518 41.7C18.7518 41.35 19.1018 41.15 19.6518 41.15C20.2518 41.15 20.8518 41.4 21.1518 41.55L21.6018 40.7ZM49.5017 40.2C48.9017 40.2 48.5017 40.5 48.2517 40.9V40.3H47.2017V45.1H48.2517V42.4C48.2517 41.6 48.6017 41.15 49.2517 41.15C49.4517 41.15 49.7017 41.2 49.9017 41.25L50.2017 40.25C50.0017 40.2 49.7017 40.2 49.5017 40.2ZM36.1018 42.7C36.1018 44.15 37.1018 45.2 38.6518 45.2C39.3518 45.2 39.8518 45.05 40.3518 44.65L39.8518 43.8C39.4518 44.1 39.0518 44.25 38.6018 44.25C37.7518 44.25 37.1518 43.65 37.1518 42.7C37.1518 41.8 37.7518 41.2 38.6018 41.15C39.0518 41.15 39.4518 41.3 39.8518 41.6L40.3518 40.75C39.8518 40.35 39.3518 40.2 38.6518 40.2C37.1018 40.2 36.1018 41.25 36.1018 42.7ZM45.8017 42.7V40.3H44.7517V40.9C44.4017 40.45 43.9017 40.2 43.2517 40.2C41.9018 40.2 40.8518 41.25 40.8518 42.7C40.8518 44.15 41.9018 45.2 43.2517 45.2C43.9517 45.2 44.4517 44.95 44.7517 44.5V45.1H45.8017V42.7ZM41.9518 42.7C41.9518 41.85 42.5017 41.15 43.4017 41.15C44.2517 41.15 44.8517 41.8 44.8517 42.7C44.8517 43.55 44.2517 44.25 43.4017 44.25C42.5017 44.2 41.9518 43.55 41.9518 42.7ZM29.4018 40.2C28.0018 40.2 27.0018 41.2 27.0018 42.7C27.0018 44.2 28.0018 45.2 29.4518 45.2C30.1518 45.2 30.8518 45 31.4018 44.55L30.9018 43.8C30.5018 44.1 30.0018 44.3 29.5018 44.3C28.8518 44.3 28.2018 44 28.0518 43.15H31.6018V42.75C31.6518 41.2 30.7518 40.2 29.4018 40.2ZM29.4018 41.1C30.0518 41.1 30.5018 41.5 30.6018 42.25H28.1018C28.2018 41.6 28.6518 41.1 29.4018 41.1ZM55.4517 42.7V38.4H54.4017V40.9C54.0517 40.45 53.5517 40.2 52.9017 40.2C51.5517 40.2 50.5017 41.25 50.5017 42.7C50.5017 44.15 51.5517 45.2 52.9017 45.2C53.6017 45.2 54.1017 44.95 54.4017 44.5V45.1H55.4517V42.7ZM51.6017 42.7C51.6017 41.85 52.1517 41.15 53.0517 41.15C53.9017 41.15 54.5017 41.8 54.5017 42.7C54.5017 43.55 53.9017 44.25 53.0517 44.25C52.1517 44.2 51.6017 43.55 51.6017 42.7ZM16.5018 42.7V40.3H15.4518V40.9C15.1018 40.45 14.6018 40.2 13.9518 40.2C12.6018 40.2 11.5518 41.25 11.5518 42.7C11.5518 44.15 12.6018 45.2 13.9518 45.2C14.6518 45.2 15.1518 44.95 15.4518 44.5V45.1H16.5018V42.7ZM12.6018 42.7C12.6018 41.85 13.1518 41.15 14.0518 41.15C14.9018 41.15 15.5018 41.8 15.5018 42.7C15.5018 43.55 14.9018 44.25 14.0518 44.25C13.1518 44.2 12.6018 43.55 12.6018 42.7Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ s.jsx("path", { d: "M37.0028 3.85008H21.2528V32.1501H37.0028V3.85008Z", fill: "#FF5F00" }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M22.25 18C22.25 12.25 24.95 7.15 29.1 3.85C26.05 1.45 22.2 2.86102e-06 18 2.86102e-06C8.04999 2.86102e-06 0 8.05 0 18C0 27.95 8.04999 36 18 36C22.2 36 26.05 34.55 29.1 32.15C24.95 28.9 22.25 23.75 22.25 18Z",
      fill: "#EB001B"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M58.2538 18C58.2538 27.95 50.2038 36 40.2538 36C36.0538 36 32.2038 34.55 29.1538 32.15C33.3538 28.85 36.0038 23.75 36.0038 18C36.0038 12.25 33.3038 7.14999 29.1538 3.85C32.2038 1.45 36.0538 0 40.2538 0C50.2038 0 58.2538 8.09999 58.2538 18Z",
      fill: "#F79E1B"
    }
  )
] }), v4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 59 59", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("path", { d: "M27.8332 27.8285H3.5V3.49976H27.8332V27.8285Z", fill: "#F1511B" }),
  /* @__PURE__ */ s.jsx("path", { d: "M54.698 27.8285H30.3652V3.49976H54.698V27.8285Z", fill: "#80CC28" }),
  /* @__PURE__ */ s.jsx("path", { d: "M27.8325 54.6998H3.5V30.3712H27.8325V54.6998Z", fill: "#00ADEF" }),
  /* @__PURE__ */ s.jsx("path", { d: "M54.698 54.6998H30.3652V30.3712H54.698V54.6998Z", fill: "#FBBC09" })
] }), x4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 31 31", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("g", { filter: "url(#filter0_i_11981_28655)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M21.7677 28.3357C21.8344 28.3624 22.4754 28.6224 22.5674 28.6599C22.5699 28.6608 22.5753 28.6629 22.5818 28.6656C22.5925 28.6698 22.5882 28.668 22.5934 28.6701C22.6044 28.6746 22.6081 28.6761 22.612 28.6776C22.6121 28.4762 22.6122 28.1778 22.6122 27.8588C22.6122 27.4505 22.6122 27.0174 22.6122 26.8022V1.68481H17.3105V15.7336C17.4728 16.1923 18.1593 18.1388 18.335 18.629C18.6633 19.564 20.5316 24.8409 20.681 25.2629C20.8149 25.6417 21.1878 26.6947 21.3064 27.0315C21.3757 27.2266 21.5566 27.7369 21.6527 28.0089C21.7279 28.2217 21.7211 28.2043 21.7677 28.3357Z",
      fill: "#B11F24"
    }
  ) }),
  /* @__PURE__ */ s.jsx("g", { filter: "url(#filter1_i_11981_28655)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M8.61596 2.02679C8.54925 1.99993 7.90832 1.74016 7.81631 1.70273C7.81381 1.70171 7.80838 1.69949 7.80187 1.69685C7.79124 1.69265 7.79542 1.69445 7.79033 1.69238C7.77926 1.68794 7.77558 1.6864 7.77167 1.68481C7.7716 1.88631 7.7715 2.18468 7.7715 2.50376C7.77147 2.91183 7.7715 3.34512 7.7715 3.56043V28.6778C9.8775 28.4248 10.9307 28.3263 13.0732 28.2287V14.6289C12.9109 14.1703 12.2244 12.2237 12.0487 11.7335C11.7204 10.7986 9.85209 5.5217 9.70271 5.09956C9.56883 4.72077 9.19588 3.66786 9.07734 3.33089C9.00804 3.13597 8.82708 2.62577 8.73095 2.35367C8.65581 2.14092 8.66259 2.15838 8.61596 2.02679Z",
      fill: "#B11F24"
    }
  ) }),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M13.0712 1.68518H7.76953L17.1575 28.2292C19.7957 28.2959 22.6179 28.6783 22.6179 28.6783L13.0712 1.68518Z",
      fill: "#ED1C24"
    }
  ),
  /* @__PURE__ */ s.jsxs("defs", { children: [
    /* @__PURE__ */ s.jsxs(
      "filter",
      {
        id: "filter0_i_11981_28655",
        x: 17.3105,
        y: -0.59276,
        width: 5.30078,
        height: 29.2704,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ s.jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
          /* @__PURE__ */ s.jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ s.jsx("feOffset", { dy: -3.79596 }),
          /* @__PURE__ */ s.jsx("feGaussianBlur", { stdDeviation: 1.13879 }),
          /* @__PURE__ */ s.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }),
          /* @__PURE__ */ s.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_11981_28655" })
        ]
      }
    ),
    /* @__PURE__ */ s.jsxs(
      "filter",
      {
        id: "filter1_i_11981_28655",
        x: 7.77148,
        y: 1.68481,
        width: 5.30078,
        height: 29.2705,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ s.jsx("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
          /* @__PURE__ */ s.jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ s.jsx("feOffset", { dy: 3.79596 }),
          /* @__PURE__ */ s.jsx("feGaussianBlur", { stdDeviation: 1.13879 }),
          /* @__PURE__ */ s.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: -1, k3: 1 }),
          /* @__PURE__ */ s.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
          /* @__PURE__ */ s.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_11981_28655" })
        ]
      }
    )
  ] })
] }), C4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 28 28", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M3.63597 2.60737L17.2984 1.60123C18.9761 1.45732 19.4078 1.55372 20.4623 2.31977L24.8236 5.38513C25.5432 5.91226 25.783 6.05577 25.783 6.63038L25.783 23.4428C25.783 24.4965 25.3992 25.1196 24.0572 25.2149L8.19116 26.173C7.18384 26.2211 6.70438 26.0775 6.17685 25.4066L2.96519 21.2394C2.38971 20.4724 2.15039 19.8985 2.15039 19.2272L2.15039 4.28317C2.15039 3.42151 2.53431 2.70279 3.63597 2.60737Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.2984 1.60123L3.63597 2.60737C2.53431 2.70279 2.15039 3.42151 2.15039 4.28317L2.15039 19.2272C2.15039 19.8985 2.38971 20.4724 2.96519 21.2394L6.17685 25.4066C6.70438 26.0775 7.18384 26.2211 8.19116 26.173L24.0572 25.2149C25.3992 25.1196 25.783 24.4965 25.783 23.4428L25.783 6.63038C25.783 6.08573 25.5675 5.9284 24.9322 5.46458C24.8972 5.43905 24.8611 5.4126 24.8236 5.38513L20.4623 2.31977C19.4078 1.55372 18.9761 1.45732 17.2984 1.60123ZM8.55091 6.35461C7.25553 6.4421 6.96118 6.46196 6.22557 5.86434L4.35489 4.37956C4.16411 4.18755 4.2598 3.94806 4.73882 3.90054L17.8737 2.9425C18.9759 2.84649 19.5511 3.2303 19.9827 3.56542L22.2356 5.19411C22.3314 5.24181 22.5707 5.52882 22.283 5.52882L8.7181 6.34337C8.66104 6.34719 8.6057 6.35091 8.55209 6.35455L8.55091 6.35461ZM7.03999 23.2988L7.03999 9.02575C7.03999 8.40319 7.23176 8.11559 7.80668 8.06727L23.3855 7.15751C23.9138 7.10962 24.1531 7.44514 24.1531 8.06727L24.1531 22.2446C24.1531 22.8677 24.057 23.3954 23.1939 23.4428L8.28607 24.3054C7.42333 24.3528 7.03999 24.0659 7.03999 23.2988ZM21.7569 9.79136C21.8525 10.2229 21.7569 10.654 21.3247 10.7025L20.6064 10.8456L20.6064 21.3829C19.9827 21.7182 19.4077 21.9097 18.9284 21.9097C18.1612 21.9097 17.969 21.6701 17.3943 20.952L12.6959 13.5758L12.6959 20.7125L14.1826 21.048C14.1826 21.048 14.1826 21.9097 12.9831 21.9097L9.67637 22.1016C9.58029 21.9097 9.67637 21.4312 10.0118 21.3353L10.8747 21.0961L10.8747 11.6602L9.67656 11.5641C9.58047 11.1326 9.81979 10.5105 10.4914 10.4622L14.0388 10.2231L18.9284 17.6953L18.9284 11.0851L17.6817 10.942C17.586 10.4145 17.969 10.0314 18.4484 9.98399L21.7569 9.79136Z",
      fill: "#000008"
    }
  )
] }), b4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 56 56", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M45.2165 26.3545C44.1976 32.1631 39.4576 36.5551 33.2408 36.5551H29.2921C28.4864 36.5532 27.6763 37.3004 27.5423 38.1213L25.8114 49.0948C25.7126 49.7181 25.4195 49.9257 24.7867 49.9257H18.4416C17.8007 49.9257 17.6479 49.7118 17.7479 49.0784L18.4675 41.4938L10.8449 41.0994C10.2033 41.0994 9.96242 40.7434 10.0631 40.11L15.2634 7.13216C15.3622 6.50755 15.7515 6.23901 16.383 6.23901H29.572C35.9215 6.23901 39.9375 10.5128 40.4307 16.054C44.214 18.6113 45.9795 22.0046 45.2165 26.3545Z",
      fill: "#001C64"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.4024 29.2079L17.2493 49.2027C17.1494 49.836 17.6387 50.409 18.2796 50.409H24.9858C25.6179 50.409 26.1557 49.9492 26.2544 49.3247L28.0206 38.1221C28.1193 37.4976 28.6571 37.0378 29.2899 37.0378H33.2379C39.4554 37.0378 44.7312 32.5017 45.6954 26.3555C46.3798 21.993 44.1834 18.0236 40.4284 16.0549C40.419 16.5115 40.3793 16.9738 40.3064 17.4418C39.3422 23.588 34.0663 28.1235 27.8489 28.1235H21.671C21.0389 28.1235 20.5006 28.5833 20.4024 29.2079Z",
      fill: "#0070E0"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M18.4661 41.4945H10.663C10.0215 41.4945 9.53212 40.9216 9.63216 40.2882L14.8941 6.92222C14.9922 6.29829 15.5307 5.8385 16.1628 5.8385H29.5713C35.9202 5.8385 40.5375 10.4589 40.4294 16.0548C38.8493 15.2264 36.9938 14.7522 34.9598 14.7522H23.781C23.1488 14.7522 22.6111 15.212 22.5123 15.8366L18.4661 41.4945Z",
      fill: "#003087"
    }
  )
] }), w4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "-4.09 -4.11 71.74 71.74", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M13.4013 40.1488C13.4013 43.8401 10.4179 46.8234 6.72666 46.8234C3.03539 46.8234 0.0520371 43.8401 0.0520371 40.1488C0.0520371 36.4575 3.03539 33.4742 6.72666 33.4742H13.4013V40.1488ZM16.7386 40.1488C16.7386 36.4575 19.7219 33.4742 23.4132 33.4742C27.1045 33.4742 30.0878 36.4575 30.0878 40.1488V56.8353C30.0878 60.5266 27.1045 63.51 23.4132 63.51C19.7219 63.51 16.7386 60.5266 16.7386 56.8353V40.1488Z",
      fill: "#E01E5A"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M23.4117 13.3492C19.7205 13.3492 16.7371 10.3659 16.7371 6.67462C16.7371 2.98335 19.7205 0 23.4117 0C27.103 0 30.0864 2.98335 30.0864 6.67462V13.3492H23.4117ZM23.4117 16.7371C27.103 16.7371 30.0864 19.7205 30.0864 23.4117C30.0864 27.103 27.103 30.0864 23.4117 30.0864H6.67462C2.98335 30.0864 0 27.103 0 23.4117C0 19.7205 2.98335 16.7371 6.67462 16.7371H23.4117Z",
      fill: "#36C5F0"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M50.1603 23.4117C50.1603 19.7205 53.1436 16.7371 56.8349 16.7371C60.5262 16.7371 63.5095 19.7205 63.5095 23.4117C63.5095 27.103 60.5262 30.0864 56.8349 30.0864H50.1603V23.4117ZM46.823 23.4117C46.823 27.103 43.8396 30.0864 40.1484 30.0864C36.4571 30.0864 33.4737 27.103 33.4737 23.4117V6.67462C33.4737 2.98335 36.4571 0 40.1484 0C43.8396 0 46.823 2.98335 46.823 6.67462V23.4117Z",
      fill: "#2EB67D"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M40.1484 50.1607C43.8396 50.1607 46.823 53.1441 46.823 56.8353C46.823 60.5266 43.8396 63.51 40.1484 63.51C36.4571 63.51 33.4737 60.5266 33.4737 56.8353V50.1607H40.1484ZM40.1484 46.8234C36.4571 46.8234 33.4737 43.8401 33.4737 40.1488C33.4737 36.4575 36.4571 33.4742 40.1484 33.4742H56.8855C60.5767 33.4742 63.5601 36.4575 63.5601 40.1488C63.5601 43.8401 60.5767 46.8234 56.8855 46.8234H40.1484Z",
      fill: "#ECB22E"
    }
  )
] }), y4 = (e) => /* @__PURE__ */ s.jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", ...e, children: /* @__PURE__ */ s.jsx(
  "path",
  {
    d: "M23.985 14.1419C19.4789 11.4658 12.046 11.2198 7.74433 12.5255C7.05358 12.735 6.32307 12.345 6.11376 11.6543C5.90443 10.9632 6.29402 10.2332 6.98529 10.0232C11.9233 8.5242 20.1321 8.81381 25.3196 11.8931C25.9409 12.2619 26.1448 13.0643 25.7765 13.6846C25.4079 14.3059 24.6048 14.5108 23.985 14.1419ZM23.8375 18.1054C23.5213 18.6184 22.8506 18.7793 22.3382 18.4643C18.5815 16.1552 12.8529 15.4863 8.40837 16.8353C7.83198 17.0096 7.22318 16.6845 7.04823 16.1093C6.87444 15.5329 7.19963 14.9253 7.77487 14.75C12.8522 13.2094 19.164 13.9556 23.4789 16.6071C23.9912 16.9226 24.1524 17.5938 23.8375 18.1054ZM22.1269 21.9119C21.8757 22.3239 21.3393 22.4529 20.9288 22.2019C17.646 20.1955 13.5141 19.7425 8.64808 20.8539C8.17918 20.9614 7.71193 20.6676 7.60496 20.1987C7.4976 19.73 7.79025 19.2626 8.2603 19.1556C13.5852 17.9383 18.1531 18.4622 21.8378 20.7137C22.2486 20.9646 22.378 21.5013 22.1269 21.9119ZM15.7158 1.74902C7.99522 1.74902 1.73633 8.00771 1.73633 15.728C1.73633 23.4492 7.99522 29.7074 15.7158 29.7074C23.4365 29.7074 29.695 23.4492 29.695 15.728C29.695 8.00771 23.4365 1.74902 15.7158 1.74902Z",
    fill: "#1ED760"
  }
) }), S4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 28 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28603)", children: [
    /* @__PURE__ */ s.jsx("mask", { id: "mask0_11981_28603", maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 28, height: 32, children: /* @__PURE__ */ s.jsx("path", { d: "M0.00195312 0H27.0789V32H0.00195312V0Z", fill: "white" }) }),
    /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_11981_28603)", children: /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.00195312 28.6622H27.0789V32.0037H0.00221432L0.00195312 28.6622Z",
        fill: "#FF322E"
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.23506 7.54572L1.68359 21.486H4.97898L8.07044 11.6325L9.61992 16.5588H7.61553L6.81507 19.3709H10.5044L11.1697 21.486H14.5592L10.0083 7.54572H6.23506Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7313 7.54572H15V21.486H18.2719V10.3579H19.5903C21.12 10.3579 21.9911 11.1028 21.9911 12.4488C21.9911 13.7708 21.12 14.5399 19.5903 14.5399H19.3785V17.352H19.7313C23.262 17.352 25.3334 15.5372 25.3334 12.4488C25.3334 9.30025 23.262 7.54572 19.7313 7.54572Z",
        fill: "black"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28603", children: /* @__PURE__ */ s.jsx("rect", { width: 27.0769, height: 32, fill: "white" }) }) })
] }), E4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 133 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx("g", { clipPath: "url(#clip0_11981_28600)", children: /* @__PURE__ */ s.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 10.24H4.77009C7.42327 10.24 8.81058 11.6117 8.81058 13.2963C8.81058 14.4592 8.15481 15.249 7.24548 15.6668V15.6969C8.40837 16.1147 9.06414 17.0386 9.06414 18.216C9.06414 19.9006 7.76718 21.3763 4.96439 21.3763H0V10.24ZM4.62145 14.6525C5.41128 14.6525 5.76977 14.2503 5.76977 13.8025C5.76977 13.3546 5.41225 12.9378 4.62145 12.9378H3.22054V14.6525H4.62145ZM4.66614 18.6775C5.50066 18.6775 5.90383 18.2753 5.90383 17.7536C5.90383 17.2319 5.48609 16.8297 4.68168 16.8297H3.22054V18.6785H4.66614V18.6775ZM9.74905 16.8443V10.24H12.9987V16.8141C12.9987 18.0518 13.6098 18.7076 14.6532 18.7076C15.6966 18.7076 16.3524 18.0518 16.3524 16.7996V10.24H19.6176V16.8443C19.6176 19.647 17.7397 21.66 14.6532 21.66C11.5667 21.66 9.74808 19.647 9.74808 16.8443H9.74905ZM27.8919 10.7762V13.6383C27.1914 13.1467 25.9984 12.8038 25.0299 12.8038C24.1506 12.8038 23.7028 13.0874 23.7028 13.4595C23.7028 13.8316 24.1944 14.0259 25.0745 14.3387C26.5658 14.8604 28.5924 15.5609 28.5924 17.9314C28.5924 20.0483 26.9971 21.6134 24.1944 21.6134C22.7488 21.6134 21.4217 21.1956 20.6017 20.6448V17.6331C21.4071 18.2889 22.6293 18.8106 23.8067 18.8106C24.8054 18.8106 25.2679 18.4375 25.2679 18.0207C25.2679 17.4845 24.5072 17.2455 23.5978 16.9171C22.4048 16.4848 20.5124 15.7095 20.5124 13.5479C20.5124 11.5952 22.0483 10 24.7909 10C25.9984 10 27.0865 10.3128 27.8919 10.7753V10.7762ZM29.4269 10.24H32.6766V21.3763H29.4269V10.24ZM44.2307 21.3763H41.1296L37.1193 15.3987H37.1047V21.3763H34.0192V10.24H37.1202L41.1306 16.1137H41.1452V10.24H44.2307V21.3763ZM45.5723 10.24H53.2647V13.1321H48.822V14.4738H52.8168V17.0978H48.822V18.4842H53.2647V21.3763H45.5723V10.24ZM61.4195 10.7762V13.6383C60.719 13.1467 59.526 12.8038 58.5574 12.8038C57.6782 12.8038 57.2304 13.0874 57.2304 13.4595C57.2304 13.8316 57.722 14.0259 58.6021 14.3387C60.0934 14.8604 62.12 15.5609 62.12 17.9314C62.12 20.0483 60.5247 21.6134 57.722 21.6134C56.2764 21.6134 54.9493 21.1956 54.1293 20.6448V17.6331C54.9347 18.2889 56.1569 18.8106 57.3343 18.8106C58.333 18.8106 58.7955 18.4375 58.7955 18.0207C58.7955 17.4845 58.0348 17.2455 57.1255 16.9171C55.9324 16.4848 54.04 15.7095 54.04 13.5479C54.04 11.5952 55.5759 10 58.3185 10C59.526 10 60.6141 10.3128 61.4195 10.7753V10.7762ZM70.0212 10.7762V13.6383C69.3207 13.1467 68.1277 12.8038 67.1591 12.8038C66.2799 12.8038 65.8321 13.0874 65.8321 13.4595C65.8321 13.8316 66.3237 14.0259 67.2038 14.3387C68.6951 14.8604 70.7217 15.5609 70.7217 17.9314C70.7217 20.0483 69.1264 21.6134 66.3237 21.6134C64.8781 21.6134 63.551 21.1956 62.731 20.6448V17.6331C63.5364 18.2889 64.7586 18.8106 65.936 18.8106C66.9347 18.8106 67.3972 18.4375 67.3972 18.0207C67.3972 17.4845 66.6365 17.2455 65.7271 16.9171C64.5341 16.4848 62.6417 15.7095 62.6417 13.5479C62.6417 11.5952 64.1776 10 66.9202 10C68.1277 10 69.2158 10.3128 70.0212 10.7753V10.7762ZM74.4872 21.3977H77.7369V10.2623H74.4872V21.3987V21.3977ZM89.2891 10.2623H86.2036V16.136H86.189L82.1786 10.2623H79.0776V21.3987H82.1631V15.421H82.1776L86.188 21.3987H89.2891V10.2623ZM94.5196 10.0233C91.7761 10.0233 90.2411 11.6185 90.2411 13.5713C90.2411 15.7328 92.1346 16.5081 93.3266 16.9404C94.236 17.2688 94.9967 17.5068 94.9967 18.0441C94.9967 18.4618 94.5342 18.8339 93.5355 18.8339C92.358 18.8339 91.1349 18.3122 90.3305 17.6564V20.6681C91.1505 21.2199 92.4775 21.6367 93.9231 21.6367C96.7259 21.6367 98.3211 20.0716 98.3211 17.9547C98.3211 15.5842 96.2936 14.8838 94.8033 14.3621C93.9241 14.0492 93.4315 13.8705 93.4315 13.4828C93.4315 13.0952 93.8784 12.8271 94.7586 12.8271C95.7272 12.8271 96.9202 13.17 97.6207 13.6616V10.7986C96.8153 10.3361 95.7272 10.0233 94.5196 10.0233ZM99.0799 21.3977H102.33V10.2623H99.0799V21.3987V21.3977ZM106.921 18.4608H107.548C109.232 18.4608 110.32 17.5068 110.32 15.8368C110.32 14.1668 109.232 13.1982 107.548 13.1982H106.921V18.4608ZM113.6 15.8368C113.6 19.1914 111.065 21.3977 107.428 21.3977H103.671V10.2623H107.428C111.065 10.2623 113.6 12.4832 113.6 15.8378V15.8368ZM114.481 21.3977H122.174V18.5055H117.731V17.1192H121.726V14.4952H117.731V13.1535H122.174V10.2623H114.481V21.3987V21.3977ZM127.288 15.524C128.108 15.524 128.75 15.1363 128.75 14.3611C128.75 13.5858 128.108 13.1982 127.274 13.1982H126.588V15.524H127.288ZM132.61 21.3977H128.779L126.662 17.9537H126.587V21.3977H123.337V10.2623H127.303C130.091 10.2623 132.028 11.5 132.028 14.1386C132.028 15.182 131.566 16.7024 129.717 17.4777L132.609 21.3987L132.61 21.3977Z",
      fill: "#0A0A0A"
    }
  ) }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28600", children: /* @__PURE__ */ s.jsx("rect", { width: 133, height: 32, fill: "white" }) }) })
] }), R4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 96 32", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_11981_28586)", children: [
    /* @__PURE__ */ s.jsx("path", { d: "M88.4754 21.5191L88.5014 21.5183H88.4492L88.4754 21.5191Z", fill: "#E40784" }),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2857 23.4141C81.6014 23.4139 80.9323 23.2107 80.3635 22.8302C79.7944 22.4498 79.3511 21.9092 79.0895 21.2768C78.8275 20.6444 78.7592 19.9486 78.8928 19.2773C79.0267 18.6061 79.3564 17.9895 79.8403 17.5056C80.3245 17.0217 80.9411 16.6922 81.6123 16.5588C82.2835 16.4253 82.9794 16.4939 83.6116 16.7559C84.2441 17.0178 84.7845 17.4614 85.1648 18.0305C85.545 18.5996 85.748 19.2686 85.748 19.953C85.7473 20.871 85.3824 21.7511 84.733 22.4C84.084 23.049 83.2039 23.4137 82.2857 23.4141ZM82.2857 18.5166C82.0019 18.5171 81.7244 18.6019 81.4884 18.7601C81.2527 18.9183 81.0688 19.1429 80.9604 19.4054C80.8521 19.668 80.824 19.9568 80.8799 20.2353C80.9358 20.5138 81.0728 20.7695 81.2739 20.9702C81.4749 21.1708 81.7309 21.3074 82.0094 21.3625C82.2882 21.4177 82.577 21.3891 82.8392 21.2802C83.1015 21.1714 83.3256 20.9872 83.4833 20.751C83.6413 20.5148 83.7252 20.2371 83.7252 19.9531C83.7246 19.5718 83.5726 19.2065 83.3025 18.9372C83.0328 18.6679 82.6672 18.5166 82.2857 18.5166Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2873 7.80487C81.8075 7.80515 81.3283 7.83349 80.8516 7.88974V10.08C82.2686 9.87385 83.7131 9.97502 85.0874 10.3766C86.4614 10.7782 87.7333 11.4709 88.816 12.4075C89.899 13.3441 90.7675 14.5028 91.3629 15.8049C91.9582 17.1069 92.2664 18.5219 92.2664 19.9536C92.2673 20.4345 92.2323 20.9148 92.1618 21.3904H94.3528C94.5569 19.6855 94.3968 17.9566 93.8835 16.318C93.3703 14.6794 92.5155 13.1683 91.3754 11.8844C90.2349 10.6005 88.8353 9.57304 87.269 8.86983C85.7025 8.16661 84.0044 7.80364 82.2873 7.80487Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M82.2873 12.0686C81.8059 12.0691 81.3252 12.1138 80.8516 12.2021V14.4233C81.6964 14.2039 82.5802 14.1809 83.4353 14.356C84.2904 14.5311 85.094 14.8997 85.7846 15.4335C86.4751 15.9674 87.034 16.6523 87.4189 17.4357C87.8035 18.2192 88.004 19.0803 88.0043 19.9531C88.0036 20.4378 87.9421 20.9206 87.821 21.39H90.042C90.1288 20.9159 90.1725 20.435 90.1728 19.9531C90.1703 17.8626 89.3389 15.8584 87.8603 14.3803C86.3821 12.9021 84.3778 12.0708 82.2873 12.0686Z",
        fill: "#E40784"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M40.9956 12.1082H39.2851C38.3566 12.1092 37.4666 12.4785 36.81 13.135C36.1535 13.7915 35.7845 14.6816 35.7832 15.61V21.5017H38.2143V15.61C38.2146 15.3261 38.3276 15.054 38.5283 14.8533C38.7291 14.6527 39.0013 14.5398 39.2851 14.5396H40.9956V12.1082Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M46.2476 19.0704C45.7974 19.0704 45.3569 18.9369 44.9826 18.6867C44.608 18.4365 44.3161 18.0809 44.1437 17.6648C43.9714 17.2487 43.9261 16.7909 44.0142 16.3491C44.1019 15.9074 44.3186 15.5016 44.637 15.1831C44.9554 14.8646 45.3613 14.6477 45.8031 14.5598C46.2448 14.4719 46.7025 14.517 47.1186 14.6893C47.5348 14.8616 47.8904 15.1535 48.1408 15.5279C48.3911 15.9024 48.5245 16.3426 48.5248 16.793C48.5238 17.3967 48.2838 17.9755 47.857 18.4024C47.4302 18.8294 46.8514 19.0696 46.2476 19.0704ZM46.2476 12.0854C45.5286 12.0845 44.819 12.2482 44.1731 12.564C43.5271 12.8799 42.9621 13.3395 42.5216 13.9076C42.0807 14.4757 41.776 15.1371 41.6306 15.8413C41.4851 16.5454 41.5029 17.2735 41.6824 17.9697C41.8619 18.6659 42.1984 19.3117 42.6664 19.8577C43.1344 20.4036 43.721 20.8351 44.3816 21.1192C45.0422 21.4032 45.759 21.5322 46.4771 21.4962C47.1951 21.4603 47.8954 21.2603 48.5241 20.9117V21.5021H50.9555V16.799V16.793C50.9543 15.5448 50.4579 14.3482 49.5753 13.4656C48.6924 12.5831 47.4958 12.0867 46.2476 12.0854Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M23.3454 18.8336C22.9153 19.3767 22.3268 19.7724 21.6616 19.9658C20.9963 20.1592 20.2874 20.1408 19.6331 19.9131C18.9788 19.6854 18.4117 19.2596 18.0103 18.6949C17.609 18.1303 17.3933 17.4547 17.3933 16.7619C17.3933 16.0691 17.609 15.3935 18.0103 14.8289C18.4117 14.2642 18.9788 13.8385 19.6331 13.6108C20.2874 13.383 20.9963 13.3646 21.6616 13.558C22.3268 13.7515 22.9153 14.1471 23.3454 14.6902L23.3997 14.7579L24.3972 13.7604L24.3512 13.7058C23.7247 12.9633 22.8853 12.4313 21.9464 12.1818C21.0076 11.9324 20.0147 11.9774 19.1024 12.3109C18.1899 12.6444 17.4021 13.2502 16.8454 14.0464C16.2888 14.8425 15.9902 15.7905 15.9902 16.7619C15.9902 17.7334 16.2888 18.6813 16.8454 19.4775C17.4021 20.2736 18.1899 20.8794 19.1024 21.2129C20.0147 21.5464 21.0076 21.5915 21.9464 21.342C22.8853 21.0925 23.7247 20.5605 24.3512 19.8181L24.3972 19.7635L23.3997 18.7659L23.3454 18.8336Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M10.164 12.0229C9.30983 12.0227 8.47153 12.2534 7.73771 12.6904C7.0039 13.1275 6.40186 13.7548 5.99526 14.506C5.58865 15.2571 5.39259 16.1042 5.42787 16.9576C5.46315 17.811 5.72839 18.639 6.19559 19.354C6.66279 20.0691 7.31456 20.6445 8.08194 21.0196C8.84931 21.3946 9.70379 21.5554 10.555 21.4847C11.4062 21.414 12.2225 21.1146 12.9175 20.6181C13.6125 20.1216 14.1604 19.4465 14.5033 18.6642L14.5508 18.5558H12.9756L12.9524 18.5906C12.5919 19.1408 12.0767 19.5722 11.4716 19.8303C10.8666 20.0884 10.1987 20.1618 9.552 20.0412C8.90532 19.9207 8.30872 19.6115 7.83736 19.1526C7.36598 18.6938 7.04086 18.1058 6.9029 17.4625H14.8502L14.8596 17.3956C14.888 17.1853 14.9025 16.9734 14.903 16.7612C14.9014 15.5048 14.4016 14.3004 13.5132 13.4121C12.6248 12.5238 11.4203 12.0242 10.164 12.0229ZM6.90253 16.0605C7.06271 15.3145 7.47381 14.646 8.06723 14.1665C8.66068 13.6869 9.40059 13.4253 10.1636 13.4253C10.9266 13.4253 11.6664 13.6869 12.2599 14.1665C12.8533 14.646 13.2644 15.3145 13.4246 16.0605H6.90253Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M25.7227 21.5014H27.1251V16.1761C27.1241 15.8123 27.1948 15.4518 27.3334 15.1153C27.4719 14.7789 27.6754 14.4731 27.9324 14.2154C28.1893 13.9578 28.4945 13.7534 28.8306 13.6139C29.1666 13.4744 29.5269 13.4026 29.8907 13.4026C30.2547 13.4026 30.615 13.4744 30.9509 13.6139C31.2871 13.7534 31.5921 13.9578 31.8491 14.2154C32.106 14.4731 32.3096 14.7789 32.4482 15.1153C32.5868 15.4518 32.6574 15.8123 32.6564 16.1761V21.501H34.0591V15.9929H34.0541C34.0198 15.206 33.7635 14.4448 33.3142 13.7978C32.865 13.1508 32.2415 12.6444 31.516 12.3375C30.7904 12.0306 29.9929 11.9357 29.2157 12.0639C28.4385 12.1921 27.7136 12.538 27.1251 13.0616V7.89789H25.7227V21.5014Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M0.522928 12.024H-1.09375V13.4264H0.522928V18.5274C0.523817 19.3161 0.837502 20.0722 1.39516 20.6298C1.95282 21.1875 2.70894 21.5012 3.49758 21.502H4.96471V20.0992H3.49758C3.08086 20.0987 2.68134 19.933 2.38669 19.6383C2.09201 19.3436 1.92625 18.9441 1.92576 18.5274V13.4264H4.19602V12.024H1.92576V8.78503H0.522928V12.024Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M59.044 12.6627C58.5669 12.4028 58.0484 12.2281 57.5111 12.1467C57.458 12.1385 57.4049 12.1292 57.3509 12.1225C57.2913 12.1149 57.231 12.1097 57.1708 12.1045C57.0562 12.0948 56.941 12.0884 56.8243 12.0869C56.8121 12.0869 56.7999 12.0854 56.788 12.0854L56.7793 12.0858L56.7671 12.0854C55.5183 12.0854 54.3208 12.5815 53.4379 13.4645C52.5547 14.3475 52.0586 15.5451 52.0586 16.7938C52.0586 18.0425 52.5547 19.2401 53.4379 20.1231C54.3208 21.0061 55.5183 21.5022 56.7671 21.5022C56.7709 21.5022 56.7737 21.5014 56.7774 21.5014C56.7809 21.5014 56.7843 21.5022 56.788 21.5022C56.9391 21.5022 57.0877 21.4924 57.2357 21.4779C57.2426 21.4775 57.2501 21.4764 57.2573 21.476C57.892 21.413 58.507 21.221 59.0649 20.9118V21.5021H61.4944L61.476 7.89789H59.044V12.6627ZM59.044 16.7949C59.0436 17.3985 58.8036 17.9772 58.3765 18.4038C57.9494 18.8304 57.3703 19.0698 56.7668 19.0696C56.1633 19.0694 55.5845 18.8295 55.1578 18.4026C54.731 17.9757 54.4912 17.3968 54.4912 16.7932C54.4912 16.1896 54.731 15.6107 55.1578 15.1839C55.5845 14.757 56.1633 14.517 56.7668 14.5168C57.3703 14.5166 57.9494 14.7561 58.3765 15.1827C58.8036 15.6092 59.0436 16.1879 59.044 16.7915V16.7949Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M69.7473 21.4842H72.1774V16.7822C72.1761 15.7481 71.8349 14.7432 71.2065 13.9221C70.578 13.101 69.697 12.5093 68.6992 12.2382C67.7011 11.967 66.6419 12.0314 65.6844 12.4215C64.7265 12.8115 63.9239 13.5056 63.3994 14.3968C62.8749 15.2879 62.6579 16.3268 62.7822 17.3534C62.9061 18.3799 63.3641 19.3373 64.0859 20.0779C64.8074 20.8185 65.7524 21.3014 66.7755 21.4522C67.7985 21.6029 68.8425 21.4132 69.7473 20.9122V21.4842ZM67.4701 19.0711C67.0199 19.0711 66.5797 18.9376 66.2054 18.6875C65.8311 18.4373 65.5392 18.0818 65.3668 17.6658C65.1945 17.2499 65.1496 16.7922 65.2373 16.3506C65.325 15.909 65.5417 15.5033 65.8601 15.1849C66.1782 14.8664 66.5838 14.6495 67.0255 14.5615C67.467 14.4735 67.9247 14.5184 68.3408 14.6905C68.7567 14.8627 69.1126 15.1543 69.3626 15.5285C69.613 15.9027 69.7469 16.3428 69.7473 16.793V16.7957C69.7463 17.3992 69.5062 17.9778 69.0792 18.4044C68.6524 18.831 68.0736 19.0708 67.4701 19.0711Z",
        fill: "#1E1715"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M77.1831 12.0869C76.2547 12.0882 75.3643 12.4576 74.7077 13.1141C74.0509 13.7706 73.6812 14.6606 73.6797 15.5891V21.5022H76.1139V15.5891C76.1139 15.3054 76.2263 15.0332 76.4267 14.8325C76.6274 14.6316 76.8994 14.5187 77.1831 14.5183H78.8955V12.0869L77.1831 12.0869Z",
        fill: "#1E1715"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_11981_28586", children: /* @__PURE__ */ s.jsx("rect", { width: 96, height: 32, fill: "white" }) }) })
] }), j4 = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 55.71 55.71", fill: "none", ...e, children: [
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M20.2048 28.4925C21.2609 28.4925 22.117 29.3486 22.117 30.4048C22.117 31.4609 21.2609 32.317 20.2048 32.317H7.45619C6.40007 32.317 5.54391 31.4609 5.54391 30.4048C5.54391 29.3486 6.40007 28.4925 7.45619 28.4925H20.2048Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M38.6902 22.7556C38.6902 21.9103 38.3542 21.0999 37.7565 20.5022C37.1588 19.9045 36.3483 19.5685 35.5031 19.5685H29.7662V28.4925H35.5031C36.3483 28.4925 37.1588 28.1564 37.7565 27.5587C38.3542 26.961 38.6902 26.1506 38.6902 25.3053V22.7556ZM42.5148 25.3053C42.5148 27.1649 41.7755 28.9479 40.4606 30.2628C39.1456 31.5778 37.3627 32.317 35.5031 32.317H29.7662V38.0539C29.7662 39.11 28.91 39.9662 27.8539 39.9662C26.7978 39.9662 25.9416 39.11 25.9416 38.0539V17.6562C25.9416 16.6001 26.7978 15.7439 27.8539 15.7439H35.5031C37.3627 15.7439 39.1456 16.4832 40.4606 17.7981C41.7755 19.1131 42.5148 20.896 42.5148 22.7556V25.3053Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M46.3393 38.0539V17.6562C46.3393 16.6001 47.1955 15.7439 48.2516 15.7439C49.3077 15.7439 50.1639 16.6001 50.1639 17.6562V38.0539C50.1639 39.11 49.3077 39.9662 48.2516 39.9662C47.1955 39.9662 46.3393 39.11 46.3393 38.0539Z",
      fill: "#FF00FF"
    }
  ),
  /* @__PURE__ */ s.jsx(
    "path",
    {
      d: "M18.2925 38.0539V24.0305C18.2925 22.8471 17.822 21.7125 16.9853 20.8757C16.1485 20.0389 15.0139 19.5685 13.8305 19.5685C12.6471 19.5685 11.5125 20.0389 10.6757 20.8757C9.83892 21.7125 9.36848 22.8471 9.36848 24.0305V38.0539C9.36848 39.11 8.51232 39.9662 7.45619 39.9662C6.40007 39.9662 5.54391 39.11 5.54391 38.0539V24.0305C5.54391 21.8327 6.41758 19.7256 7.97161 18.1716C9.52565 16.6176 11.6327 15.7439 13.8305 15.7439C16.0282 15.7439 18.1353 16.6176 19.6893 18.1716C21.2434 19.7256 22.117 21.8327 22.117 24.0305V38.0539C22.117 39.11 21.2609 39.9662 20.2048 39.9662C19.1486 39.9662 18.2925 39.11 18.2925 38.0539Z",
      fill: "#FF00FF"
    }
  )
] }), xs = Gl(null), Ac = () => {
  const e = Zl(xs);
  if (!e)
    throw new Error("useLinkComponent must be used within a LinkContextProvider");
  return e;
}, ke = fs(({ scope: e, ...t }, n) => {
  const { LinkComponent: o, scope: r } = Ac();
  return r === e || !e ? /* @__PURE__ */ s.jsx(o, { ...t }) : /* @__PURE__ */ s.jsx("a", { ...t, ref: n });
}), kc = ({ children: e, LinkComponent: t, scope: n }) => /* @__PURE__ */ s.jsx(xs.Provider, { value: { LinkComponent: t, scope: n }, children: e });
var ie = /* @__PURE__ */ ((e) => (e.Microsite = "microsite", e.Docs = "docs", e.Blog = "blog", e.App = "app", e))(ie || {});
function Cs(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var r = e.length;
    for (t = 0; t < r; t++) e[t] && (n = Cs(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function bs() {
  for (var e, t, n = 0, o = "", r = arguments.length; n < r; n++) (e = arguments[n]) && (t = Cs(e)) && (o && (o += " "), o += t);
  return o;
}
const _o = "-", Tc = (e) => {
  const t = Oc(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (i) => {
      const l = i.split(_o);
      return l[0] === "" && l.length !== 1 && l.shift(), ws(l, t) || Ic(i);
    },
    getConflictingClassGroupIds: (i, l) => {
      const c = n[i] || [];
      return l && o[i] ? [...c, ...o[i]] : c;
    }
  };
}, ws = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], o = t.nextPart.get(n), r = o ? ws(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (t.validators.length === 0)
    return;
  const a = e.join(_o);
  return (i = t.validators.find(({
    validator: l
  }) => l(a))) == null ? void 0 : i.classGroupId;
}, Mr = /^\[(.+)\]$/, Ic = (e) => {
  if (Mr.test(e)) {
    const t = Mr.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, Oc = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const r in n)
    lo(n[r], o, r, t);
  return o;
}, lo = (e, t, n, o) => {
  e.forEach((r) => {
    if (typeof r == "string") {
      const a = r === "" ? t : Pr(t, r);
      a.classGroupId = n;
      return;
    }
    if (typeof r == "function") {
      if (Lc(r)) {
        lo(r(o), t, n, o);
        return;
      }
      t.validators.push({
        validator: r,
        classGroupId: n
      });
      return;
    }
    Object.entries(r).forEach(([a, i]) => {
      lo(i, Pr(t, a), n, o);
    });
  });
}, Pr = (e, t) => {
  let n = e;
  return t.split(_o).forEach((o) => {
    n.nextPart.has(o) || n.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(o);
  }), n;
}, Lc = (e) => e.isThemeGetter, Dc = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  const r = (a, i) => {
    n.set(a, i), t++, t > e && (t = 0, o = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = n.get(a);
      if (i !== void 0)
        return i;
      if ((i = o.get(a)) !== void 0)
        return r(a, i), i;
    },
    set(a, i) {
      n.has(a) ? n.set(a, i) : r(a, i);
    }
  };
}, co = "!", uo = ":", Fc = uo.length, Vc = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let o = (r) => {
    const a = [];
    let i = 0, l = 0, c = 0, d;
    for (let b = 0; b < r.length; b++) {
      let p = r[b];
      if (i === 0 && l === 0) {
        if (p === uo) {
          a.push(r.slice(c, b)), c = b + Fc;
          continue;
        }
        if (p === "/") {
          d = b;
          continue;
        }
      }
      p === "[" ? i++ : p === "]" ? i-- : p === "(" ? l++ : p === ")" && l--;
    }
    const f = a.length === 0 ? r : r.substring(c), m = Hc(f), g = m !== f, x = d && d > c ? d - c : void 0;
    return {
      modifiers: a,
      hasImportantModifier: g,
      baseClassName: m,
      maybePostfixModifierPosition: x
    };
  };
  if (t) {
    const r = t + uo, a = o;
    o = (i) => i.startsWith(r) ? a(i.substring(r.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: i,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const r = o;
    o = (a) => n({
      className: a,
      parseClassName: r
    });
  }
  return o;
}, Hc = (e) => e.endsWith(co) ? e.substring(0, e.length - 1) : e.startsWith(co) ? e.substring(1) : e, $c = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((o) => [o, !0]));
  return (o) => {
    if (o.length <= 1)
      return o;
    const r = [];
    let a = [];
    return o.forEach((i) => {
      i[0] === "[" || t[i] ? (r.push(...a.sort(), i), a = []) : a.push(i);
    }), r.push(...a.sort()), r;
  };
}, Bc = (e) => ({
  cache: Dc(e.cacheSize),
  parseClassName: Vc(e),
  sortModifiers: $c(e),
  ...Tc(e)
}), zc = /\s+/, Wc = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: o,
    getConflictingClassGroupIds: r,
    sortModifiers: a
  } = t, i = [], l = e.trim().split(zc);
  let c = "";
  for (let d = l.length - 1; d >= 0; d -= 1) {
    const f = l[d], {
      isExternal: m,
      modifiers: g,
      hasImportantModifier: x,
      baseClassName: b,
      maybePostfixModifierPosition: p
    } = n(f);
    if (m) {
      c = f + (c.length > 0 ? " " + c : c);
      continue;
    }
    let v = !!p, w = o(v ? b.substring(0, p) : b);
    if (!w) {
      if (!v) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (w = o(b), !w) {
        c = f + (c.length > 0 ? " " + c : c);
        continue;
      }
      v = !1;
    }
    const C = a(g).join(":"), y = x ? C + co : C, S = y + w;
    if (i.includes(S))
      continue;
    i.push(S);
    const E = r(w, v);
    for (let j = 0; j < E.length; ++j) {
      const M = E[j];
      i.push(y + M);
    }
    c = f + (c.length > 0 ? " " + c : c);
  }
  return c;
};
function Gc() {
  let e = 0, t, n, o = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = ys(t)) && (o && (o += " "), o += n);
  return o;
}
const ys = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (t = ys(e[o])) && (n && (n += " "), n += t);
  return n;
};
function Nr(e, ...t) {
  let n, o, r, a = i;
  function i(c) {
    const d = t.reduce((f, m) => m(f), e());
    return n = Bc(d), o = n.cache.get, r = n.cache.set, a = l, l(c);
  }
  function l(c) {
    const d = o(c);
    if (d)
      return d;
    const f = Wc(c, n);
    return r(c, f), f;
  }
  return function() {
    return a(Gc.apply(null, arguments));
  };
}
const me = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Ss = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Es = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Zc = /^\d+\/\d+$/, Uc = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Kc = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Yc = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Xc = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, qc = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, bt = (e) => Zc.test(e), W = (e) => !!e && !Number.isNaN(Number(e)), qe = (e) => !!e && Number.isInteger(Number(e)), Yn = (e) => e.endsWith("%") && W(e.slice(0, -1)), We = (e) => Uc.test(e), Jc = () => !0, Qc = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Kc.test(e) && !Yc.test(e)
), Rs = () => !1, e1 = (e) => Xc.test(e), t1 = (e) => qc.test(e), n1 = (e) => !T(e) && !I(e), o1 = (e) => Nt(e, Ps, Rs), T = (e) => Ss.test(e), lt = (e) => Nt(e, Ns, Qc), Xn = (e) => Nt(e, l1, W), _r = (e) => Nt(e, js, Rs), r1 = (e) => Nt(e, Ms, t1), Yt = (e) => Nt(e, _s, e1), I = (e) => Es.test(e), Lt = (e) => _t(e, Ns), s1 = (e) => _t(e, c1), Ar = (e) => _t(e, js), a1 = (e) => _t(e, Ps), i1 = (e) => _t(e, Ms), Xt = (e) => _t(e, _s, !0), Nt = (e, t, n) => {
  const o = Ss.exec(e);
  return o ? o[1] ? t(o[1]) : n(o[2]) : !1;
}, _t = (e, t, n = !1) => {
  const o = Es.exec(e);
  return o ? o[1] ? t(o[1]) : n : !1;
}, js = (e) => e === "position" || e === "percentage", Ms = (e) => e === "image" || e === "url", Ps = (e) => e === "length" || e === "size" || e === "bg-size", Ns = (e) => e === "length", l1 = (e) => e === "number", c1 = (e) => e === "family-name", _s = (e) => e === "shadow", kr = () => {
  const e = me("color"), t = me("font"), n = me("text"), o = me("font-weight"), r = me("tracking"), a = me("leading"), i = me("breakpoint"), l = me("container"), c = me("spacing"), d = me("radius"), f = me("shadow"), m = me("inset-shadow"), g = me("text-shadow"), x = me("drop-shadow"), b = me("blur"), p = me("perspective"), v = me("aspect"), w = me("ease"), C = me("animate"), y = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], S = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], E = () => [...S(), I, T], j = () => ["auto", "hidden", "clip", "visible", "scroll"], M = () => ["auto", "contain", "none"], R = () => [I, T, c], _ = () => [bt, "full", "auto", ...R()], L = () => [qe, "none", "subgrid", I, T], B = () => ["auto", {
    span: ["full", qe, I, T]
  }, qe, I, T], X = () => [qe, "auto", I, T], $ = () => ["auto", "min", "max", "fr", I, T], z = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], G = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], D = () => ["auto", ...R()], Z = () => [bt, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...R()], P = () => [e, I, T], te = () => [...S(), Ar, _r, {
    position: [I, T]
  }], de = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ge = () => ["auto", "cover", "contain", a1, o1, {
    size: [I, T]
  }], Re = () => [Yn, Lt, lt], le = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    I,
    T
  ], ce = () => ["", W, Lt, lt], Se = () => ["solid", "dashed", "dotted", "double"], be = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], k = () => [W, Yn, Ar, _r], Q = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    I,
    T
  ], ae = () => ["none", W, I, T], U = () => ["none", W, I, T], q = () => [W, I, T], K = () => [bt, "full", ...R()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [We],
      breakpoint: [We],
      color: [Jc],
      container: [We],
      "drop-shadow": [We],
      ease: ["in", "out", "in-out"],
      font: [n1],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [We],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [We],
      shadow: [We],
      spacing: ["px", W],
      text: [We],
      "text-shadow": [We],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", bt, T, I, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [W, T, I, l]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": y()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": y()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: E()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: j()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": j()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": j()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: _()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": _()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": _()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: _()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: _()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: _()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: _()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: _()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: _()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [qe, "auto", I, T]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [bt, "full", "auto", l, ...R()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [W, bt, "auto", "initial", "none", T]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", W, I, T]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", W, I, T]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [qe, "first", "last", "none", I, T]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": L()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: B()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": X()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": X()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": L()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: B()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": X()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": X()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": $()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": $()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: R()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": R()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": R()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...z(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...G(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...G()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...z()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": z()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...G(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...G()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: R()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: R()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: R()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: R()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: R()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: R()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: R()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: R()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: R()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: D()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: D()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: D()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: D()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: D()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: D()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: D()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: D()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: D()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": R()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": R()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Z()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [l, "screen", ...Z()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          l,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Z()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          l,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...Z()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Z()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Z()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Z()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Lt, lt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, I, Xn]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Yn, T]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [s1, T, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [r, I, T]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [W, "none", I, Xn]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...R()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", I, T]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", I, T]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: P()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: P()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Se(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [W, "from-font", "auto", I, lt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: P()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [W, "auto", I, T]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: R()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", I, T]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", I, T]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: te()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: de()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ge()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, qe, I, T],
          radial: ["", I, T],
          conic: [qe, I, T]
        }, i1, r1]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: P()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Re()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Re()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Re()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: P()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: P()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: P()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: le()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": le()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": le()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": le()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": le()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": le()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": le()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": le()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": le()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": le()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": le()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": le()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": le()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": le()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": le()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: ce()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": ce()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": ce()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": ce()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": ce()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": ce()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": ce()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": ce()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": ce()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": ce()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": ce()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Se(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Se(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: P()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": P()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": P()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": P()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": P()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": P()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": P()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": P()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": P()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: P()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Se(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [W, I, T]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", W, Lt, lt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: P()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          f,
          Xt,
          Yt
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: P()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", m, Xt, Yt]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": P()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: ce()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: P()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [W, lt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": P()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": ce()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": P()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", g, Xt, Yt]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": P()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [W, I, T]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...be(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": be()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [W]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": k()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": k()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": P()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": P()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": k()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": k()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": P()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": P()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": k()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": k()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": P()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": P()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": k()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": k()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": P()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": P()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": k()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": k()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": P()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": P()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": k()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": k()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": P()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": P()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": k()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": k()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": P()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": P()
      }],
      "mask-image-radial": [{
        "mask-radial": [I, T]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": k()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": k()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": P()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": P()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": S()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [W]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": k()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": k()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": P()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": P()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: te()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: de()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ge()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", I, T]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          T
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Q()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [W, I, T]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [W, I, T]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          x,
          Xt,
          Yt
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": P()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", W, I, T]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [W, I, T]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", W, I, T]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [W, I, T]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", W, I, T]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          I,
          T
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Q()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [W, I, T]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [W, I, T]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", W, I, T]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [W, I, T]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", W, I, T]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [W, I, T]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [W, I, T]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", W, I, T]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": R()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": R()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": R()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", I, T]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [W, "initial", I, T]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", w, I, T]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [W, I, T]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", C, I, T]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, I, T]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": E()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ae()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ae()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ae()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ae()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: U()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": U()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": U()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": U()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: q()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": q()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": q()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [I, T, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: E()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: K()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": K()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": K()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": K()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: P()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: P()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", I, T]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": R()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": R()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": R()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": R()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": R()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": R()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": R()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": R()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": R()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": R()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": R()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": R()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": R()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": R()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": R()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": R()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": R()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": R()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", I, T]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...P()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [W, Lt, lt, Xn]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...P()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, u1 = (e, {
  cacheSize: t,
  prefix: n,
  experimentalParseClassName: o,
  extend: r = {},
  override: a = {}
}) => (Dt(e, "cacheSize", t), Dt(e, "prefix", n), Dt(e, "experimentalParseClassName", o), qt(e.theme, a.theme), qt(e.classGroups, a.classGroups), qt(e.conflictingClassGroups, a.conflictingClassGroups), qt(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), Dt(e, "orderSensitiveModifiers", a.orderSensitiveModifiers), Jt(e.theme, r.theme), Jt(e.classGroups, r.classGroups), Jt(e.conflictingClassGroups, r.conflictingClassGroups), Jt(e.conflictingClassGroupModifiers, r.conflictingClassGroupModifiers), As(e, r, "orderSensitiveModifiers"), e), Dt = (e, t, n) => {
  n !== void 0 && (e[t] = n);
}, qt = (e, t) => {
  if (t)
    for (const n in t)
      Dt(e, n, t[n]);
}, Jt = (e, t) => {
  if (t)
    for (const n in t)
      As(e, t, n);
}, As = (e, t, n) => {
  const o = t[n];
  o !== void 0 && (e[n] = e[n] ? e[n].concat(o) : o);
}, d1 = (e, ...t) => typeof e == "function" ? Nr(kr, e, ...t) : Nr(() => u1(kr(), e), ...t), f1 = d1({
  extend: {
    classGroups: {
      "font-size": [
        "text-heading-h1",
        "text-heading-h2",
        "text-heading-h3",
        "text-paragraph-big",
        "text-paragraph-medium",
        "text-paragraph-small",
        "text-paragraph-extrasmall",
        "text-paragraph-extrasmall-bold",
        "text-button-big",
        "text-button-small",
        "text-link-big",
        "text-link-medium",
        "text-link-medium-bold",
        "text-link-small",
        "text-link-extrasmall",
        "text-link-extrasmall-bold"
      ]
    }
  }
});
function O(...e) {
  return f1(bs(e));
}
const Tr = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ir = bs, En = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return Ir(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: a } = t, i = Object.keys(r).map((d) => {
    const f = n == null ? void 0 : n[d], m = a == null ? void 0 : a[d];
    if (f === null) return null;
    const g = Tr(f) || Tr(m);
    return r[d][g];
  }), l = n && Object.entries(n).reduce((d, f) => {
    let [m, g] = f;
    return g === void 0 || (d[m] = g), d;
  }, {}), c = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((d, f) => {
    let { class: m, className: g, ...x } = f;
    return Object.entries(x).every((b) => {
      let [p, v] = b;
      return Array.isArray(v) ? v.includes({
        ...a,
        ...l
      }[p]) : {
        ...a,
        ...l
      }[p] === v;
    }) ? [
      ...d,
      m,
      g
    ] : d;
  }, []);
  return Ir(e, i, c, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Qt = "text-accent-primary underline hover:text-accent-secondary hover:no-underline transition-all", p1 = En("", {
  variants: {
    variant: {
      "Heading/Hero": "text-heading-hero",
      "Heading/H1": "text-heading-h1",
      "Heading/H2": "text-heading-h2",
      "Heading/H3": "text-heading-h3",
      "Heading/H4": "text-heading-h4",
      "Paragraph/Big": "text-paragraph-big",
      "Paragraph/Medium": "text-paragraph-medium",
      "Paragraph/Small": "text-paragraph-small",
      "Paragraph/ExtraSmall": "text-paragraph-extrasmall",
      "Paragraph/ExtraSmall/Bold": "text-paragraph-extrasmall-bold",
      "Link/Big": O("text-link-big", Qt),
      "Link/Medium": O("text-link-medium", Qt),
      "Link/Medium/Bold": O("text-link-medium-bold", Qt),
      "Link/Small": O("text-link-small", Qt),
      Label: "text-label"
    }
  }
}), m1 = ({ as: e, variant: t, className: n, children: o }) => an(e, { className: p1({ variant: t, className: n }) }, o), h1 = ({ as: e = "span", variant: t, className: n, showArrow: o, children: r }) => /* @__PURE__ */ s.jsxs(m1, { as: e, variant: t, className: O("flex items-center gap-2", n), children: [
  r,
  o && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    "⁠",
    /* @__PURE__ */ s.jsx(tt, { className: "size-4 rotate-270" })
  ] })
] });
function Or(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ao(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = Or(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : Or(e[r], null);
        }
      };
  };
}
function ne(...e) {
  return u.useCallback(Ao(...e), e);
}
// @__NO_SIDE_EFFECTS__
function ut(e) {
  const t = /* @__PURE__ */ g1(e), n = u.forwardRef((o, r) => {
    const { children: a, ...i } = o, l = u.Children.toArray(a), c = l.find(x1);
    if (c) {
      const d = c.props.children, f = l.map((m) => m === c ? u.Children.count(d) > 1 ? u.Children.only(null) : u.isValidElement(d) ? d.props.children : null : m);
      return /* @__PURE__ */ s.jsx(t, { ...i, ref: r, children: u.isValidElement(d) ? u.cloneElement(d, void 0, f) : null });
    }
    return /* @__PURE__ */ s.jsx(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var ks = /* @__PURE__ */ ut("Slot");
// @__NO_SIDE_EFFECTS__
function g1(e) {
  const t = u.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (u.isValidElement(r)) {
      const i = b1(r), l = C1(a, r.props);
      return r.type !== u.Fragment && (l.ref = o ? Ao(o, i) : i), u.cloneElement(r, l);
    }
    return u.Children.count(r) > 1 ? u.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var v1 = Symbol("radix.slottable");
function x1(e) {
  return u.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === v1;
}
function C1(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...l) => {
      const c = a(...l);
      return r(...l), c;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function b1(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var w1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], V = w1.reduce((e, t) => {
  const n = /* @__PURE__ */ ut(`Primitive.${t}`), o = u.forwardRef((r, a) => {
    const { asChild: i, ...l } = r, c = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s.jsx(c, { ...l, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function fo(e, t) {
  e && Sn.flushSync(() => e.dispatchEvent(t));
}
var Ts = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), y1 = "VisuallyHidden", Is = u.forwardRef(
  (e, t) => /* @__PURE__ */ s.jsx(
    V.span,
    {
      ...e,
      ref: t,
      style: { ...Ts, ...e.style }
    }
  )
);
Is.displayName = y1;
var S1 = Is;
function E1(e, t) {
  const n = u.createContext(t), o = (a) => {
    const { children: i, ...l } = a, c = u.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ s.jsx(n.Provider, { value: c, children: i });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const i = u.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function He(e, t = []) {
  let n = [];
  function o(a, i) {
    const l = u.createContext(i), c = n.length;
    n = [...n, i];
    const d = (m) => {
      var w;
      const { scope: g, children: x, ...b } = m, p = ((w = g == null ? void 0 : g[e]) == null ? void 0 : w[c]) || l, v = u.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ s.jsx(p.Provider, { value: v, children: x });
    };
    d.displayName = a + "Provider";
    function f(m, g) {
      var p;
      const x = ((p = g == null ? void 0 : g[e]) == null ? void 0 : p[c]) || l, b = u.useContext(x);
      if (b) return b;
      if (i !== void 0) return i;
      throw new Error(`\`${m}\` must be used within \`${a}\``);
    }
    return [d, f];
  }
  const r = () => {
    const a = n.map((i) => u.createContext(i));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || a;
      return u.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return r.scopeName = e, [o, R1(r, ...t)];
}
function R1(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((l, { useScope: c, scopeName: d }) => {
        const m = c(a)[`__scope${d}`];
        return { ...l, ...m };
      }, {});
      return u.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Bt(e) {
  const t = e + "CollectionProvider", [n, o] = He(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (p) => {
    const { scope: v, children: w } = p, C = ee.useRef(null), y = ee.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ s.jsx(r, { scope: v, itemMap: y, collectionRef: C, children: w });
  };
  i.displayName = t;
  const l = e + "CollectionSlot", c = /* @__PURE__ */ ut(l), d = ee.forwardRef(
    (p, v) => {
      const { scope: w, children: C } = p, y = a(l, w), S = ne(v, y.collectionRef);
      return /* @__PURE__ */ s.jsx(c, { ref: S, children: C });
    }
  );
  d.displayName = l;
  const f = e + "CollectionItemSlot", m = "data-radix-collection-item", g = /* @__PURE__ */ ut(f), x = ee.forwardRef(
    (p, v) => {
      const { scope: w, children: C, ...y } = p, S = ee.useRef(null), E = ne(v, S), j = a(f, w);
      return ee.useEffect(() => (j.itemMap.set(S, { ref: S, ...y }), () => void j.itemMap.delete(S))), /* @__PURE__ */ s.jsx(g, { [m]: "", ref: E, children: C });
    }
  );
  x.displayName = f;
  function b(p) {
    const v = a(e + "CollectionConsumer", p);
    return ee.useCallback(() => {
      const C = v.collectionRef.current;
      if (!C) return [];
      const y = Array.from(C.querySelectorAll(`[${m}]`));
      return Array.from(v.itemMap.values()).sort(
        (j, M) => y.indexOf(j.ref.current) - y.indexOf(M.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: i, Slot: d, ItemSlot: x },
    b,
    o
  ];
}
function F(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
var pe = globalThis != null && globalThis.document ? u.useLayoutEffect : () => {
}, j1 = u[" useInsertionEffect ".trim().toString()] || pe;
function Ee({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, i] = M1({
    defaultProp: t,
    onChange: n
  }), l = e !== void 0, c = l ? e : r;
  {
    const f = u.useRef(e !== void 0);
    u.useEffect(() => {
      const m = f.current;
      m !== l && console.warn(
        `${o} is changing from ${m ? "controlled" : "uncontrolled"} to ${l ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), f.current = l;
    }, [l, o]);
  }
  const d = u.useCallback(
    (f) => {
      var m;
      if (l) {
        const g = P1(f) ? f(e) : f;
        g !== e && ((m = i.current) == null || m.call(i, g));
      } else
        a(f);
    },
    [l, e, a, i]
  );
  return [c, d];
}
function M1({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = u.useState(e), r = u.useRef(n), a = u.useRef(t);
  return j1(() => {
    a.current = t;
  }, [t]), u.useEffect(() => {
    var i;
    r.current !== n && ((i = a.current) == null || i.call(a, n), r.current = n);
  }, [n, r]), [n, o, a];
}
function P1(e) {
  return typeof e == "function";
}
function N1(e, t) {
  return u.useReducer((n, o) => t[n][o] ?? n, e);
}
var $e = (e) => {
  const { present: t, children: n } = e, o = _1(t), r = typeof n == "function" ? n({ present: o.isPresent }) : u.Children.only(n), a = ne(o.ref, A1(r));
  return typeof n == "function" || o.isPresent ? u.cloneElement(r, { ref: a }) : null;
};
$e.displayName = "Presence";
function _1(e) {
  const [t, n] = u.useState(), o = u.useRef(null), r = u.useRef(e), a = u.useRef("none"), i = e ? "mounted" : "unmounted", [l, c] = N1(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return u.useEffect(() => {
    const d = en(o.current);
    a.current = l === "mounted" ? d : "none";
  }, [l]), pe(() => {
    const d = o.current, f = r.current;
    if (f !== e) {
      const g = a.current, x = en(d);
      e ? c("MOUNT") : x === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(f && g !== x ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, c]), pe(() => {
    if (t) {
      let d;
      const f = t.ownerDocument.defaultView ?? window, m = (x) => {
        const p = en(o.current).includes(CSS.escape(x.animationName));
        if (x.target === t && p && (c("ANIMATION_END"), !r.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, g = (x) => {
        x.target === t && (a.current = en(o.current));
      };
      return t.addEventListener("animationstart", g), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        f.clearTimeout(d), t.removeEventListener("animationstart", g), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: u.useCallback((d) => {
      o.current = d ? getComputedStyle(d) : null, n(d);
    }, [])
  };
}
function en(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function A1(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var k1 = u[" useId ".trim().toString()] || (() => {
}), T1 = 0;
function Pe(e) {
  const [t, n] = u.useState(k1());
  return pe(() => {
    n((o) => o ?? String(T1++));
  }, [e]), t ? `radix-${t}` : "";
}
var Rn = "Collapsible", [I1, Os] = He(Rn), [O1, ko] = I1(Rn), Ls = u.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...l
    } = e, [c, d] = Ee({
      prop: o,
      defaultProp: r ?? !1,
      onChange: i,
      caller: Rn
    });
    return /* @__PURE__ */ s.jsx(
      O1,
      {
        scope: n,
        disabled: a,
        contentId: Pe(),
        open: c,
        onOpenToggle: u.useCallback(() => d((f) => !f), [d]),
        children: /* @__PURE__ */ s.jsx(
          V.div,
          {
            "data-state": Lo(c),
            "data-disabled": a ? "" : void 0,
            ...l,
            ref: t
          }
        )
      }
    );
  }
);
Ls.displayName = Rn;
var Ds = "CollapsibleTrigger", To = u.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = ko(Ds, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": Lo(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
  }
);
To.displayName = Ds;
var Io = "CollapsibleContent", Oo = u.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = ko(Io, e.__scopeCollapsible);
    return /* @__PURE__ */ s.jsx($e, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ s.jsx(L1, { ...o, ref: t, present: a }) });
  }
);
Oo.displayName = Io;
var L1 = u.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, i = ko(Io, n), [l, c] = u.useState(o), d = u.useRef(null), f = ne(t, d), m = u.useRef(0), g = m.current, x = u.useRef(0), b = x.current, p = i.open || l, v = u.useRef(p), w = u.useRef(void 0);
  return u.useEffect(() => {
    const C = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(C);
  }, []), pe(() => {
    const C = d.current;
    if (C) {
      w.current = w.current || {
        transitionDuration: C.style.transitionDuration,
        animationName: C.style.animationName
      }, C.style.transitionDuration = "0s", C.style.animationName = "none";
      const y = C.getBoundingClientRect();
      m.current = y.height, x.current = y.width, v.current || (C.style.transitionDuration = w.current.transitionDuration, C.style.animationName = w.current.animationName), c(o);
    }
  }, [i.open, o]), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "data-state": Lo(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !p,
      ...a,
      ref: f,
      style: {
        "--radix-collapsible-content-height": g ? `${g}px` : void 0,
        "--radix-collapsible-content-width": b ? `${b}px` : void 0,
        ...e.style
      },
      children: p && r
    }
  );
});
function Lo(e) {
  return e ? "open" : "closed";
}
var Fs = Ls, D1 = To, F1 = Oo, V1 = u.createContext(void 0);
function zt(e) {
  const t = u.useContext(V1);
  return e || t || "ltr";
}
var Te = "Accordion", H1 = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Do, $1, B1] = Bt(Te), [jn] = He(Te, [
  B1,
  Os
]), Fo = Os(), Vs = ee.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ s.jsx(Do.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ s.jsx(Z1, { ...a, ref: t }) : /* @__PURE__ */ s.jsx(G1, { ...r, ref: t }) });
  }
);
Vs.displayName = Te;
var [Hs, z1] = jn(Te), [$s, W1] = jn(
  Te,
  { collapsible: !1 }
), G1 = ee.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [l, c] = Ee({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: Te
    });
    return /* @__PURE__ */ s.jsx(
      Hs,
      {
        scope: e.__scopeAccordion,
        value: ee.useMemo(() => l ? [l] : [], [l]),
        onItemOpen: c,
        onItemClose: ee.useCallback(() => a && c(""), [a, c]),
        children: /* @__PURE__ */ s.jsx($s, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ s.jsx(Bs, { ...i, ref: t }) })
      }
    );
  }
), Z1 = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: Te
  }), c = ee.useCallback(
    (f) => l((m = []) => [...m, f]),
    [l]
  ), d = ee.useCallback(
    (f) => l((m = []) => m.filter((g) => g !== f)),
    [l]
  );
  return /* @__PURE__ */ s.jsx(
    Hs,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: c,
      onItemClose: d,
      children: /* @__PURE__ */ s.jsx($s, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ s.jsx(Bs, { ...a, ref: t }) })
    }
  );
}), [U1, Mn] = jn(Te), Bs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...i } = e, l = ee.useRef(null), c = ne(l, t), d = $1(n), m = zt(r) === "ltr", g = F(e.onKeyDown, (x) => {
      var R;
      if (!H1.includes(x.key)) return;
      const b = x.target, p = d().filter((_) => {
        var L;
        return !((L = _.ref.current) != null && L.disabled);
      }), v = p.findIndex((_) => _.ref.current === b), w = p.length;
      if (v === -1) return;
      x.preventDefault();
      let C = v;
      const y = 0, S = w - 1, E = () => {
        C = v + 1, C > S && (C = y);
      }, j = () => {
        C = v - 1, C < y && (C = S);
      };
      switch (x.key) {
        case "Home":
          C = y;
          break;
        case "End":
          C = S;
          break;
        case "ArrowRight":
          a === "horizontal" && (m ? E() : j());
          break;
        case "ArrowDown":
          a === "vertical" && E();
          break;
        case "ArrowLeft":
          a === "horizontal" && (m ? j() : E());
          break;
        case "ArrowUp":
          a === "vertical" && j();
          break;
      }
      const M = C % w;
      (R = p[M].ref.current) == null || R.focus();
    });
    return /* @__PURE__ */ s.jsx(
      U1,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ s.jsx(Do.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(
          V.div,
          {
            ...i,
            "data-orientation": a,
            ref: c,
            onKeyDown: o ? void 0 : g
          }
        ) })
      }
    );
  }
), fn = "AccordionItem", [K1, Vo] = jn(fn), zs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = Mn(fn, n), i = z1(fn, n), l = Fo(n), c = Pe(), d = o && i.value.includes(o) || !1, f = a.disabled || e.disabled;
    return /* @__PURE__ */ s.jsx(
      K1,
      {
        scope: n,
        open: d,
        disabled: f,
        triggerId: c,
        children: /* @__PURE__ */ s.jsx(
          Fs,
          {
            "data-orientation": a.orientation,
            "data-state": Ys(d),
            ...l,
            ...r,
            ref: t,
            disabled: f,
            open: d,
            onOpenChange: (m) => {
              m ? i.onItemOpen(o) : i.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
zs.displayName = fn;
var Ws = "AccordionHeader", Gs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = Mn(Te, n), a = Vo(Ws, n);
    return /* @__PURE__ */ s.jsx(
      V.h3,
      {
        "data-orientation": r.orientation,
        "data-state": Ys(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
Gs.displayName = Ws;
var po = "AccordionTrigger", Zs = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = Mn(Te, n), a = Vo(po, n), i = W1(po, n), l = Fo(n);
    return /* @__PURE__ */ s.jsx(Do.ItemSlot, { scope: n, children: /* @__PURE__ */ s.jsx(
      D1,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...l,
        ...o,
        ref: t
      }
    ) });
  }
);
Zs.displayName = po;
var Us = "AccordionContent", Ks = ee.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = Mn(Te, n), a = Vo(Us, n), i = Fo(n);
    return /* @__PURE__ */ s.jsx(
      F1,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
Ks.displayName = Us;
function Ys(e) {
  return e ? "open" : "closed";
}
var Y1 = Vs, X1 = zs, q1 = Gs, J1 = Zs, Q1 = Ks;
function Ce(e) {
  const t = u.useRef(e);
  return u.useEffect(() => {
    t.current = e;
  }), u.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function eu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e);
  u.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var tu = "DismissableLayer", mo = "dismissableLayer.update", nu = "dismissableLayer.pointerDownOutside", ou = "dismissableLayer.focusOutside", Lr, Xs = u.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Wt = u.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: l,
      ...c
    } = e, d = u.useContext(Xs), [f, m] = u.useState(null), g = (f == null ? void 0 : f.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, x] = u.useState({}), b = ne(t, (M) => m(M)), p = Array.from(d.layers), [v] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), w = p.indexOf(v), C = f ? p.indexOf(f) : -1, y = d.layersWithOutsidePointerEventsDisabled.size > 0, S = C >= w, E = au((M) => {
      const R = M.target, _ = [...d.branches].some((L) => L.contains(R));
      !S || _ || (r == null || r(M), i == null || i(M), M.defaultPrevented || l == null || l());
    }, g), j = iu((M) => {
      const R = M.target;
      [...d.branches].some((L) => L.contains(R)) || (a == null || a(M), i == null || i(M), M.defaultPrevented || l == null || l());
    }, g);
    return eu((M) => {
      C === d.layers.size - 1 && (o == null || o(M), !M.defaultPrevented && l && (M.preventDefault(), l()));
    }, g), u.useEffect(() => {
      if (f)
        return n && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Lr = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), Dr(), () => {
          n && d.layersWithOutsidePointerEventsDisabled.size === 1 && (g.body.style.pointerEvents = Lr);
        };
    }, [f, g, n, d]), u.useEffect(() => () => {
      f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), Dr());
    }, [f, d]), u.useEffect(() => {
      const M = () => x({});
      return document.addEventListener(mo, M), () => document.removeEventListener(mo, M);
    }, []), /* @__PURE__ */ s.jsx(
      V.div,
      {
        ...c,
        ref: b,
        style: {
          pointerEvents: y ? S ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: F(e.onFocusCapture, j.onFocusCapture),
        onBlurCapture: F(e.onBlurCapture, j.onBlurCapture),
        onPointerDownCapture: F(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Wt.displayName = tu;
var ru = "DismissableLayerBranch", su = u.forwardRef((e, t) => {
  const n = u.useContext(Xs), o = u.useRef(null), r = ne(t, o);
  return u.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ s.jsx(V.div, { ...e, ref: r });
});
su.displayName = ru;
function au(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e), o = u.useRef(!1), r = u.useRef(() => {
  });
  return u.useEffect(() => {
    const a = (l) => {
      if (l.target && !o.current) {
        let c = function() {
          qs(
            nu,
            n,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = c, t.addEventListener("click", r.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function iu(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ce(e), o = u.useRef(!1);
  return u.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && qs(ou, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Dr() {
  const e = new CustomEvent(mo);
  document.dispatchEvent(e);
}
function qs(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? fo(r, a) : r.dispatchEvent(a);
}
var qn = "focusScope.autoFocusOnMount", Jn = "focusScope.autoFocusOnUnmount", Fr = { bubbles: !1, cancelable: !0 }, lu = "FocusScope", Pn = u.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [l, c] = u.useState(null), d = Ce(r), f = Ce(a), m = u.useRef(null), g = ne(t, (p) => c(p)), x = u.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  u.useEffect(() => {
    if (o) {
      let p = function(y) {
        if (x.paused || !l) return;
        const S = y.target;
        l.contains(S) ? m.current = S : Je(m.current, { select: !0 });
      }, v = function(y) {
        if (x.paused || !l) return;
        const S = y.relatedTarget;
        S !== null && (l.contains(S) || Je(m.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const E of y)
            E.removedNodes.length > 0 && Je(l);
      };
      document.addEventListener("focusin", p), document.addEventListener("focusout", v);
      const C = new MutationObserver(w);
      return l && C.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", p), document.removeEventListener("focusout", v), C.disconnect();
      };
    }
  }, [o, l, x.paused]), u.useEffect(() => {
    if (l) {
      Hr.add(x);
      const p = document.activeElement;
      if (!l.contains(p)) {
        const w = new CustomEvent(qn, Fr);
        l.addEventListener(qn, d), l.dispatchEvent(w), w.defaultPrevented || (cu(mu(Js(l)), { select: !0 }), document.activeElement === p && Je(l));
      }
      return () => {
        l.removeEventListener(qn, d), setTimeout(() => {
          const w = new CustomEvent(Jn, Fr);
          l.addEventListener(Jn, f), l.dispatchEvent(w), w.defaultPrevented || Je(p ?? document.body, { select: !0 }), l.removeEventListener(Jn, f), Hr.remove(x);
        }, 0);
      };
    }
  }, [l, d, f, x]);
  const b = u.useCallback(
    (p) => {
      if (!n && !o || x.paused) return;
      const v = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, w = document.activeElement;
      if (v && w) {
        const C = p.currentTarget, [y, S] = uu(C);
        y && S ? !p.shiftKey && w === S ? (p.preventDefault(), n && Je(y, { select: !0 })) : p.shiftKey && w === y && (p.preventDefault(), n && Je(S, { select: !0 })) : w === C && p.preventDefault();
      }
    },
    [n, o, x.paused]
  );
  return /* @__PURE__ */ s.jsx(V.div, { tabIndex: -1, ...i, ref: g, onKeyDown: b });
});
Pn.displayName = lu;
function cu(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Je(o, { select: t }), document.activeElement !== n) return;
}
function uu(e) {
  const t = Js(e), n = Vr(t, e), o = Vr(t.reverse(), e);
  return [n, o];
}
function Js(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Vr(e, t) {
  for (const n of e)
    if (!du(n, { upTo: t })) return n;
}
function du(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function fu(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Je(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && fu(e) && t && e.select();
  }
}
var Hr = pu();
function pu() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = $r(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = $r(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function $r(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function mu(e) {
  return e.filter((t) => t.tagName !== "A");
}
var hu = "Portal", Ho = u.forwardRef((e, t) => {
  var l;
  const { container: n, ...o } = e, [r, a] = u.useState(!1);
  pe(() => a(!0), []);
  const i = n || r && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return i ? ps.createPortal(/* @__PURE__ */ s.jsx(V.div, { ...o, ref: t }), i) : null;
});
Ho.displayName = hu;
var Qn = 0;
function $o() {
  u.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Br()), document.body.insertAdjacentElement("beforeend", e[1] ?? Br()), Qn++, () => {
      Qn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Qn--;
    };
  }, []);
}
function Br() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Le = function() {
  return Le = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Le.apply(this, arguments);
};
function Qs(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function gu(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var ln = "right-scroll-bar-position", cn = "width-before-scroll-bar", vu = "with-scroll-bars-hidden", xu = "--removed-body-scroll-bar-size";
function eo(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Cu(e, t) {
  var n = $t(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var bu = typeof window < "u" ? u.useLayoutEffect : u.useEffect, zr = /* @__PURE__ */ new WeakMap();
function wu(e, t) {
  var n = Cu(null, function(o) {
    return e.forEach(function(r) {
      return eo(r, o);
    });
  });
  return bu(function() {
    var o = zr.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), i = n.current;
      r.forEach(function(l) {
        a.has(l) || eo(l, null);
      }), a.forEach(function(l) {
        r.has(l) || eo(l, i);
      });
    }
    zr.set(n, e);
  }, [e]), n;
}
function yu(e) {
  return e;
}
function Su(e, t) {
  t === void 0 && (t = yu);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, o);
      return n.push(i), function() {
        n = n.filter(function(l) {
          return l !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(l) {
          return a(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var i = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(a), i = n;
      }
      var c = function() {
        var f = i;
        i = [], f.forEach(a);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          i.push(f), d();
        },
        filter: function(f) {
          return i = i.filter(f), n;
        }
      };
    }
  };
  return r;
}
function Eu(e) {
  e === void 0 && (e = {});
  var t = Su(null);
  return t.options = Le({ async: !0, ssr: !1 }, e), t;
}
var ea = function(e) {
  var t = e.sideCar, n = Qs(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return u.createElement(o, Le({}, n));
};
ea.isSideCarExport = !0;
function Ru(e, t) {
  return e.useMedium(t), ea;
}
var ta = Eu(), to = function() {
}, Nn = u.forwardRef(function(e, t) {
  var n = u.useRef(null), o = u.useState({
    onScrollCapture: to,
    onWheelCapture: to,
    onTouchMoveCapture: to
  }), r = o[0], a = o[1], i = e.forwardProps, l = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, m = e.shards, g = e.sideCar, x = e.noRelative, b = e.noIsolation, p = e.inert, v = e.allowPinchZoom, w = e.as, C = w === void 0 ? "div" : w, y = e.gapMode, S = Qs(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = g, j = wu([n, t]), M = Le(Le({}, S), r);
  return u.createElement(
    u.Fragment,
    null,
    f && u.createElement(E, { sideCar: ta, removeScrollBar: d, shards: m, noRelative: x, noIsolation: b, inert: p, setCallbacks: a, allowPinchZoom: !!v, lockRef: n, gapMode: y }),
    i ? u.cloneElement(u.Children.only(l), Le(Le({}, M), { ref: j })) : u.createElement(C, Le({}, M, { className: c, ref: j }), l)
  );
});
Nn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Nn.classNames = {
  fullWidth: cn,
  zeroRight: ln
};
var ju = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Mu() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ju();
  return t && e.setAttribute("nonce", t), e;
}
function Pu(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Nu(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var _u = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Mu()) && (Pu(t, n), Nu(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Au = function() {
  var e = _u();
  return function(t, n) {
    u.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, na = function() {
  var e = Au(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, ku = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, no = function(e) {
  return parseInt(e || "", 10) || 0;
}, Tu = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [no(n), no(o), no(r)];
}, Iu = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ku;
  var t = Tu(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, Ou = na(), Et = "data-scroll-locked", Lu = function(e, t, n, o) {
  var r = e.left, a = e.top, i = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(vu, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(l, "px ").concat(o, `;
  }
  body[`).concat(Et, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ln, ` {
    right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(cn, ` {
    margin-right: `).concat(l, "px ").concat(o, `;
  }
  
  .`).concat(ln, " .").concat(ln, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(cn, " .").concat(cn, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Et, `] {
    `).concat(xu, ": ").concat(l, `px;
  }
`);
}, Wr = function() {
  var e = parseInt(document.body.getAttribute(Et) || "0", 10);
  return isFinite(e) ? e : 0;
}, Du = function() {
  u.useEffect(function() {
    return document.body.setAttribute(Et, (Wr() + 1).toString()), function() {
      var e = Wr() - 1;
      e <= 0 ? document.body.removeAttribute(Et) : document.body.setAttribute(Et, e.toString());
    };
  }, []);
}, Fu = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  Du();
  var a = u.useMemo(function() {
    return Iu(r);
  }, [r]);
  return u.createElement(Ou, { styles: Lu(a, !t, r, n ? "" : "!important") });
}, ho = !1;
if (typeof window < "u")
  try {
    var tn = Object.defineProperty({}, "passive", {
      get: function() {
        return ho = !0, !0;
      }
    });
    window.addEventListener("test", tn, tn), window.removeEventListener("test", tn, tn);
  } catch {
    ho = !1;
  }
var wt = ho ? { passive: !1 } : !1, Vu = function(e) {
  return e.tagName === "TEXTAREA";
}, oa = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Vu(e) && n[t] === "visible")
  );
}, Hu = function(e) {
  return oa(e, "overflowY");
}, $u = function(e) {
  return oa(e, "overflowX");
}, Gr = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = ra(e, o);
    if (r) {
      var a = sa(e, o), i = a[1], l = a[2];
      if (i > l)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, Bu = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, zu = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, ra = function(e, t) {
  return e === "v" ? Hu(t) : $u(t);
}, sa = function(e, t) {
  return e === "v" ? Bu(t) : zu(t);
}, Wu = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Gu = function(e, t, n, o, r) {
  var a = Wu(e, window.getComputedStyle(t).direction), i = a * o, l = n.target, c = t.contains(l), d = !1, f = i > 0, m = 0, g = 0;
  do {
    if (!l)
      break;
    var x = sa(e, l), b = x[0], p = x[1], v = x[2], w = p - v - a * b;
    (b || w) && ra(e, l) && (m += w, g += b);
    var C = l.parentNode;
    l = C && C.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? C.host : C;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (f && Math.abs(m) < 1 || !f && Math.abs(g) < 1) && (d = !0), d;
}, nn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Zr = function(e) {
  return [e.deltaX, e.deltaY];
}, Ur = function(e) {
  return e && "current" in e ? e.current : e;
}, Zu = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Uu = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Ku = 0, yt = [];
function Yu(e) {
  var t = u.useRef([]), n = u.useRef([0, 0]), o = u.useRef(), r = u.useState(Ku++)[0], a = u.useState(na)[0], i = u.useRef(e);
  u.useEffect(function() {
    i.current = e;
  }, [e]), u.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var p = gu([e.lockRef.current], (e.shards || []).map(Ur), !0).filter(Boolean);
      return p.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), p.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = u.useCallback(function(p, v) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = nn(p), C = n.current, y = "deltaX" in p ? p.deltaX : C[0] - w[0], S = "deltaY" in p ? p.deltaY : C[1] - w[1], E, j = p.target, M = Math.abs(y) > Math.abs(S) ? "h" : "v";
    if ("touches" in p && M === "h" && j.type === "range")
      return !1;
    var R = window.getSelection(), _ = R && R.anchorNode, L = _ ? _ === j || _.contains(j) : !1;
    if (L)
      return !1;
    var B = Gr(M, j);
    if (!B)
      return !0;
    if (B ? E = M : (E = M === "v" ? "h" : "v", B = Gr(M, j)), !B)
      return !1;
    if (!o.current && "changedTouches" in p && (y || S) && (o.current = E), !E)
      return !0;
    var X = o.current || E;
    return Gu(X, v, p, X === "h" ? y : S);
  }, []), c = u.useCallback(function(p) {
    var v = p;
    if (!(!yt.length || yt[yt.length - 1] !== a)) {
      var w = "deltaY" in v ? Zr(v) : nn(v), C = t.current.filter(function(E) {
        return E.name === v.type && (E.target === v.target || v.target === E.shadowParent) && Zu(E.delta, w);
      })[0];
      if (C && C.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!C) {
        var y = (i.current.shards || []).map(Ur).filter(Boolean).filter(function(E) {
          return E.contains(v.target);
        }), S = y.length > 0 ? l(v, y[0]) : !i.current.noIsolation;
        S && v.cancelable && v.preventDefault();
      }
    }
  }, []), d = u.useCallback(function(p, v, w, C) {
    var y = { name: p, delta: v, target: w, should: C, shadowParent: Xu(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(S) {
        return S !== y;
      });
    }, 1);
  }, []), f = u.useCallback(function(p) {
    n.current = nn(p), o.current = void 0;
  }, []), m = u.useCallback(function(p) {
    d(p.type, Zr(p), p.target, l(p, e.lockRef.current));
  }, []), g = u.useCallback(function(p) {
    d(p.type, nn(p), p.target, l(p, e.lockRef.current));
  }, []);
  u.useEffect(function() {
    return yt.push(a), e.setCallbacks({
      onScrollCapture: m,
      onWheelCapture: m,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", c, wt), document.addEventListener("touchmove", c, wt), document.addEventListener("touchstart", f, wt), function() {
      yt = yt.filter(function(p) {
        return p !== a;
      }), document.removeEventListener("wheel", c, wt), document.removeEventListener("touchmove", c, wt), document.removeEventListener("touchstart", f, wt);
    };
  }, []);
  var x = e.removeScrollBar, b = e.inert;
  return u.createElement(
    u.Fragment,
    null,
    b ? u.createElement(a, { styles: Uu(r) }) : null,
    x ? u.createElement(Fu, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Xu(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const qu = Ru(ta, Yu);
var _n = u.forwardRef(function(e, t) {
  return u.createElement(Nn, Le({}, e, { ref: t, sideCar: qu }));
});
_n.classNames = Nn.classNames;
var Ju = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, St = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), rn = {}, oo = 0, aa = function(e) {
  return e && (e.host || aa(e.parentNode));
}, Qu = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = aa(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, ed = function(e, t, n, o) {
  var r = Qu(t, Array.isArray(e) ? e : [e]);
  rn[n] || (rn[n] = /* @__PURE__ */ new WeakMap());
  var a = rn[n], i = [], l = /* @__PURE__ */ new Set(), c = new Set(r), d = function(m) {
    !m || l.has(m) || (l.add(m), d(m.parentNode));
  };
  r.forEach(d);
  var f = function(m) {
    !m || c.has(m) || Array.prototype.forEach.call(m.children, function(g) {
      if (l.has(g))
        f(g);
      else
        try {
          var x = g.getAttribute(o), b = x !== null && x !== "false", p = (St.get(g) || 0) + 1, v = (a.get(g) || 0) + 1;
          St.set(g, p), a.set(g, v), i.push(g), p === 1 && b && on.set(g, !0), v === 1 && g.setAttribute(n, "true"), b || g.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", g, w);
        }
    });
  };
  return f(t), l.clear(), oo++, function() {
    i.forEach(function(m) {
      var g = St.get(m) - 1, x = a.get(m) - 1;
      St.set(m, g), a.set(m, x), g || (on.has(m) || m.removeAttribute(o), on.delete(m)), x || m.removeAttribute(n);
    }), oo--, oo || (St = /* @__PURE__ */ new WeakMap(), St = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), rn = {});
  };
}, Bo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = Ju(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), ed(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, An = "Dialog", [ia] = He(An), [td, Be] = ia(An), la = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, l = u.useRef(null), c = u.useRef(null), [d, f] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: An
  });
  return /* @__PURE__ */ s.jsx(
    td,
    {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: Pe(),
      titleId: Pe(),
      descriptionId: Pe(),
      open: d,
      onOpenChange: f,
      onOpenToggle: u.useCallback(() => f((m) => !m), [f]),
      modal: i,
      children: n
    }
  );
};
la.displayName = An;
var ca = "DialogTrigger", ua = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(ca, n), a = ne(t, r.triggerRef);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Wo(r.open),
        ...o,
        ref: a,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
  }
);
ua.displayName = ca;
var nd = "DialogPortal", [M4, da] = ia(nd, {
  forceMount: void 0
}), pn = "DialogOverlay", fa = u.forwardRef(
  (e, t) => {
    const n = da(pn, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Be(pn, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: /* @__PURE__ */ s.jsx(rd, { ...r, ref: t }) }) : null;
  }
);
fa.displayName = pn;
var od = /* @__PURE__ */ ut("DialogOverlay.RemoveScroll"), rd = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(pn, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s.jsx(_n, { as: od, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          "data-state": Wo(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), dt = "DialogContent", pa = u.forwardRef(
  (e, t) => {
    const n = da(dt, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = Be(dt, e.__scopeDialog);
    return /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: a.modal ? /* @__PURE__ */ s.jsx(sd, { ...r, ref: t }) : /* @__PURE__ */ s.jsx(ad, { ...r, ref: t }) });
  }
);
pa.displayName = dt;
var sd = u.forwardRef(
  (e, t) => {
    const n = Be(dt, e.__scopeDialog), o = u.useRef(null), r = ne(t, n.contentRef, o);
    return u.useEffect(() => {
      const a = o.current;
      if (a) return Bo(a);
    }, []), /* @__PURE__ */ s.jsx(
      ma,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: F(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, l = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || l) && a.preventDefault();
        }),
        onFocusOutside: F(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), ad = u.forwardRef(
  (e, t) => {
    const n = Be(dt, e.__scopeDialog), o = u.useRef(!1), r = u.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      ma,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, l;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (l = n.triggerRef.current) == null || l.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, d;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ma = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, l = Be(dt, n), c = u.useRef(null), d = ne(t, c);
    return $o(), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        Pn,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ s.jsx(
            Wt,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": Wo(l.open),
              ...i,
              ref: d,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
        /* @__PURE__ */ s.jsx(id, { titleId: l.titleId }),
        /* @__PURE__ */ s.jsx(cd, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), zo = "DialogTitle", ha = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(zo, n);
    return /* @__PURE__ */ s.jsx(V.h2, { id: r.titleId, ...o, ref: t });
  }
);
ha.displayName = zo;
var ga = "DialogDescription", va = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(ga, n);
    return /* @__PURE__ */ s.jsx(V.p, { id: r.descriptionId, ...o, ref: t });
  }
);
va.displayName = ga;
var xa = "DialogClose", Ca = u.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = Be(xa, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: F(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
Ca.displayName = xa;
function Wo(e) {
  return e ? "open" : "closed";
}
var ba = "DialogTitleWarning", [P4, wa] = E1(ba, {
  contentName: dt,
  titleName: zo,
  docsSlug: "dialog"
}), id = ({ titleId: e }) => {
  const t = wa(ba), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return u.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, ld = "DialogDescriptionWarning", cd = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${wa(ld).contentName}}.`;
  return u.useEffect(() => {
    var a;
    const r = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, ud = la, dd = ua, fd = fa, pd = pa, md = ha, hd = va, ya = Ca;
function Sa(e) {
  const t = u.useRef({ value: e, previous: e });
  return u.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function gd(e) {
  const [t, n] = u.useState(void 0);
  return pe(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, l;
        if ("borderBoxSize" in a) {
          const c = a.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          i = d.inlineSize, l = d.blockSize;
        } else
          i = e.offsetWidth, l = e.offsetHeight;
        n({ width: i, height: l });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
const vd = ["top", "right", "bottom", "left"], Qe = Math.min, Ze = Math.max, mn = Math.round, sn = Math.floor, Ue = (e) => ({
  x: e,
  y: e
}), xd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Ea(e, t, n) {
  return Ze(e, Qe(t, n));
}
function Ke(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function et(e) {
  return e.split("-")[0];
}
function At(e) {
  return e.split("-")[1];
}
function Go(e) {
  return e === "x" ? "y" : "x";
}
function Zo(e) {
  return e === "y" ? "height" : "width";
}
function De(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function Uo(e) {
  return Go(De(e));
}
function Cd(e, t, n) {
  n === void 0 && (n = !1);
  const o = At(e), r = Uo(e), a = Zo(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = hn(i)), [i, hn(i)];
}
function bd(e) {
  const t = hn(e);
  return [go(e), t, go(t)];
}
function go(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Kr = ["left", "right"], Yr = ["right", "left"], wd = ["top", "bottom"], yd = ["bottom", "top"];
function Sd(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Yr : Kr : t ? Kr : Yr;
    case "left":
    case "right":
      return t ? wd : yd;
    default:
      return [];
  }
}
function Ed(e, t, n, o) {
  const r = At(e);
  let a = Sd(et(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(go)))), a;
}
function hn(e) {
  const t = et(e);
  return xd[t] + e.slice(t.length);
}
function Rd(e) {
  var t, n, o, r;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (o = e.bottom) != null ? o : 0,
    left: (r = e.left) != null ? r : 0
  };
}
function Ra(e) {
  return typeof e != "number" ? Rd(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function gn(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Xr(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = De(t), i = Uo(t), l = Zo(i), c = et(t), d = a === "y", f = o.x + o.width / 2 - r.width / 2, m = o.y + o.height / 2 - r.height / 2, g = o[l] / 2 - r[l] / 2;
  let x;
  switch (c) {
    case "top":
      x = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      x = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      x = {
        x: o.x + o.width,
        y: m
      };
      break;
    case "left":
      x = {
        x: o.x - r.width,
        y: m
      };
      break;
    default:
      x = {
        x: o.x,
        y: o.y
      };
  }
  const b = At(t);
  return b && (x[i] += g * (b === "end" ? 1 : -1) * (n && d ? -1 : 1)), x;
}
async function jd(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: l,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: m = "floating",
    altBoundary: g = !1,
    padding: x = 0
  } = Ke(t, e), b = Ra(x), v = l[g ? m === "floating" ? "reference" : "floating" : m], w = gn(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(v))) == null || n ? v : v.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: f,
    strategy: c
  })), C = m === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, y = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l.floating)), S = await (a.isElement == null ? void 0 : a.isElement(y)) && await (a.getScale == null ? void 0 : a.getScale(y)) || {
    x: 1,
    y: 1
  }, E = gn(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: c
  }) : C);
  return {
    top: (w.top - E.top + b.top) / S.y,
    bottom: (E.bottom - w.bottom + b.bottom) / S.y,
    left: (w.left - E.left + b.left) / S.x,
    right: (E.right - w.right + b.right) / S.x
  };
}
const Md = 50, Pd = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, l = i.detectOverflow ? i : {
    ...i,
    detectOverflow: jd
  }, c = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let d = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: f,
    y: m
  } = Xr(d, o, c), g = o, x = 0;
  const b = {};
  for (let p = 0; p < a.length; p++) {
    const v = a[p];
    if (!v)
      continue;
    const {
      name: w,
      fn: C
    } = v, {
      x: y,
      y: S,
      data: E,
      reset: j
    } = await C({
      x: f,
      y: m,
      initialPlacement: o,
      placement: g,
      strategy: r,
      middlewareData: b,
      rects: d,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    f = y ?? f, m = S ?? m, b[w] = {
      ...b[w],
      ...E
    }, j && x < Md && (x++, typeof j == "object" && (j.placement && (g = j.placement), j.rects && (d = j.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : j.rects), {
      x: f,
      y: m
    } = Xr(d, g, c)), p = -1);
  }
  return {
    x: f,
    y: m,
    placement: g,
    strategy: r,
    middlewareData: b
  };
}, Nd = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: l,
      middlewareData: c
    } = t, {
      element: d,
      padding: f = 0
    } = Ke(e, t) || {};
    if (d == null)
      return {};
    const m = Ra(f), g = {
      x: n,
      y: o
    }, x = Uo(r), b = Zo(x), p = await i.getDimensions(d), v = x === "y", w = v ? "top" : "left", C = v ? "bottom" : "right", y = v ? "clientHeight" : "clientWidth", S = a.reference[b] + a.reference[x] - g[x] - a.floating[b], E = g[x] - a.reference[x], j = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(d));
    let M = j ? j[y] : 0;
    (!M || !await (i.isElement == null ? void 0 : i.isElement(j))) && (M = l.floating[y] || a.floating[b]);
    const R = S / 2 - E / 2, _ = M / 2 - p[b] / 2 - 1, L = Qe(m[w], _), B = Qe(m[C], _), X = M - p[b] - B, $ = M / 2 - p[b] / 2 + R, z = Ea(L, $, X), G = !c.arrow && At(r) != null && $ !== z && a.reference[b] / 2 - ($ < L ? L : B) - p[b] / 2 < 0, D = G ? $ < L ? $ - L : $ - X : 0;
    return {
      [x]: g[x] + D,
      data: {
        [x]: z,
        centerOffset: $ - z - D,
        ...G && {
          alignmentOffset: D
        }
      },
      reset: G
    };
  }
}), _d = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: l,
        platform: c,
        elements: d
      } = t, {
        mainAxis: f = !0,
        crossAxis: m = !0,
        fallbackPlacements: g,
        fallbackStrategy: x = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: p = !0,
        ...v
      } = Ke(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const w = et(r), C = De(l), y = et(l) === l, S = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), E = g || (y || !p ? [hn(l)] : bd(l)), j = b !== "none";
      !g && j && E.push(...Ed(l, p, b, S));
      const M = [l, ...E], R = await c.detectOverflow(t, v), _ = [];
      let L = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (f && _.push(R[w]), m) {
        const z = Cd(r, i, S);
        _.push(R[z[0]], R[z[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: _
      }], !_.every((z) => z <= 0)) {
        var B, X;
        const z = (((B = a.flip) == null ? void 0 : B.index) || 0) + 1, G = M[z];
        if (G && (!(m === "alignment" ? C !== De(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((P) => De(P.placement) === C ? P.overflows[0] > 0 : !0)))
          return {
            data: {
              index: z,
              overflows: L
            },
            reset: {
              placement: G
            }
          };
        let D = (X = L.filter((Z) => Z.overflows[0] <= 0).sort((Z, P) => Z.overflows[1] - P.overflows[1])[0]) == null ? void 0 : X.placement;
        if (!D)
          switch (x) {
            case "bestFit": {
              var $;
              const Z = ($ = L.filter((P) => {
                if (j) {
                  const te = De(P.placement);
                  return te === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  te === "y";
                }
                return !0;
              }).map((P) => [P.placement, P.overflows.filter((te) => te > 0).reduce((te, de) => te + de, 0)]).sort((P, te) => P[1] - te[1])[0]) == null ? void 0 : $[0];
              Z && (D = Z);
              break;
            }
            case "initialPlacement":
              D = l;
              break;
          }
        if (r !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function qr(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Jr(e) {
  return vd.some((t) => e[t] >= 0);
}
const Ad = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n,
        platform: o
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Ke(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await o.detectOverflow(t, {
            ...a,
            elementContext: "reference"
          }), l = qr(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: Jr(l)
            }
          };
        }
        case "escaped": {
          const i = await o.detectOverflow(t, {
            ...a,
            altBoundary: !0
          }), l = qr(i, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: Jr(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, ja = /* @__PURE__ */ new Set(["left", "top"]);
async function kd(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = et(n), l = At(n), c = De(n) === "y", d = ja.has(i) ? -1 : 1, f = a && c ? -1 : 1, m = Ke(t, e);
  let {
    mainAxis: g,
    crossAxis: x,
    alignmentAxis: b
  } = typeof m == "number" ? {
    mainAxis: m,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: m.mainAxis || 0,
    crossAxis: m.crossAxis || 0,
    alignmentAxis: m.alignmentAxis
  };
  return l && typeof b == "number" && (x = l === "end" ? b * -1 : b), c ? {
    x: x * f,
    y: g * d
  } : {
    x: g * d,
    y: x * f
  };
}
const Td = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: l
      } = t, c = await kd(t, e);
      return i === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: i
        }
      };
    }
  };
}, Id = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: l = !1,
        limiter: c = {
          fn: (C) => {
            let {
              x: y,
              y: S
            } = C;
            return {
              x: y,
              y: S
            };
          }
        },
        ...d
      } = Ke(e, t), f = {
        x: n,
        y: o
      }, m = await a.detectOverflow(t, d), g = De(r), x = Go(g);
      let b = f[x], p = f[g];
      const v = (C, y) => Ea(y + m[C === "y" ? "top" : "left"], y, y - m[C === "y" ? "bottom" : "right"]);
      i && (b = v(x, b)), l && (p = v(g, p));
      const w = c.fn({
        ...t,
        [x]: b,
        [g]: p
      });
      return {
        ...w,
        data: {
          x: w.x - n,
          y: w.y - o,
          enabled: {
            [x]: i,
            [g]: l
          }
        }
      };
    }
  };
}, Od = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        rects: l,
        middlewareData: c
      } = t, {
        offset: d = 0,
        mainAxis: f = !0,
        crossAxis: m = !0
      } = Ke(e, t), g = {
        x: r,
        y: a
      }, x = De(i), b = Go(x);
      let p = g[b], v = g[x];
      const w = Ke(d, t), C = typeof w == "number" ? {
        mainAxis: w,
        crossAxis: 0
      } : {
        mainAxis: (n = w.mainAxis) != null ? n : 0,
        crossAxis: (o = w.crossAxis) != null ? o : 0
      };
      if (f) {
        const E = b === "y" ? "height" : "width", j = l.reference[b] - l.floating[E] + C.mainAxis, M = l.reference[b] + l.reference[E] - C.mainAxis;
        p < j ? p = j : p > M && (p = M);
      }
      if (m) {
        var y, S;
        const E = b === "y" ? "width" : "height", j = ja.has(et(i)), M = l.reference[x] - l.floating[E] + (j && ((y = c.offset) == null ? void 0 : y[x]) || 0) + (j ? 0 : C.crossAxis), R = l.reference[x] + l.reference[E] + (j ? 0 : ((S = c.offset) == null ? void 0 : S[x]) || 0) - (j ? C.crossAxis : 0);
        v < M ? v = M : v > R && (v = R);
      }
      return {
        [b]: p,
        [x]: v
      };
    }
  };
}, Ld = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: o,
        platform: r,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...l
      } = Ke(e, t), c = await r.detectOverflow(t, l), d = et(n), f = At(n), m = De(n) === "y", {
        width: g,
        height: x
      } = o.floating;
      let b, p;
      d === "top" || d === "bottom" ? (b = d, p = f === (await (r.isRTL == null ? void 0 : r.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (p = d, b = f === "end" ? "top" : "bottom");
      const v = x - c.top - c.bottom, w = g - c.left - c.right, C = Qe(x - c[b], v), y = Qe(g - c[p], w), S = t.middlewareData.shift, E = !S;
      let j = C, M = y;
      S != null && S.enabled.x && (M = w), S != null && S.enabled.y && (j = v), E && !f && (m ? M = g - 2 * Ze(c.left, c.right) : j = x - 2 * Ze(c.top, c.bottom)), await i({
        ...t,
        availableWidth: M,
        availableHeight: j
      });
      const R = await r.getDimensions(a.floating);
      return g !== R.width || x !== R.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function kn() {
  return typeof window < "u";
}
function kt(e) {
  return Ma(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ye(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ye(e) {
  var t;
  return (t = (Ma(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ma(e) {
  return kn() ? e instanceof Node || e instanceof ye(e).Node : !1;
}
function Fe(e) {
  return kn() ? e instanceof Element || e instanceof ye(e).Element : !1;
}
function nt(e) {
  return kn() ? e instanceof HTMLElement || e instanceof ye(e).HTMLElement : !1;
}
function Qr(e) {
  return !kn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ye(e).ShadowRoot;
}
function Tn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = Ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && r !== "inline" && r !== "contents";
}
function Dd(e) {
  return /^(table|td|th)$/.test(kt(e));
}
function In(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const Fd = /transform|translate|scale|rotate|perspective|filter/, Vd = /paint|layout|strict|content/, ct = (e) => !!e && e !== "none";
let ro;
function Ko(e) {
  const t = Fe(e) ? Ve(e) : e;
  return ct(t.transform) || ct(t.translate) || ct(t.scale) || ct(t.rotate) || ct(t.perspective) || !Yo() && (ct(t.backdropFilter) || ct(t.filter)) || Fd.test(t.willChange || "") || Vd.test(t.contain || "");
}
function Hd(e) {
  let t = ft(e);
  for (; nt(t) && !Vt(t); ) {
    if (Ko(t))
      return t;
    if (In(t))
      return null;
    t = ft(t);
  }
  return null;
}
function Yo() {
  return ro == null && (ro = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), ro;
}
function Vt(e) {
  return /^(html|body|#document)$/.test(kt(e));
}
function Ve(e) {
  return ye(e).getComputedStyle(e);
}
function On(e) {
  return Fe(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ft(e) {
  if (kt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Qr(e) && e.host || // Fallback.
    Ye(e)
  );
  return Qr(t) ? t.host : t;
}
function Pa(e) {
  const t = ft(e);
  return Vt(t) ? (e.ownerDocument || e).body : nt(t) && Tn(t) ? t : Pa(t);
}
function Ht(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Pa(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = ye(r);
  if (a) {
    const l = vo(i);
    return t.concat(i, i.visualViewport || [], Tn(r) ? r : [], l && n ? Ht(l) : []);
  } else
    return t.concat(r, Ht(r, [], n));
}
function vo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Na(e) {
  const t = Ve(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = nt(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, l = mn(n) !== a || mn(o) !== i;
  return l && (n = a, o = i), {
    width: n,
    height: o,
    $: l
  };
}
function Xo(e) {
  return Fe(e) ? e : e.contextElement;
}
function Rt(e) {
  const t = Xo(e);
  if (!nt(t))
    return Ue(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = Na(t);
  let i = (a ? mn(n.width) : n.width) / o, l = (a ? mn(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: i,
    y: l
  };
}
const $d = /* @__PURE__ */ Ue(0);
function _a(e) {
  const t = ye(e);
  return !Yo() || !t.visualViewport ? $d : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Bd(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === ye(e);
}
function pt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = Xo(e);
  let i = Ue(1);
  t && (o ? Fe(o) && (i = Rt(o)) : i = Rt(e));
  const l = Bd(a, n, o) ? _a(a) : Ue(0);
  let c = (r.left + l.x) / i.x, d = (r.top + l.y) / i.y, f = r.width / i.x, m = r.height / i.y;
  if (a && o) {
    const g = ye(a), x = Fe(o) ? ye(o) : o;
    let b = g, p = vo(b);
    for (; p && x !== b; ) {
      const v = Rt(p), w = p.getBoundingClientRect(), C = Ve(p), y = w.left + (p.clientLeft + parseFloat(C.paddingLeft)) * v.x, S = w.top + (p.clientTop + parseFloat(C.paddingTop)) * v.y;
      c *= v.x, d *= v.y, f *= v.x, m *= v.y, c += y, d += S, b = ye(p), p = vo(b);
    }
  }
  return gn({
    width: f,
    height: m,
    x: c,
    y: d
  });
}
function Ln(e, t) {
  const n = On(e).scrollLeft;
  return t ? t.left + n : pt(Ye(e)).left + n;
}
function Aa(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - Ln(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function zd(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = Ye(o), l = t ? In(t.floating) : !1;
  if (o === i || l && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = Ue(1);
  const f = Ue(0), m = nt(o);
  if ((m || !a) && ((kt(o) !== "body" || Tn(i)) && (c = On(o)), m)) {
    const x = pt(o);
    d = Rt(o), f.x = x.x + o.clientLeft, f.y = x.y + o.clientTop;
  }
  const g = i && !m && !a ? Aa(i, c) : Ue(0);
  return {
    width: n.width * d.x,
    height: n.height * d.y,
    x: n.x * d.x - c.scrollLeft * d.x + f.x + g.x,
    y: n.y * d.y - c.scrollTop * d.y + f.y + g.y
  };
}
function Wd(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function Gd(e) {
  const t = On(e), n = e.ownerDocument.body, o = Ze(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = Ze(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -t.scrollLeft + Ln(e);
  const i = -t.scrollTop;
  return Ve(n).direction === "rtl" && (a += Ze(e.clientWidth, n.clientWidth) - o), {
    width: o,
    height: r,
    x: a,
    y: i
  };
}
const Zd = 25;
function Ud(e, t, n) {
  n === void 0 && (n = "viewport");
  const o = n === "layoutViewport", r = ye(e), a = Ye(e), i = r.visualViewport;
  let l = a.clientWidth, c = a.clientHeight, d = 0, f = 0;
  if (i) {
    const g = !Yo() || t === "fixed";
    o ? g || (d = -i.offsetLeft, f = -i.offsetTop) : (l = i.width, c = i.height, g && (d = i.offsetLeft, f = i.offsetTop));
  }
  if (Ln(a) <= 0) {
    const g = a.ownerDocument, x = g.body, b = getComputedStyle(x), p = g.compatMode === "CSS1Compat" && parseFloat(b.marginLeft) + parseFloat(b.marginRight) || 0, v = Math.abs(a.clientWidth - x.clientWidth - p), w = getComputedStyle(a).scrollbarGutter === "stable both-edges" ? v / 2 : v;
    w <= Zd && (l -= w);
  }
  return {
    width: l,
    height: c,
    x: d,
    y: f
  };
}
function Kd(e, t) {
  const n = pt(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = Rt(e), i = e.clientWidth * a.x, l = e.clientHeight * a.y, c = r * a.x, d = o * a.y;
  return {
    width: i,
    height: l,
    x: c,
    y: d
  };
}
function es(e, t, n) {
  let o;
  if (t === "viewport" || t === "layoutViewport")
    o = Ud(e, n, t);
  else if (t === "document")
    o = Gd(Ye(e));
  else if (Fe(t))
    o = Kd(t, n);
  else {
    const r = _a(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return gn(o);
}
function Yd(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Ht(e, [], !1).filter((l) => Fe(l) && kt(l) !== "body"), r = null;
  const a = Ve(e).position === "fixed";
  let i = a ? ft(e) : e;
  for (; Fe(i) && !Vt(i); ) {
    const l = Ve(i), c = Ko(i), d = r ? r.position : a ? "fixed" : "";
    !c && (d === "fixed" || d === "absolute" && l.position === "static") ? o = o.filter((m) => m !== i) : r = l, i = ft(i);
  }
  return t.set(e, o), o;
}
function Xd(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? In(t) ? [] : Yd(t, this._c) : [].concat(n), o], l = es(t, i[0], r);
  let c = l.top, d = l.right, f = l.bottom, m = l.left;
  for (let g = 1; g < i.length; g++) {
    const x = es(t, i[g], r);
    c = Ze(x.top, c), d = Qe(x.right, d), f = Qe(x.bottom, f), m = Ze(x.left, m);
  }
  return {
    width: d - m,
    height: f - c,
    x: m,
    y: c
  };
}
function qd(e) {
  const {
    width: t,
    height: n
  } = Na(e);
  return {
    width: t,
    height: n
  };
}
function Jd(e, t, n) {
  const o = nt(t), r = Ye(t), a = n === "fixed", i = pt(e, !0, a, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Ue(0);
  if ((o || !a) && ((kt(t) !== "body" || Tn(r)) && (l = On(t)), o)) {
    const g = pt(t, !0, a, t);
    c.x = g.x + t.clientLeft, c.y = g.y + t.clientTop;
  }
  !o && r && (c.x = Ln(r));
  const d = r && !o && !a ? Aa(r, l) : Ue(0), f = i.left + l.scrollLeft - c.x - d.x, m = i.top + l.scrollTop - c.y - d.y;
  return {
    x: f,
    y: m,
    width: i.width,
    height: i.height
  };
}
function so(e) {
  return Ve(e).position === "static";
}
function ts(e, t) {
  if (!nt(e) || Ve(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ye(e) === n && (n = n.ownerDocument.body), n;
}
function ka(e, t) {
  const n = ye(e);
  if (In(e))
    return n;
  if (!nt(e)) {
    let r = ft(e);
    for (; r && !Vt(r); ) {
      if (Fe(r) && !so(r))
        return r;
      r = ft(r);
    }
    return n;
  }
  let o = ts(e, t);
  for (; o && Dd(o) && so(o); )
    o = ts(o, t);
  return o && Vt(o) && so(o) && !Ko(o) ? n : o || Hd(e) || n;
}
const Qd = async function(e) {
  const t = this.getOffsetParent || ka, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Jd(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function e2(e) {
  return Ve(e).direction === "rtl";
}
const t2 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: zd,
  getDocumentElement: Ye,
  getClippingRect: Xd,
  getOffsetParent: ka,
  getElementRects: Qd,
  getClientRects: Wd,
  getDimensions: qd,
  getScale: Rt,
  isElement: Fe,
  isRTL: e2
};
function Ta(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function n2(e, t, n) {
  let o = null, r;
  const a = Ye(e);
  function i() {
    var f;
    clearTimeout(r), (f = o) == null || f.disconnect(), o = null;
  }
  function l(f, m) {
    f === void 0 && (f = !1), m === void 0 && (m = 1), i();
    const g = e.getBoundingClientRect(), {
      left: x,
      top: b,
      width: p,
      height: v
    } = g;
    if (f || t(), !p || !v)
      return;
    const w = sn(b), C = sn(a.clientWidth - (x + p)), y = sn(a.clientHeight - (b + v)), S = sn(x), j = {
      rootMargin: -w + "px " + -C + "px " + -y + "px " + -S + "px",
      threshold: Ze(0, Qe(1, m)) || 1
    };
    let M = !0;
    function R(_) {
      const L = _[0].intersectionRatio;
      if (!Ta(g, e.getBoundingClientRect()))
        return l();
      if (L !== m) {
        if (!M)
          return l();
        L ? l(!1, L) : r = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      M = !1;
    }
    try {
      o = new IntersectionObserver(R, {
        ...j,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      o = new IntersectionObserver(R, j);
    }
    o.observe(e);
  }
  const c = ye(e), d = () => l(n);
  return c.addEventListener("resize", d), l(!0), () => {
    c.removeEventListener("resize", d), i();
  };
}
function o2(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = o, d = Xo(e), f = r || a ? [...d ? Ht(d) : [], ...t ? Ht(t) : []] : [];
  f.forEach((w) => {
    r && w.addEventListener("scroll", n), a && w.addEventListener("resize", n);
  });
  const m = d && l ? n2(d, n, a) : null;
  let g = -1, x = null;
  i && (x = new ResizeObserver((w) => {
    let [C] = w;
    C && C.target === d && x && t && (x.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var y;
      (y = x) == null || y.observe(t);
    })), n();
  }), d && !c && x.observe(d), t && x.observe(t));
  let b, p = c ? pt(e) : null;
  c && v();
  function v() {
    const w = pt(e);
    p && !Ta(p, w) && n(), p = w, b = requestAnimationFrame(v);
  }
  return n(), () => {
    var w;
    f.forEach((C) => {
      r && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), m == null || m(), (w = x) == null || w.disconnect(), x = null, c && cancelAnimationFrame(b);
  };
}
const r2 = Td, s2 = Id, a2 = _d, i2 = Ld, l2 = Ad, ns = Nd, c2 = Od, u2 = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = n ?? {}, a = {
    ...t2,
    ...r.platform,
    _c: o
  };
  return Pd(e, t, {
    ...r,
    platform: a
  });
};
var d2 = typeof document < "u", f2 = function() {
}, un = d2 ? Ul : f2;
function vn(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!vn(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !vn(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Ia(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function os(e, t) {
  const n = Ia(e);
  return Math.round(t * n) / n;
}
function ao(e) {
  const t = u.useRef(e);
  return un(() => {
    t.current = e;
  }), t;
}
function p2(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: d
  } = e, [f, m] = u.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, x] = u.useState(o);
  vn(g, o) || x(o);
  const [b, p] = u.useState(null), [v, w] = u.useState(null), C = u.useCallback((P) => {
    P !== j.current && (j.current = P, p(P));
  }, []), y = u.useCallback((P) => {
    P !== M.current && (M.current = P, w(P));
  }, []), S = a || b, E = i || v, j = u.useRef(null), M = u.useRef(null), R = u.useRef(f), _ = c != null, L = ao(c), B = ao(r), X = ao(d), $ = u.useCallback(() => {
    if (!j.current || !M.current)
      return;
    const P = {
      placement: t,
      strategy: n,
      middleware: g
    };
    B.current && (P.platform = B.current), u2(j.current, M.current, P).then((te) => {
      const de = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: X.current !== !1
      };
      z.current && !vn(R.current, de) && (R.current = de, Sn.flushSync(() => {
        m(de);
      }));
    });
  }, [g, t, n, B, X]);
  un(() => {
    d === !1 && R.current.isPositioned && (R.current.isPositioned = !1, m((P) => ({
      ...P,
      isPositioned: !1
    })));
  }, [d]);
  const z = u.useRef(!1);
  un(() => (z.current = !0, () => {
    z.current = !1;
  }), []), un(() => {
    if (S && (j.current = S), E && (M.current = E), S && E) {
      if (L.current)
        return L.current(S, E, $);
      $();
    }
  }, [S, E, $, L, _]);
  const G = u.useMemo(() => ({
    reference: j,
    floating: M,
    setReference: C,
    setFloating: y
  }), [C, y]), D = u.useMemo(() => ({
    reference: S,
    floating: E
  }), [S, E]), Z = u.useMemo(() => {
    const P = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return P;
    const te = os(D.floating, f.x), de = os(D.floating, f.y);
    return l ? {
      ...P,
      transform: "translate(" + te + "px, " + de + "px)",
      ...Ia(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: te,
      top: de
    };
  }, [n, l, D.floating, f.x, f.y]);
  return u.useMemo(() => ({
    ...f,
    update: $,
    refs: G,
    elements: D,
    floatingStyles: Z
  }), [f, $, G, D, Z]);
}
const m2 = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? ns({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? ns({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, h2 = (e, t) => {
  const n = r2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, g2 = (e, t) => {
  const n = s2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, v2 = (e, t) => ({
  fn: c2(e).fn,
  options: [e, t]
}), x2 = (e, t) => {
  const n = a2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, C2 = (e, t) => {
  const n = i2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, b2 = (e, t) => {
  const n = l2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
}, w2 = (e, t) => {
  const n = m2(e);
  return {
    name: n.name,
    fn: n.fn,
    options: [e, t]
  };
};
var y2 = "Arrow", Oa = u.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ s.jsx(
    V.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ s.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Oa.displayName = y2;
var S2 = Oa, qo = "Popper", [La, Dn] = He(qo), [E2, Da] = La(qo), Fa = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = u.useState(null);
  return /* @__PURE__ */ s.jsx(E2, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Fa.displayName = qo;
var Va = "PopperAnchor", Ha = u.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = Da(Va, n), i = u.useRef(null), l = ne(t, i), c = u.useRef(null);
    return u.useEffect(() => {
      const d = c.current;
      c.current = (o == null ? void 0 : o.current) || i.current, d !== c.current && a.onAnchorChange(c.current);
    }), o ? null : /* @__PURE__ */ s.jsx(V.div, { ...r, ref: l });
  }
);
Ha.displayName = Va;
var Jo = "PopperContent", [R2, j2] = La(Jo), $a = u.forwardRef(
  (e, t) => {
    var k, Q, ae, U, q, K;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: f = 0,
      sticky: m = "partial",
      hideWhenDetached: g = !1,
      updatePositionStrategy: x = "optimized",
      onPlaced: b,
      ...p
    } = e, v = Da(Jo, n), [w, C] = u.useState(null), y = ne(t, (ve) => C(ve)), [S, E] = u.useState(null), j = gd(S), M = (j == null ? void 0 : j.width) ?? 0, R = (j == null ? void 0 : j.height) ?? 0, _ = o + (a !== "center" ? "-" + a : ""), L = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, B = Array.isArray(d) ? d : [d], X = B.length > 0, $ = {
      padding: L,
      boundary: B.filter(P2),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: X
    }, { refs: z, floatingStyles: G, placement: D, isPositioned: Z, middlewareData: P } = p2({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: _,
      whileElementsMounted: (...ve) => o2(...ve, {
        animationFrame: x === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        h2({ mainAxis: r + R, alignmentAxis: i }),
        c && g2({
          mainAxis: !0,
          crossAxis: !1,
          limiter: m === "partial" ? v2() : void 0,
          ...$
        }),
        c && x2({ ...$ }),
        C2({
          ...$,
          apply: ({ elements: ve, rects: je, availableWidth: Ie, availableHeight: _e }) => {
            const { width: Xe, height: Ut } = je.reference, ze = ve.floating.style;
            ze.setProperty("--radix-popper-available-width", `${Ie}px`), ze.setProperty("--radix-popper-available-height", `${_e}px`), ze.setProperty("--radix-popper-anchor-width", `${Xe}px`), ze.setProperty("--radix-popper-anchor-height", `${Ut}px`);
          }
        }),
        S && w2({ element: S, padding: l }),
        N2({ arrowWidth: M, arrowHeight: R }),
        g && b2({ strategy: "referenceHidden", ...$ })
      ]
    }), [te, de] = Wa(D), ge = Ce(b);
    pe(() => {
      Z && (ge == null || ge());
    }, [Z, ge]);
    const Re = (k = P.arrow) == null ? void 0 : k.x, le = (Q = P.arrow) == null ? void 0 : Q.y, ce = ((ae = P.arrow) == null ? void 0 : ae.centerOffset) !== 0, [Se, be] = u.useState();
    return pe(() => {
      w && be(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ s.jsx(
      "div",
      {
        ref: z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: Z ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Se,
          "--radix-popper-transform-origin": [
            (U = P.transformOrigin) == null ? void 0 : U.x,
            (q = P.transformOrigin) == null ? void 0 : q.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((K = P.hide) == null ? void 0 : K.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s.jsx(
          R2,
          {
            scope: n,
            placedSide: te,
            onArrowChange: E,
            arrowX: Re,
            arrowY: le,
            shouldHideArrow: ce,
            children: /* @__PURE__ */ s.jsx(
              V.div,
              {
                "data-side": te,
                "data-align": de,
                ...p,
                ref: y,
                style: {
                  ...p.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: Z ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
$a.displayName = Jo;
var Ba = "PopperArrow", M2 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, za = u.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = j2(Ba, o), i = M2[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s.jsx(
          S2,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
za.displayName = Ba;
function P2(e) {
  return e !== null;
}
var N2 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, w, C;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((v = r.arrow) == null ? void 0 : v.centerOffset) !== 0, l = i ? 0 : e.arrowWidth, c = i ? 0 : e.arrowHeight, [d, f] = Wa(n), m = { start: "0%", center: "50%", end: "100%" }[f], g = (((w = r.arrow) == null ? void 0 : w.x) ?? 0) + l / 2, x = (((C = r.arrow) == null ? void 0 : C.y) ?? 0) + c / 2;
    let b = "", p = "";
    return d === "bottom" ? (b = i ? m : `${g}px`, p = `${-c}px`) : d === "top" ? (b = i ? m : `${g}px`, p = `${o.floating.height + c}px`) : d === "right" ? (b = `${-c}px`, p = i ? m : `${x}px`) : d === "left" && (b = `${o.floating.width + c}px`, p = i ? m : `${x}px`), { data: { x: b, y: p } };
  }
});
function Wa(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Ga = Fa, Qo = Ha, Za = $a, Ua = za, io = "rovingFocusGroup.onEntryFocus", _2 = { bubbles: !1, cancelable: !0 }, Gt = "RovingFocusGroup", [xo, Ka, A2] = Bt(Gt), [k2, Ya] = He(
  Gt,
  [A2]
), [T2, I2] = k2(Gt), Xa = u.forwardRef(
  (e, t) => /* @__PURE__ */ s.jsx(xo.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s.jsx(xo.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ s.jsx(O2, { ...e, ref: t }) }) })
);
Xa.displayName = Gt;
var O2 = u.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: l,
    onCurrentTabStopIdChange: c,
    onEntryFocus: d,
    preventScrollOnEntryFocus: f = !1,
    ...m
  } = e, g = u.useRef(null), x = ne(t, g), b = zt(a), [p, v] = Ee({
    prop: i,
    defaultProp: l ?? null,
    onChange: c,
    caller: Gt
  }), [w, C] = u.useState(!1), y = Ce(d), S = Ka(n), E = u.useRef(!1), [j, M] = u.useState(0);
  return u.useEffect(() => {
    const R = g.current;
    if (R)
      return R.addEventListener(io, y), () => R.removeEventListener(io, y);
  }, [y]), /* @__PURE__ */ s.jsx(
    T2,
    {
      scope: n,
      orientation: o,
      dir: b,
      loop: r,
      currentTabStopId: p,
      onItemFocus: u.useCallback(
        (R) => v(R),
        [v]
      ),
      onItemShiftTab: u.useCallback(() => C(!0), []),
      onFocusableItemAdd: u.useCallback(
        () => M((R) => R + 1),
        []
      ),
      onFocusableItemRemove: u.useCallback(
        () => M((R) => R - 1),
        []
      ),
      children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          tabIndex: w || j === 0 ? -1 : 0,
          "data-orientation": o,
          ...m,
          ref: x,
          style: { outline: "none", ...e.style },
          onMouseDown: F(e.onMouseDown, () => {
            E.current = !0;
          }),
          onFocus: F(e.onFocus, (R) => {
            const _ = !E.current;
            if (R.target === R.currentTarget && _ && !w) {
              const L = new CustomEvent(io, _2);
              if (R.currentTarget.dispatchEvent(L), !L.defaultPrevented) {
                const B = S().filter((D) => D.focusable), X = B.find((D) => D.active), $ = B.find((D) => D.id === p), G = [X, $, ...B].filter(
                  Boolean
                ).map((D) => D.ref.current);
                Qa(G, f);
              }
            }
            E.current = !1;
          }),
          onBlur: F(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), qa = "RovingFocusGroupItem", Ja = u.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...l
    } = e, c = Pe(), d = a || c, f = I2(qa, n), m = f.currentTabStopId === d, g = Ka(n), { onFocusableItemAdd: x, onFocusableItemRemove: b, currentTabStopId: p } = f;
    return u.useEffect(() => {
      if (o)
        return x(), () => b();
    }, [o, x, b]), /* @__PURE__ */ s.jsx(
      xo.ItemSlot,
      {
        scope: n,
        id: d,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ s.jsx(
          V.span,
          {
            tabIndex: m ? 0 : -1,
            "data-orientation": f.orientation,
            ...l,
            ref: t,
            onMouseDown: F(e.onMouseDown, (v) => {
              o ? f.onItemFocus(d) : v.preventDefault();
            }),
            onFocus: F(e.onFocus, () => f.onItemFocus(d)),
            onKeyDown: F(e.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                f.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const w = F2(v, f.orientation, f.dir);
              if (w !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let y = g().filter((S) => S.focusable).map((S) => S.ref.current);
                if (w === "last") y.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && y.reverse();
                  const S = y.indexOf(v.currentTarget);
                  y = f.loop ? V2(y, S + 1) : y.slice(S + 1);
                }
                setTimeout(() => Qa(y));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: m, hasTabStop: p != null }) : i
          }
        )
      }
    );
  }
);
Ja.displayName = qa;
var L2 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function D2(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function F2(e, t, n) {
  const o = D2(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return L2[o];
}
function Qa(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function V2(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var H2 = Xa, $2 = Ja, gt = "NavigationMenu", [er, ei, B2] = Bt(gt), [Co, z2, W2] = Bt(gt), [tr] = He(
  gt,
  [B2, W2]
), [G2, Ne] = tr(gt), [Z2, U2] = tr(gt), ti = u.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      delayDuration: i = 200,
      skipDelayDuration: l = 300,
      orientation: c = "horizontal",
      dir: d,
      ...f
    } = e, [m, g] = u.useState(null), x = ne(t, (_) => g(_)), b = zt(d), p = u.useRef(0), v = u.useRef(0), w = u.useRef(0), [C, y] = u.useState(!0), [S, E] = Ee({
      prop: o,
      onChange: (_) => {
        const L = _ !== "", B = l > 0;
        L ? (window.clearTimeout(w.current), B && y(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => y(!0),
          l
        )), r == null || r(_);
      },
      defaultProp: a ?? "",
      caller: gt
    }), j = u.useCallback(() => {
      window.clearTimeout(v.current), v.current = window.setTimeout(() => E(""), 150);
    }, [E]), M = u.useCallback(
      (_) => {
        window.clearTimeout(v.current), E(_);
      },
      [E]
    ), R = u.useCallback(
      (_) => {
        S === _ ? window.clearTimeout(v.current) : p.current = window.setTimeout(() => {
          window.clearTimeout(v.current), E(_);
        }, i);
      },
      [S, E, i]
    );
    return u.useEffect(() => () => {
      window.clearTimeout(p.current), window.clearTimeout(v.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ s.jsx(
      ni,
      {
        scope: n,
        isRootMenu: !0,
        value: S,
        dir: b,
        orientation: c,
        rootNavigationMenu: m,
        onTriggerEnter: (_) => {
          window.clearTimeout(p.current), C ? R(_) : M(_);
        },
        onTriggerLeave: () => {
          window.clearTimeout(p.current), j();
        },
        onContentEnter: () => window.clearTimeout(v.current),
        onContentLeave: j,
        onItemSelect: (_) => {
          E((L) => L === _ ? "" : _);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ s.jsx(
          V.nav,
          {
            "aria-label": "Main",
            "data-orientation": c,
            dir: b,
            ...f,
            ref: x
          }
        )
      }
    );
  }
);
ti.displayName = gt;
var bo = "NavigationMenuSub", K2 = u.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      ...l
    } = e, c = Ne(bo, n), [d, f] = Ee({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: bo
    });
    return /* @__PURE__ */ s.jsx(
      ni,
      {
        scope: n,
        isRootMenu: !1,
        value: d,
        dir: c.dir,
        orientation: i,
        rootNavigationMenu: c.rootNavigationMenu,
        onTriggerEnter: (m) => f(m),
        onItemSelect: (m) => f(m),
        onItemDismiss: () => f(""),
        children: /* @__PURE__ */ s.jsx(V.div, { "data-orientation": i, ...l, ref: t })
      }
    );
  }
);
K2.displayName = bo;
var ni = (e) => {
  const {
    scope: t,
    isRootMenu: n,
    rootNavigationMenu: o,
    dir: r,
    orientation: a,
    children: i,
    value: l,
    onItemSelect: c,
    onItemDismiss: d,
    onTriggerEnter: f,
    onTriggerLeave: m,
    onContentEnter: g,
    onContentLeave: x
  } = e, [b, p] = u.useState(null), [v, w] = u.useState(/* @__PURE__ */ new Map()), [C, y] = u.useState(null);
  return /* @__PURE__ */ s.jsx(
    G2,
    {
      scope: t,
      isRootMenu: n,
      rootNavigationMenu: o,
      value: l,
      previousValue: Sa(l),
      baseId: Pe(),
      dir: r,
      orientation: a,
      viewport: b,
      onViewportChange: p,
      indicatorTrack: C,
      onIndicatorTrackChange: y,
      onTriggerEnter: Ce(f),
      onTriggerLeave: Ce(m),
      onContentEnter: Ce(g),
      onContentLeave: Ce(x),
      onItemSelect: Ce(c),
      onItemDismiss: Ce(d),
      onViewportContentChange: u.useCallback((S, E) => {
        w((j) => (j.set(S, E), new Map(j)));
      }, []),
      onViewportContentRemove: u.useCallback((S) => {
        w((E) => E.has(S) ? (E.delete(S), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ s.jsx(er.Provider, { scope: t, children: /* @__PURE__ */ s.jsx(Z2, { scope: t, items: v, children: i }) })
    }
  );
}, oi = "NavigationMenuList", ri = u.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Ne(oi, n), a = /* @__PURE__ */ s.jsx(V.ul, { "data-orientation": r.orientation, ...o, ref: t });
    return /* @__PURE__ */ s.jsx(V.div, { style: { position: "relative" }, ref: r.onIndicatorTrackChange, children: /* @__PURE__ */ s.jsx(er.Slot, { scope: n, children: r.isRootMenu ? /* @__PURE__ */ s.jsx(mi, { asChild: !0, children: a }) : a }) });
  }
);
ri.displayName = oi;
var si = "NavigationMenuItem", [Y2, ai] = tr(si), ii = u.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, value: o, ...r } = e, a = Pe(), i = o || a || "LEGACY_REACT_AUTO_VALUE", l = u.useRef(null), c = u.useRef(null), d = u.useRef(null), f = u.useRef(() => {
    }), m = u.useRef(!1), g = u.useCallback((b = "start") => {
      if (l.current) {
        f.current();
        const p = yo(l.current);
        p.length && rr(b === "start" ? p : p.reverse());
      }
    }, []), x = u.useCallback(() => {
      if (l.current) {
        const b = yo(l.current);
        b.length && (f.current = nf(b));
      }
    }, []);
    return /* @__PURE__ */ s.jsx(
      Y2,
      {
        scope: n,
        value: i,
        triggerRef: c,
        contentRef: l,
        focusProxyRef: d,
        wasEscapeCloseRef: m,
        onEntryKeyDown: g,
        onFocusProxyEnter: g,
        onRootContentClose: x,
        onContentFocusOutside: x,
        children: /* @__PURE__ */ s.jsx(V.li, { ...r, ref: t })
      }
    );
  }
);
ii.displayName = si;
var wo = "NavigationMenuTrigger", li = u.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, disabled: o, ...r } = e, a = Ne(wo, e.__scopeNavigationMenu), i = ai(wo, e.__scopeNavigationMenu), l = u.useRef(null), c = ne(l, i.triggerRef, t), d = gi(a.baseId, i.value), f = vi(a.baseId, i.value), m = u.useRef(!1), g = u.useRef(!1), x = i.value === a.value;
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(er.ItemSlot, { scope: n, value: i.value, children: /* @__PURE__ */ s.jsx(hi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        id: d,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": sr(x),
        "aria-expanded": x,
        "aria-controls": f,
        ...r,
        ref: c,
        onPointerEnter: F(e.onPointerEnter, () => {
          g.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: F(
          e.onPointerMove,
          xn(() => {
            o || g.current || i.wasEscapeCloseRef.current || m.current || (a.onTriggerEnter(i.value), m.current = !0);
          })
        ),
        onPointerLeave: F(
          e.onPointerLeave,
          xn(() => {
            o || (a.onTriggerLeave(), m.current = !1);
          })
        ),
        onClick: F(e.onClick, () => {
          a.onItemSelect(i.value), g.current = x;
        }),
        onKeyDown: F(e.onKeyDown, (b) => {
          const v = { horizontal: "ArrowDown", vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[a.orientation];
          x && b.key === v && (i.onEntryKeyDown(), b.preventDefault());
        })
      }
    ) }) }),
    x && /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        S1,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (b) => {
            const p = i.contentRef.current, v = b.relatedTarget, w = v === l.current, C = p == null ? void 0 : p.contains(v);
            (w || !C) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      a.viewport && /* @__PURE__ */ s.jsx("span", { "aria-owns": f })
    ] })
  ] });
});
li.displayName = wo;
var X2 = "NavigationMenuLink", rs = "navigationMenu.linkSelect", ci = u.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, active: o, onSelect: r, ...a } = e;
    return /* @__PURE__ */ s.jsx(hi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
      V.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...a,
        ref: t,
        onClick: F(
          e.onClick,
          (i) => {
            const l = i.target, c = new CustomEvent(rs, {
              bubbles: !0,
              cancelable: !0
            });
            if (l.addEventListener(rs, (d) => r == null ? void 0 : r(d), { once: !0 }), fo(l, c), !c.defaultPrevented && !i.metaKey) {
              const d = new CustomEvent(dn, {
                bubbles: !0,
                cancelable: !0
              });
              fo(l, d);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
ci.displayName = X2;
var nr = "NavigationMenuIndicator", ui = u.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ne(nr, e.__scopeNavigationMenu), a = !!r.value;
  return r.indicatorTrack ? ps.createPortal(
    /* @__PURE__ */ s.jsx($e, { present: n || a, children: /* @__PURE__ */ s.jsx(q2, { ...o, ref: t }) }),
    r.indicatorTrack
  ) : null;
});
ui.displayName = nr;
var q2 = u.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, ...o } = e, r = Ne(nr, n), a = ei(n), [i, l] = u.useState(
    null
  ), [c, d] = u.useState(null), f = r.orientation === "horizontal", m = !!r.value;
  u.useEffect(() => {
    var p;
    const b = (p = a().find((v) => v.value === r.value)) == null ? void 0 : p.ref.current;
    b && l(b);
  }, [a, r.value]);
  const g = () => {
    i && d({
      size: f ? i.offsetWidth : i.offsetHeight,
      offset: f ? i.offsetLeft : i.offsetTop
    });
  };
  return So(i, g), So(r.indicatorTrack, g), c ? /* @__PURE__ */ s.jsx(
    V.div,
    {
      "aria-hidden": !0,
      "data-state": m ? "visible" : "hidden",
      "data-orientation": r.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...f ? {
          left: 0,
          width: c.size + "px",
          transform: `translateX(${c.offset}px)`
        } : {
          top: 0,
          height: c.size + "px",
          transform: `translateY(${c.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), jt = "NavigationMenuContent", di = u.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = Ne(jt, e.__scopeNavigationMenu), a = ai(jt, e.__scopeNavigationMenu), i = ne(a.contentRef, t), l = a.value === r.value, c = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...o
  };
  return r.viewport ? /* @__PURE__ */ s.jsx(J2, { forceMount: n, ...c, ref: i }) : /* @__PURE__ */ s.jsx($e, { present: n || l, children: /* @__PURE__ */ s.jsx(
    fi,
    {
      "data-state": sr(l),
      ...c,
      ref: i,
      onPointerEnter: F(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: F(
        e.onPointerLeave,
        xn(r.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !l && r.isRootMenu ? "none" : void 0,
        ...c.style
      }
    }
  ) });
});
di.displayName = jt;
var J2 = u.forwardRef((e, t) => {
  const n = Ne(jt, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: r } = n;
  return pe(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), pe(() => () => r(e.value), [e.value, r]), null;
}), dn = "navigationMenu.rootContentDismiss", fi = u.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: n,
    value: o,
    triggerRef: r,
    focusProxyRef: a,
    wasEscapeCloseRef: i,
    onRootContentClose: l,
    onContentFocusOutside: c,
    ...d
  } = e, f = Ne(jt, n), m = u.useRef(null), g = ne(m, t), x = gi(f.baseId, o), b = vi(f.baseId, o), p = ei(n), v = u.useRef(null), { onItemDismiss: w } = f;
  u.useEffect(() => {
    const y = m.current;
    if (f.isRootMenu && y) {
      const S = () => {
        var E;
        w(), l(), y.contains(document.activeElement) && ((E = r.current) == null || E.focus());
      };
      return y.addEventListener(dn, S), () => y.removeEventListener(dn, S);
    }
  }, [f.isRootMenu, e.value, r, w, l]);
  const C = u.useMemo(() => {
    const S = p().map((L) => L.value);
    f.dir === "rtl" && S.reverse();
    const E = S.indexOf(f.value), j = S.indexOf(f.previousValue), M = o === f.value, R = j === S.indexOf(o);
    if (!M && !R) return v.current;
    const _ = (() => {
      if (E !== j) {
        if (M && j !== -1) return E > j ? "from-end" : "from-start";
        if (R && E !== -1) return E > j ? "to-start" : "to-end";
      }
      return null;
    })();
    return v.current = _, _;
  }, [f.previousValue, f.value, f.dir, p, o]);
  return /* @__PURE__ */ s.jsx(mi, { asChild: !0, children: /* @__PURE__ */ s.jsx(
    Wt,
    {
      id: b,
      "aria-labelledby": x,
      "data-motion": C,
      "data-orientation": f.orientation,
      ...d,
      ref: g,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var S;
        const y = new Event(dn, {
          bubbles: !0,
          cancelable: !0
        });
        (S = m.current) == null || S.dispatchEvent(y);
      },
      onFocusOutside: F(e.onFocusOutside, (y) => {
        var E;
        c();
        const S = y.target;
        (E = f.rootNavigationMenu) != null && E.contains(S) && y.preventDefault();
      }),
      onPointerDownOutside: F(e.onPointerDownOutside, (y) => {
        var M;
        const S = y.target, E = p().some((R) => {
          var _;
          return (_ = R.ref.current) == null ? void 0 : _.contains(S);
        }), j = f.isRootMenu && ((M = f.viewport) == null ? void 0 : M.contains(S));
        (E || j || !f.isRootMenu) && y.preventDefault();
      }),
      onKeyDown: F(e.onKeyDown, (y) => {
        var j;
        const S = y.altKey || y.ctrlKey || y.metaKey;
        if (y.key === "Tab" && !S) {
          const M = yo(y.currentTarget), R = document.activeElement, _ = M.findIndex((X) => X === R), B = y.shiftKey ? M.slice(0, _).reverse() : M.slice(_ + 1, M.length);
          rr(B) ? y.preventDefault() : (j = a.current) == null || j.focus();
        }
      }),
      onEscapeKeyDown: F(e.onEscapeKeyDown, (y) => {
        i.current = !0;
      })
    }
  ) });
}), or = "NavigationMenuViewport", pi = u.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, a = !!Ne(or, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ s.jsx($e, { present: n || a, children: /* @__PURE__ */ s.jsx(Q2, { ...o, ref: t }) });
});
pi.displayName = or;
var Q2 = u.forwardRef((e, t) => {
  const { __scopeNavigationMenu: n, children: o, ...r } = e, a = Ne(or, n), i = ne(t, a.onViewportChange), l = U2(
    jt,
    e.__scopeNavigationMenu
  ), [c, d] = u.useState(null), [f, m] = u.useState(null), g = c ? (c == null ? void 0 : c.width) + "px" : void 0, x = c ? (c == null ? void 0 : c.height) + "px" : void 0, b = !!a.value, p = b ? a.value : a.previousValue;
  return So(f, () => {
    f && d({ width: f.offsetWidth, height: f.offsetHeight });
  }), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "data-state": sr(b),
      "data-orientation": a.orientation,
      ...r,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !b && a.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": g,
        "--radix-navigation-menu-viewport-height": x,
        ...r.style
      },
      onPointerEnter: F(e.onPointerEnter, a.onContentEnter),
      onPointerLeave: F(e.onPointerLeave, xn(a.onContentLeave)),
      children: Array.from(l.items).map(([w, { ref: C, forceMount: y, ...S }]) => {
        const E = p === w;
        return /* @__PURE__ */ s.jsx($e, { present: y || E, children: /* @__PURE__ */ s.jsx(
          fi,
          {
            ...S,
            ref: Ao(C, (j) => {
              E && j && m(j);
            })
          }
        ) }, w);
      })
    }
  );
}), ef = "FocusGroup", mi = u.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = Ne(ef, n);
    return /* @__PURE__ */ s.jsx(Co.Provider, { scope: n, children: /* @__PURE__ */ s.jsx(Co.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(V.div, { dir: r.dir, ...o, ref: t }) }) });
  }
), ss = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], tf = "FocusGroupItem", hi = u.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: n, ...o } = e, r = z2(n), a = Ne(tf, n);
    return /* @__PURE__ */ s.jsx(Co.ItemSlot, { scope: n, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        ...o,
        ref: t,
        onKeyDown: F(e.onKeyDown, (i) => {
          if (["Home", "End", ...ss].includes(i.key)) {
            let c = r().map((m) => m.ref.current);
            if ([a.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && c.reverse(), ss.includes(i.key)) {
              const m = c.indexOf(i.currentTarget);
              c = c.slice(m + 1);
            }
            setTimeout(() => rr(c)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function yo(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function rr(e) {
  const t = document.activeElement;
  return e.some((n) => n === t ? !0 : (n.focus(), document.activeElement !== t));
}
function nf(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const n = t.dataset.tabindex;
      t.setAttribute("tabindex", n);
    });
  };
}
function So(e, t) {
  const n = Ce(t);
  pe(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
function sr(e) {
  return e ? "open" : "closed";
}
function gi(e, t) {
  return `${e}-trigger-${t}`;
}
function vi(e, t) {
  return `${e}-content-${t}`;
}
function xn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var of = ti, rf = ri, sf = ii, af = li, lf = ci, cf = ui, uf = di, df = pi;
function as(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
var Fn = "Popover", [xi] = He(Fn, [
  Dn
]), Zt = Dn(), [ff, ot] = xi(Fn), Ci = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !1
  } = e, l = Zt(t), c = u.useRef(null), [d, f] = u.useState(!1), [m, g] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: Fn
  });
  return /* @__PURE__ */ s.jsx(Ga, { ...l, children: /* @__PURE__ */ s.jsx(
    ff,
    {
      scope: t,
      contentId: Pe(),
      triggerRef: c,
      open: m,
      onOpenChange: g,
      onOpenToggle: u.useCallback(() => g((x) => !x), [g]),
      hasCustomAnchor: d,
      onCustomAnchorAdd: u.useCallback(() => f(!0), []),
      onCustomAnchorRemove: u.useCallback(() => f(!1), []),
      modal: i,
      children: n
    }
  ) });
};
Ci.displayName = Fn;
var bi = "PopoverAnchor", wi = u.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(bi, n), a = Zt(n), { onCustomAnchorAdd: i, onCustomAnchorRemove: l } = r;
    return u.useEffect(() => (i(), () => l()), [i, l]), /* @__PURE__ */ s.jsx(Qo, { ...a, ...o, ref: t });
  }
);
wi.displayName = bi;
var yi = "PopoverTrigger", Si = u.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(yi, n), a = Zt(n), i = ne(t, r.triggerRef), l = /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": Pi(r.open),
        ...o,
        ref: i,
        onClick: F(e.onClick, r.onOpenToggle)
      }
    );
    return r.hasCustomAnchor ? l : /* @__PURE__ */ s.jsx(Qo, { asChild: !0, ...a, children: l });
  }
);
Si.displayName = yi;
var ar = "PopoverPortal", [pf, mf] = xi(ar, {
  forceMount: void 0
}), Ei = (e) => {
  const { __scopePopover: t, forceMount: n, children: o, container: r } = e, a = ot(ar, t);
  return /* @__PURE__ */ s.jsx(pf, { scope: t, forceMount: n, children: /* @__PURE__ */ s.jsx($e, { present: n || a.open, children: /* @__PURE__ */ s.jsx(Ho, { asChild: !0, container: r, children: o }) }) });
};
Ei.displayName = ar;
var Mt = "PopoverContent", Ri = u.forwardRef(
  (e, t) => {
    const n = mf(Mt, e.__scopePopover), { forceMount: o = n.forceMount, ...r } = e, a = ot(Mt, e.__scopePopover);
    return /* @__PURE__ */ s.jsx($e, { present: o || a.open, children: a.modal ? /* @__PURE__ */ s.jsx(gf, { ...r, ref: t }) : /* @__PURE__ */ s.jsx(vf, { ...r, ref: t }) });
  }
);
Ri.displayName = Mt;
var hf = /* @__PURE__ */ ut("PopoverContent.RemoveScroll"), gf = u.forwardRef(
  (e, t) => {
    const n = ot(Mt, e.__scopePopover), o = u.useRef(null), r = ne(t, o), a = u.useRef(!1);
    return u.useEffect(() => {
      const i = o.current;
      if (i) return Bo(i);
    }, []), /* @__PURE__ */ s.jsx(_n, { as: hf, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
      ji,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: F(e.onCloseAutoFocus, (i) => {
          var l;
          i.preventDefault(), a.current || (l = n.triggerRef.current) == null || l.focus();
        }),
        onPointerDownOutside: F(
          e.onPointerDownOutside,
          (i) => {
            const l = i.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || c;
            a.current = d;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: F(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), vf = u.forwardRef(
  (e, t) => {
    const n = ot(Mt, e.__scopePopover), o = u.useRef(!1), r = u.useRef(!1);
    return /* @__PURE__ */ s.jsx(
      ji,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, l;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (l = n.triggerRef.current) == null || l.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var c, d;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((d = n.triggerRef.current) == null ? void 0 : d.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ji = u.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: o,
      onOpenAutoFocus: r,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: i,
      onEscapeKeyDown: l,
      onPointerDownOutside: c,
      onFocusOutside: d,
      onInteractOutside: f,
      ...m
    } = e, g = ot(Mt, n), x = Zt(n);
    return $o(), /* @__PURE__ */ s.jsx(
      Pn,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: r,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ s.jsx(
          Wt,
          {
            asChild: !0,
            disableOutsidePointerEvents: i,
            onInteractOutside: f,
            onEscapeKeyDown: l,
            onPointerDownOutside: c,
            onFocusOutside: d,
            onDismiss: () => g.onOpenChange(!1),
            children: /* @__PURE__ */ s.jsx(
              Za,
              {
                "data-state": Pi(g.open),
                role: "dialog",
                id: g.contentId,
                ...x,
                ...m,
                ref: t,
                style: {
                  ...m.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Mi = "PopoverClose", xf = u.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = ot(Mi, n);
    return /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: F(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
xf.displayName = Mi;
var Cf = "PopoverArrow", bf = u.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...o } = e, r = Zt(n);
    return /* @__PURE__ */ s.jsx(Ua, { ...r, ...o, ref: t });
  }
);
bf.displayName = Cf;
function Pi(e) {
  return e ? "open" : "closed";
}
var wf = Ci, yf = wi, Sf = Si, Ef = Ei, Rf = Ri, jf = [" ", "Enter", "ArrowUp", "ArrowDown"], Mf = [" ", "Enter"], mt = "Select", [Vn, Hn, Pf] = Bt(mt), [Tt] = He(mt, [
  Pf,
  Dn
]), $n = Dn(), [Nf, rt] = Tt(mt), [_f, Af] = Tt(mt), Ni = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: l,
    onValueChange: c,
    dir: d,
    name: f,
    autoComplete: m,
    disabled: g,
    required: x,
    form: b
  } = e, p = $n(t), [v, w] = u.useState(null), [C, y] = u.useState(null), [S, E] = u.useState(!1), j = zt(d), [M, R] = Ee({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: mt
  }), [_, L] = Ee({
    prop: i,
    defaultProp: l,
    onChange: c,
    caller: mt
  }), B = u.useRef(null), X = v ? b || !!v.closest("form") : !0, [$, z] = u.useState(/* @__PURE__ */ new Set()), G = Array.from($).map((D) => D.props.value).join(";");
  return /* @__PURE__ */ s.jsx(Ga, { ...p, children: /* @__PURE__ */ s.jsxs(
    Nf,
    {
      required: x,
      scope: t,
      trigger: v,
      onTriggerChange: w,
      valueNode: C,
      onValueNodeChange: y,
      valueNodeHasChildren: S,
      onValueNodeHasChildrenChange: E,
      contentId: Pe(),
      value: _,
      onValueChange: L,
      open: M,
      onOpenChange: R,
      dir: j,
      triggerPointerDownPosRef: B,
      disabled: g,
      children: [
        /* @__PURE__ */ s.jsx(Vn.Provider, { scope: t, children: /* @__PURE__ */ s.jsx(
          _f,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: u.useCallback((D) => {
              z((Z) => new Set(Z).add(D));
            }, []),
            onNativeOptionRemove: u.useCallback((D) => {
              z((Z) => {
                const P = new Set(Z);
                return P.delete(D), P;
              });
            }, []),
            children: n
          }
        ) }),
        X ? /* @__PURE__ */ s.jsxs(
          el,
          {
            "aria-hidden": !0,
            required: x,
            tabIndex: -1,
            name: f,
            autoComplete: m,
            value: _,
            onChange: (D) => L(D.target.value),
            disabled: g,
            form: b,
            children: [
              _ === void 0 ? /* @__PURE__ */ s.jsx("option", { value: "" }) : null,
              Array.from($)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
Ni.displayName = mt;
var _i = "SelectTrigger", Ai = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = $n(n), i = rt(_i, n), l = i.disabled || o, c = ne(t, i.onTriggerChange), d = Hn(n), f = u.useRef("touch"), [m, g, x] = nl((p) => {
      const v = d().filter((y) => !y.disabled), w = v.find((y) => y.value === i.value), C = ol(v, p, w);
      C !== void 0 && i.onValueChange(C.value);
    }), b = (p) => {
      l || (i.onOpenChange(!0), x()), p && (i.triggerPointerDownPosRef.current = {
        x: Math.round(p.pageX),
        y: Math.round(p.pageY)
      });
    };
    return /* @__PURE__ */ s.jsx(Qo, { asChild: !0, ...a, children: /* @__PURE__ */ s.jsx(
      V.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: l,
        "data-disabled": l ? "" : void 0,
        "data-placeholder": tl(i.value) ? "" : void 0,
        ...r,
        ref: c,
        onClick: F(r.onClick, (p) => {
          p.currentTarget.focus(), f.current !== "mouse" && b(p);
        }),
        onPointerDown: F(r.onPointerDown, (p) => {
          f.current = p.pointerType;
          const v = p.target;
          v.hasPointerCapture(p.pointerId) && v.releasePointerCapture(p.pointerId), p.button === 0 && p.ctrlKey === !1 && p.pointerType === "mouse" && (b(p), p.preventDefault());
        }),
        onKeyDown: F(r.onKeyDown, (p) => {
          const v = m.current !== "";
          !(p.ctrlKey || p.altKey || p.metaKey) && p.key.length === 1 && g(p.key), !(v && p.key === " ") && jf.includes(p.key) && (b(), p.preventDefault());
        })
      }
    ) });
  }
);
Ai.displayName = _i;
var ki = "SelectValue", Ti = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: i = "", ...l } = e, c = rt(ki, n), { onValueNodeHasChildrenChange: d } = c, f = a !== void 0, m = ne(t, c.onValueNodeChange);
    return pe(() => {
      d(f);
    }, [d, f]), /* @__PURE__ */ s.jsx(
      V.span,
      {
        ...l,
        ref: m,
        style: { pointerEvents: "none" },
        children: tl(c.value) ? /* @__PURE__ */ s.jsx(s.Fragment, { children: i }) : a
      }
    );
  }
);
Ti.displayName = ki;
var kf = "SelectIcon", Ii = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ s.jsx(V.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
Ii.displayName = kf;
var Tf = "SelectPortal", Oi = (e) => /* @__PURE__ */ s.jsx(Ho, { asChild: !0, ...e });
Oi.displayName = Tf;
var ht = "SelectContent", Li = u.forwardRef(
  (e, t) => {
    const n = rt(ht, e.__scopeSelect), [o, r] = u.useState();
    if (pe(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? Sn.createPortal(
        /* @__PURE__ */ s.jsx(Di, { scope: e.__scopeSelect, children: /* @__PURE__ */ s.jsx(Vn.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ s.jsx("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ s.jsx(Fi, { ...e, ref: t });
  }
);
Li.displayName = ht;
var Ae = 10, [Di, st] = Tt(ht), If = "SelectContentImpl", Of = /* @__PURE__ */ ut("SelectContent.RemoveScroll"), Fi = u.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: l,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: g,
      collisionPadding: x,
      sticky: b,
      hideWhenDetached: p,
      avoidCollisions: v,
      //
      ...w
    } = e, C = rt(ht, n), [y, S] = u.useState(null), [E, j] = u.useState(null), M = ne(t, (k) => S(k)), [R, _] = u.useState(null), [L, B] = u.useState(
      null
    ), X = Hn(n), [$, z] = u.useState(!1), G = u.useRef(!1);
    u.useEffect(() => {
      if (y) return Bo(y);
    }, [y]), $o();
    const D = u.useCallback(
      (k) => {
        const [Q, ...ae] = X().map((K) => K.ref.current), [U] = ae.slice(-1), q = document.activeElement;
        for (const K of k)
          if (K === q || (K == null || K.scrollIntoView({ block: "nearest" }), K === Q && E && (E.scrollTop = 0), K === U && E && (E.scrollTop = E.scrollHeight), K == null || K.focus(), document.activeElement !== q)) return;
      },
      [X, E]
    ), Z = u.useCallback(
      () => D([R, y]),
      [D, R, y]
    );
    u.useEffect(() => {
      $ && Z();
    }, [$, Z]);
    const { onOpenChange: P, triggerPointerDownPosRef: te } = C;
    u.useEffect(() => {
      if (y) {
        let k = { x: 0, y: 0 };
        const Q = (U) => {
          var q, K;
          k = {
            x: Math.abs(Math.round(U.pageX) - (((q = te.current) == null ? void 0 : q.x) ?? 0)),
            y: Math.abs(Math.round(U.pageY) - (((K = te.current) == null ? void 0 : K.y) ?? 0))
          };
        }, ae = (U) => {
          k.x <= 10 && k.y <= 10 ? U.preventDefault() : y.contains(U.target) || P(!1), document.removeEventListener("pointermove", Q), te.current = null;
        };
        return te.current !== null && (document.addEventListener("pointermove", Q), document.addEventListener("pointerup", ae, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Q), document.removeEventListener("pointerup", ae, { capture: !0 });
        };
      }
    }, [y, P, te]), u.useEffect(() => {
      const k = () => P(!1);
      return window.addEventListener("blur", k), window.addEventListener("resize", k), () => {
        window.removeEventListener("blur", k), window.removeEventListener("resize", k);
      };
    }, [P]);
    const [de, ge] = nl((k) => {
      const Q = X().filter((q) => !q.disabled), ae = Q.find((q) => q.ref.current === document.activeElement), U = ol(Q, k, ae);
      U && setTimeout(() => U.ref.current.focus());
    }), Re = u.useCallback(
      (k, Q, ae) => {
        const U = !G.current && !ae;
        (C.value !== void 0 && C.value === Q || U) && (_(k), U && (G.current = !0));
      },
      [C.value]
    ), le = u.useCallback(() => y == null ? void 0 : y.focus(), [y]), ce = u.useCallback(
      (k, Q, ae) => {
        const U = !G.current && !ae;
        (C.value !== void 0 && C.value === Q || U) && B(k);
      },
      [C.value]
    ), Se = o === "popper" ? Eo : Vi, be = Se === Eo ? {
      side: l,
      sideOffset: c,
      align: d,
      alignOffset: f,
      arrowPadding: m,
      collisionBoundary: g,
      collisionPadding: x,
      sticky: b,
      hideWhenDetached: p,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ s.jsx(
      Di,
      {
        scope: n,
        content: y,
        viewport: E,
        onViewportChange: j,
        itemRefCallback: Re,
        selectedItem: R,
        onItemLeave: le,
        itemTextRefCallback: ce,
        focusSelectedItem: Z,
        selectedItemText: L,
        position: o,
        isPositioned: $,
        searchRef: de,
        children: /* @__PURE__ */ s.jsx(_n, { as: Of, allowPinchZoom: !0, children: /* @__PURE__ */ s.jsx(
          Pn,
          {
            asChild: !0,
            trapped: C.open,
            onMountAutoFocus: (k) => {
              k.preventDefault();
            },
            onUnmountAutoFocus: F(r, (k) => {
              var Q;
              (Q = C.trigger) == null || Q.focus({ preventScroll: !0 }), k.preventDefault();
            }),
            children: /* @__PURE__ */ s.jsx(
              Wt,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (k) => k.preventDefault(),
                onDismiss: () => C.onOpenChange(!1),
                children: /* @__PURE__ */ s.jsx(
                  Se,
                  {
                    role: "listbox",
                    id: C.contentId,
                    "data-state": C.open ? "open" : "closed",
                    dir: C.dir,
                    onContextMenu: (k) => k.preventDefault(),
                    ...w,
                    ...be,
                    onPlaced: () => z(!0),
                    ref: M,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: F(w.onKeyDown, (k) => {
                      const Q = k.ctrlKey || k.altKey || k.metaKey;
                      if (k.key === "Tab" && k.preventDefault(), !Q && k.key.length === 1 && ge(k.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(k.key)) {
                        let U = X().filter((q) => !q.disabled).map((q) => q.ref.current);
                        if (["ArrowUp", "End"].includes(k.key) && (U = U.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(k.key)) {
                          const q = k.target, K = U.indexOf(q);
                          U = U.slice(K + 1);
                        }
                        setTimeout(() => D(U)), k.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Fi.displayName = If;
var Lf = "SelectItemAlignedPosition", Vi = u.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = rt(ht, n), i = st(ht, n), [l, c] = u.useState(null), [d, f] = u.useState(null), m = ne(t, (M) => f(M)), g = Hn(n), x = u.useRef(!1), b = u.useRef(!0), { viewport: p, selectedItem: v, selectedItemText: w, focusSelectedItem: C } = i, y = u.useCallback(() => {
    if (a.trigger && a.valueNode && l && d && p && v && w) {
      const M = a.trigger.getBoundingClientRect(), R = d.getBoundingClientRect(), _ = a.valueNode.getBoundingClientRect(), L = w.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const q = L.left - R.left, K = _.left - q, ve = M.left - K, je = M.width + ve, Ie = Math.max(je, R.width), _e = window.innerWidth - Ae, Xe = as(K, [
          Ae,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ae, _e - Ie)
        ]);
        l.style.minWidth = je + "px", l.style.left = Xe + "px";
      } else {
        const q = R.right - L.right, K = window.innerWidth - _.right - q, ve = window.innerWidth - M.right - K, je = M.width + ve, Ie = Math.max(je, R.width), _e = window.innerWidth - Ae, Xe = as(K, [
          Ae,
          Math.max(Ae, _e - Ie)
        ]);
        l.style.minWidth = je + "px", l.style.right = Xe + "px";
      }
      const B = g(), X = window.innerHeight - Ae * 2, $ = p.scrollHeight, z = window.getComputedStyle(d), G = parseInt(z.borderTopWidth, 10), D = parseInt(z.paddingTop, 10), Z = parseInt(z.borderBottomWidth, 10), P = parseInt(z.paddingBottom, 10), te = G + D + $ + P + Z, de = Math.min(v.offsetHeight * 5, te), ge = window.getComputedStyle(p), Re = parseInt(ge.paddingTop, 10), le = parseInt(ge.paddingBottom, 10), ce = M.top + M.height / 2 - Ae, Se = X - ce, be = v.offsetHeight / 2, k = v.offsetTop + be, Q = G + D + k, ae = te - Q;
      if (Q <= ce) {
        const q = B.length > 0 && v === B[B.length - 1].ref.current;
        l.style.bottom = "0px";
        const K = d.clientHeight - p.offsetTop - p.offsetHeight, ve = Math.max(
          Se,
          be + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (q ? le : 0) + K + Z
        ), je = Q + ve;
        l.style.height = je + "px";
      } else {
        const q = B.length > 0 && v === B[0].ref.current;
        l.style.top = "0px";
        const ve = Math.max(
          ce,
          G + p.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (q ? Re : 0) + be
        ) + ae;
        l.style.height = ve + "px", p.scrollTop = Q - ce + p.offsetTop;
      }
      l.style.margin = `${Ae}px 0`, l.style.minHeight = de + "px", l.style.maxHeight = X + "px", o == null || o(), requestAnimationFrame(() => x.current = !0);
    }
  }, [
    g,
    a.trigger,
    a.valueNode,
    l,
    d,
    p,
    v,
    w,
    a.dir,
    o
  ]);
  pe(() => y(), [y]);
  const [S, E] = u.useState();
  pe(() => {
    d && E(window.getComputedStyle(d).zIndex);
  }, [d]);
  const j = u.useCallback(
    (M) => {
      M && b.current === !0 && (y(), C == null || C(), b.current = !1);
    },
    [y, C]
  );
  return /* @__PURE__ */ s.jsx(
    Ff,
    {
      scope: n,
      contentWrapper: l,
      shouldExpandOnScrollRef: x,
      onScrollButtonChange: j,
      children: /* @__PURE__ */ s.jsx(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: S
          },
          children: /* @__PURE__ */ s.jsx(
            V.div,
            {
              ...r,
              ref: m,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
Vi.displayName = Lf;
var Df = "SelectPopperPosition", Eo = u.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = Ae,
    ...a
  } = e, i = $n(n);
  return /* @__PURE__ */ s.jsx(
    Za,
    {
      ...i,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Eo.displayName = Df;
var [Ff, ir] = Tt(ht, {}), Ro = "SelectViewport", Hi = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = st(Ro, n), i = ir(Ro, n), l = ne(t, a.onViewportChange), c = u.useRef(0);
    return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ s.jsx(Vn.Slot, { scope: n, children: /* @__PURE__ */ s.jsx(
        V.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: l,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: F(r.onScroll, (d) => {
            const f = d.currentTarget, { contentWrapper: m, shouldExpandOnScrollRef: g } = i;
            if (g != null && g.current && m) {
              const x = Math.abs(c.current - f.scrollTop);
              if (x > 0) {
                const b = window.innerHeight - Ae * 2, p = parseFloat(m.style.minHeight), v = parseFloat(m.style.height), w = Math.max(p, v);
                if (w < b) {
                  const C = w + x, y = Math.min(b, C), S = C - y;
                  m.style.height = y + "px", m.style.bottom === "0px" && (f.scrollTop = S > 0 ? S : 0, m.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = f.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Hi.displayName = Ro;
var $i = "SelectGroup", [Vf, Hf] = Tt($i), Bi = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Pe();
    return /* @__PURE__ */ s.jsx(Vf, { scope: n, id: r, children: /* @__PURE__ */ s.jsx(V.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
Bi.displayName = $i;
var zi = "SelectLabel", Wi = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Hf(zi, n);
    return /* @__PURE__ */ s.jsx(V.div, { id: r.id, ...o, ref: t });
  }
);
Wi.displayName = zi;
var Cn = "SelectItem", [$f, Gi] = Tt(Cn), Zi = u.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, l = rt(Cn, n), c = st(Cn, n), d = l.value === o, [f, m] = u.useState(a ?? ""), [g, x] = u.useState(!1), b = ne(
      t,
      (C) => {
        var y;
        return (y = c.itemRefCallback) == null ? void 0 : y.call(c, C, o, r);
      }
    ), p = Pe(), v = u.useRef("touch"), w = () => {
      r || (l.onValueChange(o), l.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ s.jsx(
      $f,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: p,
        isSelected: d,
        onItemTextChange: u.useCallback((C) => {
          m((y) => y || ((C == null ? void 0 : C.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ s.jsx(
          Vn.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: f,
            children: /* @__PURE__ */ s.jsx(
              V.div,
              {
                role: "option",
                "aria-labelledby": p,
                "data-highlighted": g ? "" : void 0,
                "aria-selected": d && g,
                "data-state": d ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: b,
                onFocus: F(i.onFocus, () => x(!0)),
                onBlur: F(i.onBlur, () => x(!1)),
                onClick: F(i.onClick, () => {
                  v.current !== "mouse" && w();
                }),
                onPointerUp: F(i.onPointerUp, () => {
                  v.current === "mouse" && w();
                }),
                onPointerDown: F(i.onPointerDown, (C) => {
                  v.current = C.pointerType;
                }),
                onPointerMove: F(i.onPointerMove, (C) => {
                  var y;
                  v.current = C.pointerType, r ? (y = c.onItemLeave) == null || y.call(c) : v.current === "mouse" && C.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: F(i.onPointerLeave, (C) => {
                  var y;
                  C.currentTarget === document.activeElement && ((y = c.onItemLeave) == null || y.call(c));
                }),
                onKeyDown: F(i.onKeyDown, (C) => {
                  var S;
                  ((S = c.searchRef) == null ? void 0 : S.current) !== "" && C.key === " " || (Mf.includes(C.key) && w(), C.key === " " && C.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
Zi.displayName = Cn;
var Ft = "SelectItemText", Ui = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, i = rt(Ft, n), l = st(Ft, n), c = Gi(Ft, n), d = Af(Ft, n), [f, m] = u.useState(null), g = ne(
      t,
      (w) => m(w),
      c.onItemTextChange,
      (w) => {
        var C;
        return (C = l.itemTextRefCallback) == null ? void 0 : C.call(l, w, c.value, c.disabled);
      }
    ), x = f == null ? void 0 : f.textContent, b = u.useMemo(
      () => /* @__PURE__ */ s.jsx("option", { value: c.value, disabled: c.disabled, children: x }, c.value),
      [c.disabled, c.value, x]
    ), { onNativeOptionAdd: p, onNativeOptionRemove: v } = d;
    return pe(() => (p(b), () => v(b)), [p, v, b]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
      /* @__PURE__ */ s.jsx(V.span, { id: c.textId, ...a, ref: g }),
      c.isSelected && i.valueNode && !i.valueNodeHasChildren ? Sn.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
Ui.displayName = Ft;
var Ki = "SelectItemIndicator", Yi = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return Gi(Ki, n).isSelected ? /* @__PURE__ */ s.jsx(V.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
Yi.displayName = Ki;
var jo = "SelectScrollUpButton", Xi = u.forwardRef((e, t) => {
  const n = st(jo, e.__scopeSelect), o = ir(jo, e.__scopeSelect), [r, a] = u.useState(!1), i = ne(t, o.onScrollButtonChange);
  return pe(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const d = c.scrollTop > 0;
        a(d);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ s.jsx(
    Ji,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
Xi.displayName = jo;
var Mo = "SelectScrollDownButton", qi = u.forwardRef((e, t) => {
  const n = st(Mo, e.__scopeSelect), o = ir(Mo, e.__scopeSelect), [r, a] = u.useState(!1), i = ne(t, o.onScrollButtonChange);
  return pe(() => {
    if (n.viewport && n.isPositioned) {
      let l = function() {
        const d = c.scrollHeight - c.clientHeight, f = Math.ceil(c.scrollTop) < d;
        a(f);
      };
      const c = n.viewport;
      return l(), c.addEventListener("scroll", l), () => c.removeEventListener("scroll", l);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ s.jsx(
    Ji,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: l, selectedItem: c } = n;
        l && c && (l.scrollTop = l.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
qi.displayName = Mo;
var Ji = u.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = st("SelectScrollButton", n), i = u.useRef(null), l = Hn(n), c = u.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return u.useEffect(() => () => c(), [c]), pe(() => {
    var f;
    const d = l().find((m) => m.ref.current === document.activeElement);
    (f = d == null ? void 0 : d.ref.current) == null || f.scrollIntoView({ block: "nearest" });
  }, [l]), /* @__PURE__ */ s.jsx(
    V.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: F(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: F(r.onPointerMove, () => {
        var d;
        (d = a.onItemLeave) == null || d.call(a), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: F(r.onPointerLeave, () => {
        c();
      })
    }
  );
}), Bf = "SelectSeparator", Qi = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ s.jsx(V.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
Qi.displayName = Bf;
var Po = "SelectArrow", zf = u.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = $n(n), a = rt(Po, n), i = st(Po, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ s.jsx(Ua, { ...r, ...o, ref: t }) : null;
  }
);
zf.displayName = Po;
var Wf = "SelectBubbleInput", el = u.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = u.useRef(null), a = ne(o, r), i = Sa(t);
    return u.useEffect(() => {
      const l = r.current;
      if (!l) return;
      const c = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (i !== t && f) {
        const m = new Event("change", { bubbles: !0 });
        f.call(l, t), l.dispatchEvent(m);
      }
    }, [i, t]), /* @__PURE__ */ s.jsx(
      V.select,
      {
        ...n,
        style: { ...Ts, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
el.displayName = Wf;
function tl(e) {
  return e === "" || e === void 0;
}
function nl(e) {
  const t = Ce(e), n = u.useRef(""), o = u.useRef(0), r = u.useCallback(
    (i) => {
      const l = n.current + i;
      t(l), (function c(d) {
        n.current = d, window.clearTimeout(o.current), d !== "" && (o.current = window.setTimeout(() => c(""), 1e3));
      })(l);
    },
    [t]
  ), a = u.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return u.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function ol(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = Gf(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((d) => d !== n));
  const c = i.find(
    (d) => d.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Gf(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Zf = Ni, Uf = Ai, Kf = Ti, Yf = Ii, Xf = Oi, qf = Li, Jf = Hi, Qf = Bi, e0 = Wi, t0 = Zi, n0 = Ui, o0 = Yi, r0 = Xi, s0 = qi, a0 = Qi, rl = "Toggle", lr = u.forwardRef((e, t) => {
  const { pressed: n, defaultPressed: o, onPressedChange: r, ...a } = e, [i, l] = Ee({
    prop: n,
    onChange: r,
    defaultProp: o ?? !1,
    caller: rl
  });
  return /* @__PURE__ */ s.jsx(
    V.button,
    {
      type: "button",
      "aria-pressed": i,
      "data-state": i ? "on" : "off",
      "data-disabled": e.disabled ? "" : void 0,
      ...a,
      ref: t,
      onClick: F(e.onClick, () => {
        e.disabled || l(!i);
      })
    }
  );
});
lr.displayName = rl;
var i0 = lr, at = "ToggleGroup", [sl] = He(at, [
  Ya
]), al = Ya(), cr = ee.forwardRef((e, t) => {
  const { type: n, ...o } = e;
  if (n === "single") {
    const r = o;
    return /* @__PURE__ */ s.jsx(l0, { ...r, ref: t });
  }
  if (n === "multiple") {
    const r = o;
    return /* @__PURE__ */ s.jsx(c0, { ...r, ref: t });
  }
  throw new Error(`Missing prop \`type\` expected on \`${at}\``);
});
cr.displayName = at;
var [il, ll] = sl(at), l0 = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? "",
    onChange: r,
    caller: at
  });
  return /* @__PURE__ */ s.jsx(
    il,
    {
      scope: e.__scopeToggleGroup,
      type: "single",
      value: ee.useMemo(() => i ? [i] : [], [i]),
      onItemActivate: l,
      onItemDeactivate: ee.useCallback(() => l(""), [l]),
      children: /* @__PURE__ */ s.jsx(cl, { ...a, ref: t })
    }
  );
}), c0 = ee.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, l] = Ee({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: at
  }), c = ee.useCallback(
    (f) => l((m = []) => [...m, f]),
    [l]
  ), d = ee.useCallback(
    (f) => l((m = []) => m.filter((g) => g !== f)),
    [l]
  );
  return /* @__PURE__ */ s.jsx(
    il,
    {
      scope: e.__scopeToggleGroup,
      type: "multiple",
      value: i,
      onItemActivate: c,
      onItemDeactivate: d,
      children: /* @__PURE__ */ s.jsx(cl, { ...a, ref: t })
    }
  );
});
cr.displayName = at;
var [u0, d0] = sl(at), cl = ee.forwardRef(
  (e, t) => {
    const {
      __scopeToggleGroup: n,
      disabled: o = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: i,
      loop: l = !0,
      ...c
    } = e, d = al(n), f = zt(i), m = { role: "group", dir: f, ...c };
    return /* @__PURE__ */ s.jsx(u0, { scope: n, rovingFocus: r, disabled: o, children: r ? /* @__PURE__ */ s.jsx(
      H2,
      {
        asChild: !0,
        ...d,
        orientation: a,
        dir: f,
        loop: l,
        children: /* @__PURE__ */ s.jsx(V.div, { ...m, ref: t })
      }
    ) : /* @__PURE__ */ s.jsx(V.div, { ...m, ref: t }) });
  }
), bn = "ToggleGroupItem", ul = ee.forwardRef(
  (e, t) => {
    const n = ll(bn, e.__scopeToggleGroup), o = d0(bn, e.__scopeToggleGroup), r = al(e.__scopeToggleGroup), a = n.value.includes(e.value), i = o.disabled || e.disabled, l = { ...e, pressed: a, disabled: i }, c = ee.useRef(null);
    return o.rovingFocus ? /* @__PURE__ */ s.jsx(
      $2,
      {
        asChild: !0,
        ...r,
        focusable: !i,
        active: a,
        ref: c,
        children: /* @__PURE__ */ s.jsx(is, { ...l, ref: t })
      }
    ) : /* @__PURE__ */ s.jsx(is, { ...l, ref: t });
  }
);
ul.displayName = bn;
var is = ee.forwardRef(
  (e, t) => {
    const { __scopeToggleGroup: n, value: o, ...r } = e, a = ll(bn, n), i = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, l = a.type === "single" ? i : void 0;
    return /* @__PURE__ */ s.jsx(
      lr,
      {
        ...l,
        ...r,
        ref: t,
        onPressedChange: (c) => {
          c ? a.onItemActivate(o) : a.onItemDeactivate(o);
        }
      }
    );
  }
), f0 = cr, p0 = ul;
function N4({ ...e }) {
  return /* @__PURE__ */ s.jsx(Y1, { "data-slot": "accordion", ...e });
}
function _4({ className: e, value: t, ...n }) {
  const o = u.useId();
  return /* @__PURE__ */ s.jsx(
    X1,
    {
      "data-slot": "accordion-item",
      value: t ?? o,
      className: O("border-border-cards border-b py-3 last:border-b-0", e),
      ...n
    }
  );
}
function A4({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsx(q1, { className: "flex", children: /* @__PURE__ */ s.jsxs(
    J1,
    {
      "data-slot": "accordion-trigger",
      className: O(
        "text-paragraph-medium text-foreground-primary/88 focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-2 rounded-md py-3.5 text-left font-bold outline-none transition-all hover:text-button-secondary-hover focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            stroke: 1.5,
            className: "text-foreground-primary pointer-events-none size-6 shrink-0 translate-y-0.5 transition-transform duration-200"
          }
        )
      ]
    }
  ) });
}
function k4({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsx(
    Q1,
    {
      "data-slot": "accordion-content",
      className: "text-paragraph-medium text-foreground-primary/88 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden",
      ...n,
      children: /* @__PURE__ */ s.jsx("div", { className: O("pb-3 pt-1", e), children: t })
    }
  );
}
const m0 = En(
  "focus-visible:border-ring focus-visible:ring-ring/50 flex cursor-pointer items-center justify-center gap-2 rounded-full outline-none transition-all duration-300 focus-visible:ring-[3px] disabled:cursor-default",
  {
    variants: {
      variant: {
        primary: O(
          "bg-button-primary-default text-primary-foreground",
          "hover:not-disabled:bg-button-primary-hover",
          "active:not-disabled:bg-button-primary-pressed",
          "disabled:opacity-20"
        ),
        secondary: O(
          "border-1 border-button-secondary-default bg-button-secondary-background text-button-secondary-default",
          "hover:not-disabled:border-button-secondary-hover hover:not-disabled:text-button-secondary-hover",
          "active:not-disabled:border-button-secondary-pressed active:not-disabled:text-button-secondary-pressed",
          "disabled:opacity-30"
        )
      },
      size: {
        big: "text-button-big min-h-12 px-8",
        small: "text-button-small px-3 py-1"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "big"
    }
  }
);
function ls({
  className: e,
  variant: t,
  size: n,
  asChild: o = !1,
  ...r
}) {
  const a = o ? ks : "button";
  return /* @__PURE__ */ s.jsx(a, { "data-slot": "button", className: O(m0({ variant: t, size: n, className: e })), ...r });
}
function h0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card",
      className: O(
        "bg-card text-card-foreground shadow-hero flex flex-col gap-6 overflow-hidden rounded-2xl py-6",
        e
      ),
      ...t
    }
  );
}
function g0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-header-image",
      className: O("-mt-6 flex h-[13.75rem] w-full items-center justify-center", e),
      ...t
    }
  );
}
function v0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-header",
      className: O(
        "@container/card-header has-data-[slot=card-action]:grid-cols-[1fr_auto] grid auto-rows-min grid-rows-[auto_auto] items-start gap-4 px-6",
        e
      ),
      ...t
    }
  );
}
function x0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-title",
      className: O("text-heading-h3 text-foreground-primary leading-none", e),
      ...t
    }
  );
}
function C0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-description",
      className: O("text-paragraph-small text-foreground-primary", e),
      ...t
    }
  );
}
function T4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "div",
    {
      "data-slot": "card-action",
      className: O("col-start-2 row-span-2 row-start-1 self-start justify-self-end", e),
      ...t
    }
  );
}
function I4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "card-content", className: O("px-6", e), ...t });
}
function b0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "card-footer", className: O("mt-auto flex items-center px-6", e), ...t });
}
function dl({ ...e }) {
  return /* @__PURE__ */ s.jsx(Fs, { "data-slot": "collapsible", ...e });
}
function fl({ ...e }) {
  return /* @__PURE__ */ s.jsx(To, { "data-slot": "collapsible-trigger", ...e });
}
function pl({ ...e }) {
  return /* @__PURE__ */ s.jsx(Oo, { "data-slot": "collapsible-content", ...e });
}
function w0({
  className: e,
  children: t,
  viewport: n = !0,
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(
    of,
    {
      "data-slot": "navigation-menu",
      "data-viewport": n,
      className: O(
        "group/navigation-menu relative flex max-w-max flex-1 items-center justify-center",
        e
      ),
      ...o,
      children: [
        t,
        n && /* @__PURE__ */ s.jsx(M0, {})
      ]
    }
  );
}
function y0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    rf,
    {
      "data-slot": "navigation-menu-list",
      className: O("group flex flex-1 list-none items-center justify-center gap-1", e),
      ...t
    }
  );
}
function S0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    sf,
    {
      "data-slot": "navigation-menu-item",
      className: O("relative", e),
      ...t
    }
  );
}
const E0 = En(
  "text-button-small text-accent-primary hover:text-accent-secondary data-[state=open]:text-accent-secondary group inline-flex cursor-pointer items-center gap-2 transition-colors hover:bg-transparent"
);
function R0({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ s.jsxs(
    af,
    {
      "data-slot": "navigation-menu-trigger",
      className: O(E0(), "group", e),
      ...n,
      children: [
        t,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            stroke: 1.5,
            className: "relative top-[1px] ml-1 size-6 transition duration-300 group-data-[state=open]:rotate-180",
            "aria-hidden": "true"
          }
        )
      ]
    }
  );
}
function j0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    uf,
    {
      "data-slot": "navigation-menu-content",
      className: O(
        "data-[motion=from-end]:slide-in-from-right-52 data-[motion=from-start]:slide-in-from-left-52 data-[motion=to-end]:slide-out-to-right-52 data-[motion=to-start]:slide-out-to-left-52 data-[motion^=from-]:animate-in data-[motion^=from-]:fade-in data-[motion^=to-]:animate-out data-[motion^=to-]:fade-out left-0 top-0 w-full p-2 pr-2.5 md:absolute md:w-auto",
        "group-data-[viewport=false]/navigation-menu:bg-popover group-data-[viewport=false]/navigation-menu:text-popover-foreground group-data-[viewport=false]/navigation-menu:data-[state=closed]:animate-out group-data-[viewport=false]/navigation-menu:data-[state=closed]:fade-out-0 group-data-[viewport=false]/navigation-menu:data-[state=closed]:zoom-out-95 group-data-[viewport=false]/navigation-menu:data-[state=open]:animate-in group-data-[viewport=false]/navigation-menu:data-[state=open]:fade-in-0 group-data-[viewport=false]/navigation-menu:data-[state=open]:zoom-in-95 group-data-[viewport=false]/navigation-menu:top-full group-data-[viewport=false]/navigation-menu:mt-1.5 group-data-[viewport=false]/navigation-menu:overflow-hidden group-data-[viewport=false]/navigation-menu:rounded-md group-data-[viewport=false]/navigation-menu:border group-data-[viewport=false]/navigation-menu:shadow group-data-[viewport=false]/navigation-menu:duration-200",
        "h-fit p-0 pr-0",
        e
      ),
      ...t
    }
  );
}
function M0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx("div", { className: O("absolute left-0 top-[56px] isolate z-50 flex justify-center"), children: /* @__PURE__ */ s.jsx(
    df,
    {
      "data-slot": "navigation-menu-viewport",
      className: O(
        "origin-top-center bg-popover fade-out data-[state=closed]:animate-out data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:zoom-in-90 relative mt-1.5 h-[var(--radix-navigation-menu-viewport-height)] w-full overflow-hidden md:w-[var(--radix-navigation-menu-viewport-width)]",
        "navbar-popover-card",
        e
      ),
      ...t
    }
  ) });
}
function No({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    lf,
    {
      "data-slot": "navigation-menu-link",
      className: O(
        "text-button-small text-accent-primary hover:text-accent-secondary flex flex-col whitespace-nowrap p-4 transition-colors hover:bg-transparent",
        e
      ),
      ...t
    }
  );
}
function O4({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    cf,
    {
      "data-slot": "navigation-menu-indicator",
      className: O(
        "data-[state=hidden]:animate-out data-[state=hidden]:fade-out data-[state=visible]:animate-in data-[state=visible]:fade-in top-full z-[1] flex h-1.5 items-end justify-center overflow-hidden",
        e
      ),
      ...t,
      children: /* @__PURE__ */ s.jsx("div", { className: "bg-border relative top-[60%] h-2 w-2 rotate-45 rounded-tl-sm shadow-md" })
    }
  );
}
function P0({ ...e }) {
  return /* @__PURE__ */ s.jsx(wf, { "data-slot": "popover", ...e });
}
function N0({ ...e }) {
  return /* @__PURE__ */ s.jsx(Sf, { "data-slot": "popover-trigger", ...e });
}
function _0({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(Ef, { children: /* @__PURE__ */ s.jsx(
    Rf,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: O(
        "origin-(--radix-popover-content-transform-origin) bg-popover text-popover-foreground outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 z-50 w-72 rounded-md border p-4 shadow-md",
        e
      ),
      ...o
    }
  ) });
}
function L4({ ...e }) {
  return /* @__PURE__ */ s.jsx(yf, { "data-slot": "popover-anchor", ...e });
}
function D4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "popover-header", className: O("flex flex-col gap-1 text-sm", e), ...t });
}
function F4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "popover-title", className: O("font-medium", e), ...t });
}
function V4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("p", { "data-slot": "popover-description", className: O("text-muted-foreground", e), ...t });
}
function ml({ ...e }) {
  return /* @__PURE__ */ s.jsx(Zf, { "data-slot": "select", ...e });
}
function H4({ ...e }) {
  return /* @__PURE__ */ s.jsx(Qf, { "data-slot": "select-group", ...e });
}
function $4({ ...e }) {
  return /* @__PURE__ */ s.jsx(Kf, { "data-slot": "select-value", ...e });
}
function hl({
  className: e,
  size: t = "default",
  children: n,
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(
    Uf,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: O(
        'border-input focus-visible:border-ring focus-visible:ring-ring/50 data-[placeholder]:text-muted-foreground data-[state=open]:border-accent-secondary flex w-full items-center justify-between gap-2 whitespace-nowrap rounded-[4px] border bg-transparent px-3 py-2 text-sm outline-none transition-[color,box-shadow] focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ s.jsx(Yf, { asChild: !0, children: /* @__PURE__ */ s.jsx(tt, { className: "text-primary size-5" }) })
      ]
    }
  );
}
function gl({
  className: e,
  children: t,
  position: n = "item-aligned",
  align: o = "center",
  ...r
}) {
  return /* @__PURE__ */ s.jsx(Xf, { children: /* @__PURE__ */ s.jsxs(
    qf,
    {
      "data-slot": "select-content",
      className: O(
        "max-h-(--radix-select-content-available-height) origin-(--radix-select-content-transform-origin) bg-popover text-popover-foreground data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 relative z-50 min-w-[8rem] overflow-y-auto overflow-x-hidden rounded-[4px] border shadow-[0_1px_4px_0px_rgba(0,0,0,0.1)]",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: o,
      ...r,
      children: [
        /* @__PURE__ */ s.jsx(A0, {}),
        /* @__PURE__ */ s.jsx(
          Jf,
          {
            className: O(
              "p-1",
              n === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ s.jsx(k0, {})
      ]
    }
  ) });
}
function B4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    e0,
    {
      "data-slot": "select-label",
      className: O("text-muted-foreground px-2 py-1.5 text-xs", e),
      ...t
    }
  );
}
function vl({ className: e, children: t, ...n }) {
  return /* @__PURE__ */ s.jsxs(
    t0,
    {
      "data-slot": "select-item",
      className: O(
        'outline-hidden focus:text-accent-secondary *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2 relative flex w-full cursor-pointer select-none items-center gap-2 rounded-sm py-1.5 pl-2 pr-8 text-sm data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*="size-"])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0',
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ s.jsx(
          "span",
          {
            "data-slot": "select-item-indicator",
            className: "absolute right-2 flex size-3.5 items-center justify-center",
            children: /* @__PURE__ */ s.jsx(o0, { children: /* @__PURE__ */ s.jsx(cc, { className: "size-4" }) })
          }
        ),
        /* @__PURE__ */ s.jsx(n0, { children: t })
      ]
    }
  );
}
function z4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    a0,
    {
      "data-slot": "select-separator",
      className: O("bg-border pointer-events-none -mx-1 my-1 h-px", e),
      ...t
    }
  );
}
function A0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    r0,
    {
      "data-slot": "select-scroll-up-button",
      className: O("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ s.jsx(fc, { className: "size-4" })
    }
  );
}
function k0({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ s.jsx(
    s0,
    {
      "data-slot": "select-scroll-down-button",
      className: O("flex cursor-default items-center justify-center py-1", e),
      ...t,
      children: /* @__PURE__ */ s.jsx(tt, { className: "size-4" })
    }
  );
}
function T0({ ...e }) {
  return /* @__PURE__ */ s.jsx(ud, { "data-slot": "sheet", ...e });
}
function I0({ ...e }) {
  return /* @__PURE__ */ s.jsx(dd, { "data-slot": "sheet-trigger", ...e });
}
function W4({ ...e }) {
  return /* @__PURE__ */ s.jsx(ya, { "data-slot": "sheet-close", ...e });
}
function O0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    fd,
    {
      "data-slot": "sheet-overlay",
      className: O(
        "fixed inset-0 z-50 bg-[rgba(8,8,51,0.50)] data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function L0({
  className: e,
  children: t,
  side: n = "right",
  ...o
}) {
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(O0, {}),
    /* @__PURE__ */ s.jsxs(
      pd,
      {
        "data-slot": "sheet-content",
        className: O(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:animate-in data-[state=open]:duration-500",
          n === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm",
          n === "left" && "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          n === "top" && "inset-x-0 top-0 h-auto border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          n === "bottom" && "inset-x-0 bottom-0 h-auto border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          e
        ),
        ...o,
        children: [
          /* @__PURE__ */ s.jsxs(ya, { className: "absolute top-8 right-4 mr-2 cursor-pointer rounded-xs ring-offset-background transition-opacity hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ s.jsx(jc, { className: "size-6" }),
            /* @__PURE__ */ s.jsx("span", { className: "sr-only", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.close" }) })
          ] }),
          t
        ]
      }
    )
  ] });
}
function D0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "sheet-header", className: O("flex flex-col gap-1.5 p-4", e), ...t });
}
function F0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx("div", { "data-slot": "sheet-footer", className: O("mt-auto flex flex-col gap-2 p-4", e), ...t });
}
function V0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    md,
    {
      "data-slot": "sheet-title",
      className: O("font-semibold text-foreground", e),
      ...t
    }
  );
}
function G4({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    hd,
    {
      "data-slot": "sheet-description",
      className: O("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function H0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: O(
        'flex w-full min-w-0 flex-col overflow-auto [&>[data-sidebar="menu-item"]:last-child_[data-sidebar="menu-button"]]:border-b-0',
        e
      ),
      ...t
    }
  );
}
function cs({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: O("group/menu-item relative", e),
      ...t
    }
  );
}
function $0({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: O(
        "mr-7 flex min-w-0 translate-x-px flex-col pl-4",
        "group-data-[collapsible=icon]:hidden",
        "border-b border-b-background-tertiary",
        e
      ),
      ...t
    }
  );
}
function us({ className: e, ...t }) {
  return /* @__PURE__ */ s.jsx(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: O("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function wn({
  asChild: e = !1,
  isActive: t = !1,
  className: n,
  buttonType: o = "menu",
  children: r,
  ...a
}) {
  const i = e ? ks : "button";
  return /* @__PURE__ */ s.jsx(
    i,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-active": t,
      className: O(
        "group flex w-full cursor-pointer items-center gap-2 py-4 pl-2 text-button-big text-accent-primary transition-all hover:text-accent-secondary data-[state=open]:text-accent-secondary",
        o === "menu" && "border-b border-b-background-tertiary data-[state=open]:border-b-transparent",
        n
      ),
      ...a,
      children: /* @__PURE__ */ s.jsxs("div", { className: "contents", children: [
        r,
        /* @__PURE__ */ s.jsx(
          tt,
          {
            className: "relative ml-1 hidden size-4 transition duration-300 group-data-[slot=collapsible-trigger]:block group-data-[state=open]:rotate-x-180",
            "aria-hidden": "true"
          }
        )
      ] })
    }
  );
}
const xl = En(
  O(
    "inline-flex items-center justify-center gap-2 rounded-full text-paragraph-small text-sm font-medium whitespace-nowrap transition-[color,box-shadow,background-color] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50",
    "data-[state=off]:hover:text-foreground-primary/80 data-[state=on]:bg-accent-secondary data-[state=on]:text-foreground-on-primary",
    "cursor-pointer"
  ),
  {
    variants: {
      variant: {
        default: "bg-transparent",
        outline: "bg-transparent shadow-xs hover:text-accent-foreground"
      },
      size: {
        default: "h-[30px] min-w-9 px-2",
        sm: "h-8 min-w-8 px-1.5",
        lg: "h-10 min-w-10 px-2.5"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Z4({
  className: e,
  variant: t,
  size: n,
  ...o
}) {
  return /* @__PURE__ */ s.jsx(
    i0,
    {
      "data-slot": "toggle",
      className: O(xl({ variant: t, size: n, className: e })),
      ...o
    }
  );
}
const Cl = u.createContext({
  size: "default",
  variant: "default"
});
function U4({
  className: e,
  variant: t,
  size: n,
  children: o,
  ...r
}) {
  return /* @__PURE__ */ s.jsx(
    f0,
    {
      "data-slot": "toggle-group",
      "data-variant": t,
      "data-size": n,
      className: O(
        "group/toggle-group flex w-fit items-center rounded-full bg-background-secondary data-[variant=outline]:border-1 data-[variant=outline]:border-[#D9D9D9] data-[variant=outline]:p-[1px] data-[variant=outline]:shadow-xs",
        e
      ),
      ...r,
      children: /* @__PURE__ */ s.jsx(Cl.Provider, { value: { variant: t, size: n }, children: o })
    }
  );
}
function K4({
  className: e,
  children: t,
  variant: n,
  size: o,
  ...r
}) {
  const a = u.useContext(Cl);
  return /* @__PURE__ */ s.jsx(
    p0,
    {
      "data-slot": "toggle-group-item",
      "data-variant": a.variant || n,
      "data-size": a.size || o,
      className: O(
        xl({
          variant: a.variant || n,
          size: a.size || o
        }),
        "min-w-0 shrink-0 px-4 shadow-none focus:z-10 focus-visible:z-10 data-[state=on]:rounded-full",
        e
      ),
      ...r,
      children: t
    }
  );
}
const Y4 = ({
  title: e,
  description: t,
  linkText: n,
  logo: o,
  logoBackgroundColor: r,
  href: a,
  forceWhiteLogo: i
}) => {
  const { formatMessage: l } = Pt();
  return /* @__PURE__ */ s.jsxs(h0, { children: [
    /* @__PURE__ */ s.jsx(g0, { style: { backgroundColor: r }, children: /* @__PURE__ */ s.jsx(
      "img",
      {
        src: o,
        alt: l({ id: e }),
        className: O("max-h-20 max-w-50", i && "text-white brightness-0 invert")
      }
    ) }),
    /* @__PURE__ */ s.jsxs(v0, { children: [
      /* @__PURE__ */ s.jsx(x0, { children: /* @__PURE__ */ s.jsx(Ge, { id: e }) }),
      /* @__PURE__ */ s.jsx(C0, { children: /* @__PURE__ */ s.jsx(Ge, { id: t }) })
    ] }),
    /* @__PURE__ */ s.jsx(b0, { children: /* @__PURE__ */ s.jsx(ke, { href: a, children: /* @__PURE__ */ s.jsx(h1, { variant: "Link/Medium/Bold", showArrow: !0, children: /* @__PURE__ */ s.jsx(Ge, { id: n }) }) }) })
  ] });
}, B0 = ({ description: e, icon: t, title: n }) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: O(
      "absolute top-1/2 left-1/2 hidden w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-3xl bg-white",
      "transition-all duration-150 ease-in-out",
      "scale-75 opacity-0 shadow-none",
      "xl:block",
      "xl:group-hover-or-focus:z-10 xl:group-hover-or-focus:scale-100 xl:group-hover-or-focus:opacity-100 xl:group-hover-or-focus:shadow-[0px_4px_140px_0px_rgba(66,_83,_153,_0.15)]",
      "3xl:w-[39rem]"
    ),
    children: /* @__PURE__ */ s.jsxs("div", { className: "flex h-full items-center justify-between gap-4 p-6", children: [
      /* @__PURE__ */ s.jsx("div", { className: "size-32 min-w-32 text-accent-primary [&>*]:size-full [&>*]:min-w-full", children: t }),
      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-1 flex-col gap-2", children: [
        /* @__PURE__ */ s.jsx("h4", { className: "text-heading-h4", children: n }),
        /* @__PURE__ */ s.jsx("span", { className: "text-paragraph-small text-foreground-secondary", children: e })
      ] }),
      /* @__PURE__ */ s.jsx(gs, { className: "size-8 min-w-8 text-accent-primary" })
    ] })
  }
), X4 = ({ title: e, description: t, href: n, icon: o, className: r }) => /* @__PURE__ */ s.jsxs(ke, { href: n, className: "group relative", children: [
  /* @__PURE__ */ s.jsx(B0, { description: t, icon: o, title: e }),
  /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: O(
        "flex min-h-12 items-center gap-2 pr-4 text-accent-primary transition-colors hover:text-accent-secondary",
        r
      ),
      children: [
        /* @__PURE__ */ s.jsx("div", { className: "flex size-12 min-w-12 items-center justify-center", children: o }),
        /* @__PURE__ */ s.jsx("span", { className: "flex-1 text-paragraph-big leading-[120%] font-bold tracking-[0.75px]", children: e }),
        /* @__PURE__ */ s.jsx(gs, { className: "size-4 min-w-4" })
      ]
    }
  )
] }), bl = (e) => /* @__PURE__ */ s.jsxs("svg", { width: "105", height: "32", viewBox: "0 0 140 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0)", children: [
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M6.16 6.5759C7.224 6.0239 8.432 5.7439 9.768 5.7439C11.304 5.7439 12.696 6.1199 13.968 6.8799C15.232 7.6399 16.232 8.6959 16.952 10.0559C17.672 11.4159 18.032 12.9839 18.032 14.7519C18.032 16.5199 17.672 18.0959 16.952 19.4959C16.224 20.8879 15.232 21.9759 13.968 22.7519C12.696 23.5279 11.304 23.9199 9.768 23.9199C8.424 23.9199 7.232 23.6479 6.192 23.1039C5.152 22.5599 4.296 21.8879 3.64 21.0799V31.9999H0V6.0319H3.64V8.6239C4.256 7.8159 5.096 7.1279 6.16 6.5759ZM13.592 11.6079C13.096 10.7279 12.432 10.0559 11.608 9.5919C10.792 9.1359 9.912 8.9039 8.976 8.9039C8.056 8.9039 7.192 9.1359 6.368 9.6079C5.552 10.0719 4.888 10.7599 4.384 11.6479C3.888 12.5439 3.632 13.5999 3.632 14.8079C3.632 16.0159 3.888 17.0799 4.384 17.9839C4.888 18.8879 5.544 19.5759 6.368 20.0479C7.184 20.5119 8.056 20.7519 8.976 20.7519C9.912 20.7519 10.792 20.5119 11.608 20.0319C12.432 19.5519 13.088 18.8559 13.592 17.9359C14.096 17.0239 14.344 15.9519 14.344 14.7439C14.336 13.5439 14.088 12.4959 13.592 11.6079Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M22.376 10.064C23.112 8.69595 24.112 7.63995 25.376 6.88795C26.64 6.12795 28.04 5.75195 29.576 5.75195C30.96 5.75195 32.168 6.02395 33.2 6.56795C34.232 7.11195 35.056 7.78395 35.68 8.59195V6.03195H39.352V23.632H35.68V21.016C35.064 21.848 34.216 22.536 33.16 23.096C32.096 23.648 30.88 23.928 29.52 23.928C28.008 23.928 26.624 23.536 25.368 22.76C24.112 21.984 23.112 20.896 22.384 19.504C21.648 18.112 21.28 16.528 21.28 14.76C21.28 12.992 21.64 11.424 22.376 10.064ZM34.92 11.656C34.416 10.76 33.76 10.08 32.952 9.61595C32.144 9.14395 31.272 8.91195 30.336 8.91195C29.4 8.91195 28.528 9.14395 27.72 9.59995C26.912 10.064 26.256 10.728 25.752 11.616C25.256 12.496 25 13.544 25 14.76C25 15.976 25.256 17.04 25.752 17.952C26.256 18.864 26.912 19.56 27.736 20.048C28.552 20.528 29.424 20.768 30.336 20.768C31.272 20.768 32.144 20.536 32.952 20.064C33.76 19.6 34.416 18.904 34.92 18C35.416 17.096 35.672 16.032 35.672 14.824C35.672 13.608 35.424 12.552 34.92 11.656Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M47.3599 23.1681C46.2719 22.6641 45.4079 21.9841 44.7679 21.1201C44.1279 20.2561 43.7919 19.2961 43.7439 18.2321H47.5119C47.5759 19.0401 47.9359 19.7121 48.5839 20.2401C49.2319 20.7761 50.0479 21.0401 51.0239 21.0401C52.0479 21.0401 52.8399 20.8321 53.3999 20.4161C53.9679 20.0001 54.2479 19.4401 54.2479 18.7361C54.2479 18.0961 53.9279 17.6081 53.2879 17.2641C52.6479 16.9201 51.6559 16.5841 50.3199 16.2401C49.0239 15.8801 47.9599 15.5361 47.1439 15.2001C46.3199 14.8721 45.6159 14.3601 45.0159 13.6641C44.4239 12.9761 44.1199 12.0721 44.1199 10.9681C44.1199 10.0081 44.3839 9.12808 44.9199 8.33608C45.4479 7.53608 46.2239 6.90408 47.2319 6.44008C48.2399 5.97608 49.4319 5.73608 50.7919 5.73608C52.7919 5.73608 54.4079 6.24008 55.6319 7.24808C56.8559 8.26408 57.5119 9.64008 57.5999 11.3841H53.9599C53.8959 10.5281 53.5759 9.85608 52.9999 9.35208C52.4239 8.85608 51.6479 8.60008 50.6719 8.60008C49.7119 8.60008 48.9759 8.79208 48.4719 9.19208C47.9599 9.58408 47.7039 10.1121 47.7039 10.7761C47.7039 11.2481 47.8719 11.6401 48.2159 11.9601C48.5599 12.2801 48.9839 12.5281 49.4959 12.7121C50.0079 12.8881 50.7279 13.1121 51.6639 13.3681C52.9439 13.7121 53.9839 14.0481 54.7919 14.3921C55.5999 14.7361 56.2879 15.2481 56.8639 15.9441C57.4399 16.6321 57.7279 17.5361 57.7279 18.6401C57.7279 19.6401 57.4639 20.5361 56.9279 21.3361C56.3919 22.1361 55.6239 22.7601 54.6159 23.2241C53.6079 23.6801 52.4079 23.9121 51.0239 23.9121C49.6719 23.9201 48.4479 23.6721 47.3599 23.1681Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M64.968 23.1681C63.88 22.6641 63.0161 21.9841 62.3761 21.1201C61.736 20.2561 61.4001 19.2961 61.3521 18.2321H65.1201C65.1841 19.0401 65.544 19.7121 66.192 20.2401C66.84 20.7761 67.6561 21.0401 68.6321 21.0401C69.6561 21.0401 70.4481 20.8321 71.0081 20.4161C71.5761 20.0001 71.8561 19.4401 71.8561 18.7361C71.8561 18.0961 71.5361 17.6081 70.8961 17.2641C70.2561 16.9201 69.2641 16.5841 67.9281 16.2401C66.6321 15.8801 65.5681 15.5361 64.7521 15.2001C63.9281 14.8721 63.224 14.3601 62.624 13.6641C62.032 12.9761 61.7281 12.0721 61.7281 10.9681C61.7281 10.0081 61.9921 9.12808 62.5281 8.33608C63.0561 7.53608 63.8321 6.90408 64.8401 6.44008C65.8481 5.97608 67.0401 5.73608 68.4001 5.73608C70.4001 5.73608 72.0161 6.24008 73.2401 7.24808C74.4641 8.26408 75.1201 9.64008 75.2081 11.3841H71.5681C71.5041 10.5281 71.1841 9.85608 70.6081 9.35208C70.0321 8.85608 69.2561 8.60008 68.28 8.60008C67.32 8.60008 66.584 8.79208 66.08 9.19208C65.568 9.58408 65.312 10.1121 65.312 10.7761C65.312 11.2481 65.48 11.6401 65.824 11.9601C66.168 12.2801 66.592 12.5281 67.104 12.7121C67.616 12.8881 68.336 13.1121 69.272 13.3681C70.552 13.7121 71.5921 14.0481 72.4001 14.3921C73.2081 14.7361 73.896 15.2481 74.472 15.9441C75.048 16.6321 75.3361 17.5361 75.3361 18.6401C75.3361 19.6401 75.0721 20.5361 74.5361 21.3361C74.0001 22.1361 73.2321 22.7601 72.2241 23.2241C71.2161 23.6881 70.0161 23.9121 68.6321 23.9121C67.2801 23.9201 66.056 23.6721 64.968 23.1681Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M103.376 6.03198L97.912 23.632H94.08L90.536 10.632L86.992 23.632H83.16L77.672 6.03198H81.376L85.048 20.184L88.784 6.03198H92.584L96.16 20.12L99.8 6.03198H103.376Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M106.328 10.064C107.064 8.696 108.064 7.64 109.328 6.888C110.592 6.128 112.008 5.752 113.56 5.752C114.712 5.752 115.84 6 116.96 6.504C118.08 7.008 118.968 7.672 119.632 8.504V0H123.304V23.632H119.632V20.984C119.032 21.84 118.208 22.536 117.152 23.088C116.096 23.64 114.888 23.92 113.528 23.92C111.992 23.92 110.592 23.528 109.328 22.752C108.056 21.976 107.056 20.888 106.328 19.496C105.592 18.104 105.224 16.52 105.224 14.752C105.224 12.984 105.592 11.424 106.328 10.064ZM118.88 11.656C118.376 10.76 117.72 10.08 116.912 9.616C116.104 9.144 115.232 8.912 114.296 8.912C113.36 8.912 112.488 9.144 111.68 9.6C110.872 10.064 110.216 10.728 109.712 11.616C109.216 12.496 108.96 13.544 108.96 14.76C108.96 15.976 109.216 17.04 109.712 17.952C110.216 18.864 110.872 19.56 111.696 20.048C112.512 20.528 113.384 20.768 114.296 20.768C115.232 20.768 116.104 20.536 116.912 20.064C117.72 19.6 118.376 18.904 118.88 18C119.376 17.096 119.632 16.032 119.632 14.824C119.632 13.608 119.376 12.552 118.88 11.656Z",
        fill: "black"
      }
    ),
    /* @__PURE__ */ s.jsx(
      "path",
      {
        d: "M139.272 5.32C139.272 2.384 136.888 0 133.952 0C131.016 0 128.632 2.384 128.632 5.32C128.632 7.288 129.712 8.984 131.296 9.904V15.736C131.296 17.208 132.488 18.4 133.96 18.4C135.432 18.4 136.624 17.208 136.624 15.736V9.904C138.192 8.984 139.272 7.288 139.272 5.32Z",
        fill: "#0000FF"
      }
    )
  ] }),
  /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0", children: /* @__PURE__ */ s.jsx("rect", { width: "139.272", height: "32", fill: "white" }) }) })
] }), Oe = {
  eur: {
    label: "Euro",
    identifier: "EUR",
    icon: /* @__PURE__ */ s.jsx(xc, { className: "text-accent-primary size-[18px]" })
  },
  usd: {
    label: "U.S. Dollar",
    identifier: "USD",
    icon: /* @__PURE__ */ s.jsx(gc, { className: "text-accent-primary size-[18px]" })
  }
}, z0 = Object.keys(Oe).map((e) => ({
  code: e
})), W0 = ({
  currencies: e = z0,
  currentCurrency: t,
  onCurrencyChange: n,
  triggerClassName: o = "w-full",
  "aria-label": r
}) => /* @__PURE__ */ s.jsxs(ml, { value: t, onValueChange: n, children: [
  /* @__PURE__ */ s.jsx(hl, { className: o, "aria-label": r, children: /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-2", children: [
    Oe[t].icon,
    /* @__PURE__ */ s.jsx("span", { children: Oe[t].identifier })
  ] }) }),
  /* @__PURE__ */ s.jsx(gl, { position: "popper", sideOffset: 4, children: e.map((a) => /* @__PURE__ */ s.jsxs(
    vl,
    {
      value: a.code,
      textValue: `${Oe[a.code].identifier} ${Oe[a.code].label}`,
      children: [
        Oe[a.code].icon,
        " ",
        Oe[a.code].identifier,
        " (",
        Oe[a.code].label,
        ")"
      ]
    },
    a.code
  )) })
] }), G0 = ({
  code: e = "NL",
  size: t = "l",
  gradient: n = "",
  hasBorder: o = !0,
  hasDropShadow: r = !1,
  hasBorderRadius: a = !0,
  className: i
}) => /* @__PURE__ */ s.jsx(
  "div",
  {
    className: `flag ${n} size-${t} ${o ? "border" : ""} ${r ? "drop-shadow" : ""} ${a ? "border-radius" : ""} ${i ? i.replace(/\s\s+/g, " ").trim() : ""}`,
    children: /* @__PURE__ */ s.jsx("img", { src: `/flags/${t}/${e}.svg` })
  }
), ds = G0, wl = ({
  languages: e,
  currentLanguage: t,
  onLanguageChange: n,
  currencies: o,
  currentCurrency: r,
  onCurrencyChange: a,
  hideLanguage: i
}) => {
  const l = e.find((c) => c.code === t);
  return /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2 2xl:gap-4", children: [
    !i && /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s.jsx("label", { className: "text-paragraph-extrasmall text-foreground-secondary px-4", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.languageAndCurrencySwitcher.language.title" }) }),
      /* @__PURE__ */ s.jsxs(ml, { value: t, onValueChange: n, children: [
        /* @__PURE__ */ s.jsx(hl, { className: "w-full", children: /* @__PURE__ */ s.jsxs("span", { className: "flex items-center gap-2", children: [
          (l == null ? void 0 : l.flagCode) && /* @__PURE__ */ s.jsx(ds, { code: l.flagCode, size: "s", hasBorder: !1 }),
          /* @__PURE__ */ s.jsx("span", { children: l == null ? void 0 : l.label })
        ] }) }),
        /* @__PURE__ */ s.jsx(gl, { position: "popper", sideOffset: 4, children: e.map((c) => /* @__PURE__ */ s.jsxs(vl, { value: c.code, textValue: c.label, children: [
          c.flagCode && /* @__PURE__ */ s.jsx(ds, { code: c.flagCode, size: "s", hasBorder: !1 }),
          c.label
        ] }, c.code)) })
      ] })
    ] }),
    /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-1", children: [
      /* @__PURE__ */ s.jsx("label", { className: "text-paragraph-extrasmall text-foreground-secondary px-4", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.languageAndCurrencySwitcher.currency.title" }) }),
      /* @__PURE__ */ s.jsx(
        W0,
        {
          currencies: o,
          currentCurrency: r,
          onCurrencyChange: a
        }
      )
    ] })
  ] });
}, Z0 = (e) => {
  const { currentCurrency: t } = e, { formatMessage: n } = Pt();
  return /* @__PURE__ */ s.jsxs(dl, { children: [
    /* @__PURE__ */ s.jsx(fl, { asChild: !0, children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: O(
          "text-foreground-primary text-md data-[state=open]:text-accent-secondary group flex w-full cursor-pointer items-center gap-2 rounded-md px-3 py-2 font-medium",
          "hover:text-accent-secondary transition-colors"
        ),
        "aria-label": n({ id: "navbar.languageAndCurrencySwitcher.description" }),
        children: [
          /* @__PURE__ */ s.jsx(vs, { className: "size-5" }),
          Oe[t].identifier,
          /* @__PURE__ */ s.jsx(tt, { className: "relative ml-1 hidden size-4 transition duration-300 group-data-[state=open]:block" })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      pl,
      {
        className: O(
          "overflow-hidden duration-200 ease-in-out",
          "data-[state=open]:animate-collapsible-down",
          "data-[state=closed]:animate-collapsible-up"
        ),
        children: /* @__PURE__ */ s.jsx("div", { className: "pb-4 pt-1", children: /* @__PURE__ */ s.jsx(wl, { ...e }) })
      }
    )
  ] });
}, U0 = (e) => {
  const { currentCurrency: t } = e, n = hs("2xl"), [o, r] = $t(!1), { formatMessage: a } = Pt();
  return yn(() => {
    n && r(!1);
  }, [n]), /* @__PURE__ */ s.jsxs(P0, { modal: !1, open: o, onOpenChange: r, children: [
    /* @__PURE__ */ s.jsx(N0, { asChild: !0, children: /* @__PURE__ */ s.jsxs(
      "button",
      {
        className: O(
          "text-foreground-primary hover:text-accent-secondary group flex cursor-pointer items-center gap-1 transition-colors",
          "data-[state=open]:text-accent-secondary"
        ),
        "aria-label": a({ id: "navbar.languageAndCurrencySwitcher.description" }),
        children: [
          /* @__PURE__ */ s.jsx(vs, { stroke: 1.5, className: "size-6" }),
          /* @__PURE__ */ s.jsx("span", { className: "text-button-big", children: Oe[t].identifier }),
          /* @__PURE__ */ s.jsx(
            tt,
            {
              stroke: 1.5,
              className: "ml-1 size-6 transition-transform group-data-[state=open]:rotate-180"
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(
      _0,
      {
        className: "navbar-popover-card w-[267px] border-none p-4",
        align: "end",
        sideOffset: 34,
        alignOffset: -15,
        children: /* @__PURE__ */ s.jsx(wl, { ...e })
      }
    )
  ] });
}, K0 = ({ content: e }) => /* @__PURE__ */ s.jsx(j0, { children: /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-2 p-4", children: [
  /* @__PURE__ */ s.jsx("div", { className: "flex justify-between", children: e.groups.map((t) => /* @__PURE__ */ s.jsxs("div", { children: [
    /* @__PURE__ */ s.jsx("p", { className: "text-paragraph-extrasmall text-foreground-secondary p-4 pb-2", children: t.label }),
    /* @__PURE__ */ s.jsx("ul", { children: t.items.map((n) => /* @__PURE__ */ s.jsx("li", { children: /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "group w-[235px] whitespace-normal", children: /* @__PURE__ */ s.jsxs(
      ke,
      {
        href: n.href,
        scope: n.scope,
        className: "flex flex-row items-center gap-2",
        children: [
          n.label,
          /* @__PURE__ */ s.jsx("span", { className: "opacity-0 transition-opacity group-hover:opacity-100", children: "→" })
        ]
      }
    ) }) }, n.label)) })
  ] }, t.label)) }),
  e.seeAll && /* @__PURE__ */ s.jsx(s.Fragment, { children: /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "w-full text-center", children: /* @__PURE__ */ s.jsx(ke, { href: e.seeAll.href, scope: e.seeAll.scope, children: e.seeAll.label }) }) })
] }) }), Y0 = ({ items: e }) => /* @__PURE__ */ s.jsx(w0, { children: /* @__PURE__ */ s.jsx(y0, { children: /* @__PURE__ */ s.jsx("ul", { className: "flex flex-col xl:flex-row", children: e.map((t) => /* @__PURE__ */ s.jsx(S0, { children: t.subMenu ? /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
  /* @__PURE__ */ s.jsx(R0, { className: "px-5 py-1 text-button-big transition-all", children: t.label }),
  /* @__PURE__ */ s.jsx(K0, { content: t.subMenu })
] }) : /* @__PURE__ */ s.jsx(No, { asChild: !0, className: "px-5 py-1 text-button-big transition-all", children: /* @__PURE__ */ s.jsx(ke, { href: t.href, scope: t.scope, children: t.label }) }) }, t.label)) }) }) }), se = {
  microsite: {
    home: "/",
    faq: "/faq",
    pricing: "/#pricing",
    solutions: {
      home: "/solutions",
      byIndustry: {
        nonProfits: "/password-manager-for-non-profit",
        startups: "/password-manager-for-startups",
        agencies: "/password-manager-for-agency",
        techTeams: "/password-manager-for-tech-teams",
        saasTeams: "/password-manager-for-saas-teams",
        legal: "/password-manager-for-legal",
        education: "/password-manager-for-education"
      },
      switchFrom: {
        onePassword: "/passwd-vs-1password",
        lastPass: "/passwd-vs-lastpass",
        nordPass: "/passwd-vs-nordpass",
        bitwarden: "/passwd-vs-bitwarden",
        keeper: "/passwd-vs-keeper",
        drivePassword: "/passwd-vs-drivepassword",
        roboForm: "/passwd-vs-roboform"
      }
    },
    resources: {
      home: "/resources",
      browserExtension: "/resources/browser-extension",
      iosApp: "/resources/ios-app",
      androidApp: "/resources/android-app"
    }
  },
  docs: {
    home: "/docs"
  },
  app: {
    home: "https://app.passwd.team"
  }
}, X0 = () => {
  const { formatMessage: e } = Pt();
  return Kl(
    () => [
      {
        label: e({ id: "navbar.items.solutions.text" }),
        subMenu: {
          groups: [
            {
              label: e({
                id: "navbar.solutions.industries.title"
              }),
              items: [
                {
                  label: e({
                    id: "navbar.solutions.industries.agencies"
                  }),
                  href: se.microsite.solutions.byIndustry.agencies,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.nonProfits"
                  }),
                  href: se.microsite.solutions.byIndustry.nonProfits,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.startups"
                  }),
                  href: se.microsite.solutions.byIndustry.startups,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.techTeams"
                  }),
                  href: se.microsite.solutions.byIndustry.techTeams,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.education"
                  }),
                  href: se.microsite.solutions.byIndustry.education,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.legal"
                  }),
                  href: se.microsite.solutions.byIndustry.legal,
                  scope: ie.Microsite
                },
                {
                  label: e({
                    id: "navbar.solutions.industries.saasTeams"
                  }),
                  href: se.microsite.solutions.byIndustry.saasTeams,
                  scope: ie.Microsite
                }
              ]
            },
            {
              label: e({ id: "navbar.solutions.switchFrom.title" }),
              items: [
                {
                  label: "1Password",
                  href: se.microsite.solutions.switchFrom.onePassword,
                  scope: ie.Microsite
                },
                {
                  label: "Lastpass",
                  href: se.microsite.solutions.switchFrom.lastPass,
                  scope: ie.Microsite
                },
                {
                  label: "Nordpass",
                  href: se.microsite.solutions.switchFrom.nordPass,
                  scope: ie.Microsite
                },
                {
                  label: "Bitwarden",
                  href: se.microsite.solutions.switchFrom.bitwarden,
                  scope: ie.Microsite
                },
                {
                  label: "Keeper",
                  href: se.microsite.solutions.switchFrom.keeper,
                  scope: ie.Microsite
                },
                {
                  label: "Drive password",
                  href: se.microsite.solutions.switchFrom.drivePassword,
                  scope: ie.Microsite
                },
                {
                  label: "RoboForm",
                  href: se.microsite.solutions.switchFrom.roboForm,
                  scope: ie.Microsite
                }
              ]
            }
          ],
          seeAll: {
            label: e({
              id: "navbar.solutions.seeAll"
            }),
            href: se.microsite.solutions.home,
            scope: ie.Microsite
          }
        }
      },
      {
        label: e({ id: "navbar.items.resources.text" }),
        subMenu: {
          groups: [
            {
              label: e({ id: "navbar.resources.title" }),
              items: [
                {
                  label: e({ id: "navbar.resources.browserExtension" }),
                  href: se.microsite.resources.browserExtension,
                  scope: ie.Microsite
                },
                {
                  label: e({ id: "navbar.resources.iosApp" }),
                  href: se.microsite.resources.iosApp,
                  scope: ie.Microsite
                },
                {
                  label: e({ id: "navbar.resources.androidApp" }),
                  href: se.microsite.resources.androidApp,
                  scope: ie.Microsite
                }
              ]
            }
          ],
          seeAll: {
            label: e({ id: "navbar.resources.seeAll" }),
            href: se.microsite.resources.home,
            scope: ie.Microsite
          }
        }
      },
      {
        label: e({ id: "navbar.items.faq.text" }),
        href: se.microsite.faq,
        scope: ie.Microsite
      },
      {
        label: e({ id: "navbar.items.docs.text" }),
        href: se.docs.home,
        scope: ie.Docs
      },
      {
        label: e({ id: "navbar.items.pricing.text" }),
        href: se.microsite.pricing,
        scope: ie.Microsite
      }
    ],
    [e]
  );
}, yl = ({ additionalActions: e }) => /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col items-center gap-2 2xl:flex-row 2xl:gap-4", children: [
  /* @__PURE__ */ s.jsx(ls, { variant: "secondary", className: "h-10 min-h-10 w-full bg-transparent 2xl:w-fit", asChild: !0, children: /* @__PURE__ */ s.jsxs(ke, { scope: ie.App, href: se.app.home, children: [
    /* @__PURE__ */ s.jsx(Sc, { stroke: 1.5, className: "size-6" }),
    /* @__PURE__ */ s.jsx(Ge, { id: "navbar.login" })
  ] }) }),
  /* @__PURE__ */ s.jsx(ls, { className: "h-10 min-h-10 w-full 2xl:w-fit", asChild: !0, children: /* @__PURE__ */ s.jsx(ke, { scope: ie.Microsite, href: se.microsite.pricing, children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.tryButton" }) }) }),
  e && e.map((t, n) => /* @__PURE__ */ s.jsx("div", { className: "flex min-h-10 items-center", children: t }, n))
] }), q0 = ({ content: e }) => /* @__PURE__ */ s.jsxs($0, { children: [
  e.seeAll && /* @__PURE__ */ s.jsx(us, { children: /* @__PURE__ */ s.jsx(wn, { className: "text-button-small", buttonType: "sub-menu", asChild: !0, children: /* @__PURE__ */ s.jsx(ke, { href: e.seeAll.href, scope: e.seeAll.scope, children: e.seeAll.label }) }) }),
  e.groups.map((t) => /* @__PURE__ */ s.jsxs("div", { children: [
    /* @__PURE__ */ s.jsx("p", { className: "text-paragraph-extrasmall text-foreground-secondary py-2", children: t.label }),
    t.items.map((n) => /* @__PURE__ */ s.jsx(us, { children: /* @__PURE__ */ s.jsx(wn, { className: "text-button-small", buttonType: "sub-menu", asChild: !0, children: /* @__PURE__ */ s.jsx(ke, { href: n.href, scope: n.scope, children: n.label }) }) }, n.label))
  ] }, t.label))
] }), J0 = ({ items: e, navbarActions: t, languageAndCurrency: n }) => {
  const { formatMessage: o } = Pt(), r = hs("2xl"), [a, i] = $t(!1);
  return yn(() => {
    r || i(!1);
  }, [r]), /* @__PURE__ */ s.jsxs(T0, { open: a, onOpenChange: i, children: [
    /* @__PURE__ */ s.jsx("div", { className: "flex w-full items-center justify-end 2xl:hidden", children: /* @__PURE__ */ s.jsx(
      I0,
      {
        className: "cursor-pointer",
        title: o({ id: "navbar.open" }),
        onClick: () => i(!0),
        children: /* @__PURE__ */ s.jsx(wc, { className: "block size-6" })
      }
    ) }),
    /* @__PURE__ */ s.jsxs(L0, { side: "right", className: "rounded-l-4xl w-4/5 border-none px-4", children: [
      /* @__PURE__ */ s.jsxs(D0, { className: "pl-0 pt-8 active:outline-0", children: [
        /* @__PURE__ */ s.jsx(V0, { className: "sr-only", children: /* @__PURE__ */ s.jsx(Ge, { id: "navbar.menu" }) }),
        /* @__PURE__ */ s.jsx(ke, { href: se.microsite.home, className: "w-fit", children: /* @__PURE__ */ s.jsx(bl, { className: "h-6 w-[121px]" }) })
      ] }),
      /* @__PURE__ */ s.jsx(H0, { children: e.map(
        (l) => l.subMenu ? /* @__PURE__ */ s.jsx(dl, { className: "group/collapsible", children: /* @__PURE__ */ s.jsxs(cs, { children: [
          /* @__PURE__ */ s.jsx(fl, { asChild: !0, children: /* @__PURE__ */ s.jsx(wn, { children: l.label }) }),
          /* @__PURE__ */ s.jsx(
            pl,
            {
              className: O(
                "overflow-hidden duration-200 ease-in-out",
                "data-[state=open]:animate-collapsible-down",
                "data-[state=closed]:animate-collapsible-up"
              ),
              children: /* @__PURE__ */ s.jsx(q0, { content: l.subMenu })
            }
          )
        ] }) }, l.label) : /* @__PURE__ */ s.jsx(cs, { children: /* @__PURE__ */ s.jsx(wn, { asChild: !0, children: /* @__PURE__ */ s.jsx(ke, { href: l.href, scope: l.scope, onClick: () => i(!1), children: l.label }) }) }, l.label)
      ) }),
      /* @__PURE__ */ s.jsxs(F0, { children: [
        n && /* @__PURE__ */ s.jsx(Z0, { ...n }),
        /* @__PURE__ */ s.jsx(yl, { additionalActions: t })
      ] })
    ] })
  ] });
}, Q0 = "shadow-[0px_16px_50px_0px_rgba(0,0,255,0.07)]", q4 = ({
  navbarActions: e,
  forceBackground: t,
  LinkComponent: n = "a",
  scope: o,
  languageAndCurrency: r
}) => {
  const a = oc(), { formatMessage: i } = Pt(), l = X0();
  return /* @__PURE__ */ s.jsx(kc, { LinkComponent: n, scope: o, children: /* @__PURE__ */ s.jsx("div", { className: "sticky left-0 top-0 z-10 flex min-w-full items-center justify-center pt-4 2xl:pt-6", children: /* @__PURE__ */ s.jsxs(
    "nav",
    {
      className: O(
        "3xl:w-[calc(100%-160px)] flex w-[calc(100%-32px)] max-w-[1520px] items-center gap-6 rounded-full bg-white px-4 py-4 transition-all duration-300 2xl:pl-9",
        Q0,
        !a && !t && "2xl:bg-transparent 2xl:shadow-none"
      ),
      children: [
        /* @__PURE__ */ s.jsx(n, { href: se.microsite.home, title: i({ id: "navbar.home" }), children: /* @__PURE__ */ s.jsx(bl, { className: "block h-6 pl-2.5 2xl:h-8 2xl:pl-0" }) }),
        /* @__PURE__ */ s.jsxs("div", { className: "hidden 2xl:contents", children: [
          /* @__PURE__ */ s.jsx(Y0, { items: l }),
          /* @__PURE__ */ s.jsx("div", { className: "flex-1" }),
          /* @__PURE__ */ s.jsx(yl, { additionalActions: e }),
          r && /* @__PURE__ */ s.jsx(U0, { ...r })
        ] }),
        /* @__PURE__ */ s.jsx(
          J0,
          {
            items: l,
            navbarActions: e,
            languageAndCurrency: r
          }
        )
      ]
    }
  ) }) });
};
export {
  N4 as Accordion,
  k4 as AccordionContent,
  _4 as AccordionItem,
  A4 as AccordionTrigger,
  ls as Button,
  h0 as Card,
  T4 as CardAction,
  I4 as CardContent,
  C0 as CardDescription,
  b0 as CardFooter,
  v0 as CardHeader,
  g0 as CardHeaderImage,
  x0 as CardTitle,
  dl as Collapsible,
  pl as CollapsibleContent,
  fl as CollapsibleTrigger,
  W0 as CurrencySelect,
  Y4 as CustomerStoryCard,
  o4 as IconAlertTriangle,
  gs as IconArrowRight,
  r4 as IconBan,
  c4 as IconBrandApple,
  u4 as IconBrandCloudflare,
  d4 as IconBrandDropbox,
  f4 as IconBrandFigma,
  p4 as IconBrandGithub,
  m4 as IconBrandGoogle,
  h4 as IconBrandJira,
  g4 as IconBrandMastercard,
  v4 as IconBrandMicrosoft,
  x4 as IconBrandNetflix,
  C4 as IconBrandNotion,
  b4 as IconBrandPaypal,
  w4 as IconBrandSlack,
  y4 as IconBrandSpotify,
  cc as IconCheck,
  tt as IconChevronDown,
  fc as IconChevronUp,
  s4 as IconCircleCheck,
  a4 as IconCopy,
  gc as IconCurrencyDollar,
  xc as IconCurrencyEuro,
  i4 as IconFileTypePdf,
  l4 as IconInfoCircleFilled,
  S4 as IconMediaAp,
  E4 as IconMediaBusinessInsider,
  R4 as IconMediaTechradar,
  wc as IconMenuDeep,
  j4 as IconRecordApi,
  Sc as IconUser,
  vs as IconWorld,
  jc as IconX,
  Z0 as LanguageAndCurrencyCollapsible,
  wl as LanguageAndCurrencyFields,
  U0 as LanguageAndCurrencyPopover,
  h1 as Link,
  ke as LinkByScope,
  X4 as LinkCard,
  kc as LinkContextProvider,
  ie as LinkScope,
  Y0 as Menu,
  q4 as Navbar,
  w0 as NavigationMenu,
  j0 as NavigationMenuContent,
  O4 as NavigationMenuIndicator,
  S0 as NavigationMenuItem,
  No as NavigationMenuLink,
  y0 as NavigationMenuList,
  R0 as NavigationMenuTrigger,
  M0 as NavigationMenuViewport,
  bl as PasswdLogo,
  P0 as Popover,
  L4 as PopoverAnchor,
  _0 as PopoverContent,
  V4 as PopoverDescription,
  D4 as PopoverHeader,
  F4 as PopoverTitle,
  N0 as PopoverTrigger,
  ml as Select,
  gl as SelectContent,
  H4 as SelectGroup,
  vl as SelectItem,
  B4 as SelectLabel,
  k0 as SelectScrollDownButton,
  A0 as SelectScrollUpButton,
  z4 as SelectSeparator,
  hl as SelectTrigger,
  $4 as SelectValue,
  T0 as Sheet,
  W4 as SheetClose,
  L0 as SheetContent,
  G4 as SheetDescription,
  F0 as SheetFooter,
  D0 as SheetHeader,
  V0 as SheetTitle,
  I0 as SheetTrigger,
  H0 as SidebarMenu,
  wn as SidebarMenuButton,
  cs as SidebarMenuItem,
  $0 as SidebarMenuSub,
  us as SidebarMenuSubItem,
  Z4 as Toggle,
  U4 as ToggleGroup,
  K4 as ToggleGroupItem,
  m1 as Typography,
  m0 as buttonVariants,
  O as cn,
  E0 as navigationMenuTriggerStyle,
  xl as toggleVariants,
  hs as useBreakpoint,
  oc as useIsScrolled,
  Ac as useLinkContext
};
